import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Achievement = {
  __typename?: 'Achievement';
  /** Background color of the Achievement */
  background_color?: Maybe<Scalars['String']['output']>;
  /** Border color of the Achievement */
  border_color?: Maybe<Scalars['String']['output']>;
  /** Description of the Achievement */
  description?: Maybe<Scalars['String']['output']>;
  /** Image URL of the Achievement */
  image?: Maybe<Scalars['String']['output']>;
  /** Label of the Configuration */
  label?: Maybe<Scalars['String']['output']>;
  /** Name of the Achievement */
  name?: Maybe<Scalars['String']['output']>;
  /** The target link of product achievement. */
  target_link?: Maybe<Scalars['String']['output']>;
  /** Text color of the Achievement */
  text_color?: Maybe<Scalars['String']['output']>;
};

export type AddBundleProductsToCartInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<BundleProductCartItemInput>>;
};

export type AddBundleProductsToCartOutput = {
  __typename?: 'AddBundleProductsToCartOutput';
  cart: Cart;
};

export type AddConfigurableProductsToCartInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<ConfigurableProductCartItemInput>>;
};

export type AddConfigurableProductsToCartOutput = {
  __typename?: 'AddConfigurableProductsToCartOutput';
  cart: Cart;
};

export type AddDownloadableProductsToCartInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<DownloadableProductCartItemInput>>;
};

export type AddDownloadableProductsToCartOutput = {
  __typename?: 'AddDownloadableProductsToCartOutput';
  cart: Cart;
};

export type AddGiftsToCartInput = {
  /** The mask id of cart. */
  cart_id: Scalars['String']['input'];
  /** The id of quote item. */
  cart_item_id: Scalars['Int']['input'];
  /** The picked gift input. */
  picked_gifts?: InputMaybe<Array<InputMaybe<PickedGiftInput>>>;
};

export type AddGiftsToCartOutput = {
  __typename?: 'AddGiftsToCartOutput';
  cart: Cart;
};

export type AddProductToWishlistInput = {
  product_id: Scalars['Int']['input'];
};

export type AddSimpleProductsToCartInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<SimpleProductCartItemInput>>;
};

export type AddSimpleProductsToCartOutput = {
  __typename?: 'AddSimpleProductsToCartOutput';
  cart: Cart;
};

export type AddToCartContentInput = {
  product_id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type AddToCartErrorInternalEventInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  product_id?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type AddToCartErrorInternalEventRequest = {
  context?: InputMaybe<EventContextInput>;
  data?: InputMaybe<AddToCartErrorInternalEventInput>;
};

export type AddToCartEventInput = {
  cart_info?: InputMaybe<CartInfoInput>;
  user: UserDataInput;
};

export type AddToCartTrackingEventRequest = {
  context?: InputMaybe<EventContextInput>;
  data?: InputMaybe<AddToCartEventInput>;
};

export type AddVirtualProductsToCartInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<VirtualProductCartItemInput>>;
};

export type AddVirtualProductsToCartOutput = {
  __typename?: 'AddVirtualProductsToCartOutput';
  cart: Cart;
};

export type AdditionalDataAttribute = {
  __typename?: 'AdditionalDataAttribute';
  /** The attribute code. */
  code?: Maybe<Scalars['String']['output']>;
  /** The attribute label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The attribute value. */
  value?: Maybe<Scalars['String']['output']>;
};

/** The list of address types */
export enum AddressTypeEnum {
  Home = 'home',
  Office = 'office'
}

export type AdminAnswered = {
  __typename?: 'AdminAnswered';
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  like_count?: Maybe<Scalars['Int']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent_id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  total_satisfied?: Maybe<Scalars['Int']['output']>;
};

/** A bucket that contains information for each filterable option (such as price, category ID, and custom attributes). */
export type Aggregation = {
  __typename?: 'Aggregation';
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars['String']['output'];
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The aggregation display name. */
  label?: Maybe<Scalars['String']['output']>;
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<AggregationOption>>>;
};

export type AggregationOption = AggregationOptionInterface & {
  __typename?: 'AggregationOption';
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The id of aggregation option. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Aggregation option display label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output'];
};

export type AggregationOptionInterface = {
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** The id of aggregation option. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Aggregation option display label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output'];
};

export type Answer = {
  __typename?: 'Answer';
  adminId: Scalars['Int']['output'];
  adminName: Scalars['String']['output'];
  answer: Scalars['String']['output'];
  questionId: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceId?: Maybe<Scalars['Int']['output']>;
};

export type AnswerRequest = {
  content: Scalars['String']['input'];
  parent_id: Scalars['Int']['input'];
  question_id: Scalars['Int']['input'];
};

export type ApiErrorInternalEventInput = {
  api_path?: InputMaybe<Scalars['String']['input']>;
  error_message?: InputMaybe<Scalars['String']['input']>;
  error_name?: InputMaybe<Scalars['String']['input']>;
  http_code?: InputMaybe<Scalars['Int']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type ApiErrorInternalEventRequest = {
  context?: InputMaybe<EventContextInput>;
  data?: InputMaybe<ApiErrorInternalEventInput>;
};

export type AppBannerConfig = {
  __typename?: 'AppBannerConfig';
  content: Scalars['String']['output'];
  image_url: Scalars['String']['output'];
};

export type AppConfiguration = {
  __typename?: 'AppConfiguration';
  banner_config?: Maybe<AppBannerConfig>;
  footer_config?: Maybe<FooterConfig>;
  share_channel_configs?: Maybe<ShareChannelGroupResponse>;
};

export type AppliedCoupon = {
  __typename?: 'AppliedCoupon';
  code: Scalars['String']['output'];
};

export type ApplyCouponToCartInput = {
  cart_id: Scalars['String']['input'];
  coupon_code: Scalars['String']['input'];
};

export type ApplyCouponToCartOutput = {
  __typename?: 'ApplyCouponToCartOutput';
  cart: Cart;
};

export type ApplyKicoinsInput = {
  cart_id: Scalars['String']['input'];
};

export type ApplyKicoinsOutput = {
  __typename?: 'ApplyKicoinsOutput';
  cart: Cart;
};

/** Attribute contains the attribute_type of the specified attribute_code and entity_type */
export type Attribute = {
  __typename?: 'Attribute';
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /** Attribute options list. */
  attribute_options?: Maybe<Array<Maybe<AttributeOption>>>;
  /** The data type of the attribute */
  attribute_type?: Maybe<Scalars['String']['output']>;
  /** The type of entity that defines the attribute */
  entity_type?: Maybe<Scalars['String']['output']>;
  /** The frontend input type of the attribute */
  input_type?: Maybe<Scalars['String']['output']>;
};

/** AttributeInput specifies the attribute_code and entity_type to search */
export type AttributeInput = {
  /** The unique identifier for an attribute code. This value should be in lowercase letters without spaces. */
  attribute_code?: InputMaybe<Scalars['String']['input']>;
  /** The type of entity that defines the attribute */
  entity_type?: InputMaybe<Scalars['String']['input']>;
};

/** Attribute option. */
export type AttributeOption = {
  __typename?: 'AttributeOption';
  /** Attribute option label. */
  label?: Maybe<Scalars['String']['output']>;
  /** Swatch data for Attribute option */
  swatch_data?: Maybe<SwatchDataInterface>;
  /** Attribute option value. */
  value?: Maybe<Scalars['String']['output']>;
};

export type AuthErrorInternalEventInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type AuthErrorInternalEventRequest = {
  context?: InputMaybe<EventContextInput>;
  data?: InputMaybe<AuthErrorInternalEventInput>;
};

export type AvailableGifts = {
  __typename?: 'AvailableGifts';
  cart_item_id?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The rule info. */
  rule?: Maybe<Rule>;
  rule_id?: Maybe<Scalars['Int']['output']>;
};

export type AvailableGiftsCart = {
  __typename?: 'AvailableGiftsCart';
  items?: Maybe<Array<Maybe<AvailableGifts>>>;
};

/** Available next statuses and sorting direction. */
export type AvailableOrderHistoryStatuses = {
  __typename?: 'AvailableOrderHistoryStatuses';
  direction: SortDirection;
  items: Array<OrderStatus>;
};

export type AvailablePaymentMethod = {
  __typename?: 'AvailablePaymentMethod';
  /** The payment method code */
  code: Scalars['String']['output'];
  /** The payment method title. */
  title: Scalars['String']['output'];
};

export type AvailableRules = {
  __typename?: 'AvailableRules';
  /** An array rule data. */
  items?: Maybe<Array<Maybe<Rule>>>;
  /** The total count of available rules. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type AvailableShippingMethod = {
  __typename?: 'AvailableShippingMethod';
  amount: Money;
  available: Scalars['Boolean']['output'];
  /** @deprecated The field should not be used on the storefront */
  base_amount?: Maybe<Money>;
  carrier_code: Scalars['String']['output'];
  carrier_title: Scalars['String']['output'];
  error_message?: Maybe<Scalars['String']['output']>;
  /** Could be null if method is not available */
  method_code?: Maybe<Scalars['String']['output']>;
  /** Could be null if method is not available */
  method_title?: Maybe<Scalars['String']['output']>;
  price_excl_tax: Money;
  price_incl_tax: Money;
};

/** Banners information for homepage */
export type Banner = {
  __typename?: 'Banner';
  /** App image url */
  app_image_url?: Maybe<Scalars['String']['output']>;
  /** background color */
  background_color?: Maybe<Scalars['String']['output']>;
  /** Banner ID */
  banner_id?: Maybe<Scalars['Int']['output']>;
  /** Image */
  image?: Maybe<Scalars['String']['output']>;
  /** Image app */
  image_app?: Maybe<Scalars['String']['output']>;
  /** Image Mobile */
  image_mobile?: Maybe<Scalars['String']['output']>;
  /** Banner name */
  name?: Maybe<Scalars['String']['output']>;
  /** Allow open new tab after click */
  newtab?: Maybe<Scalars['Int']['output']>;
  /** Position */
  position?: Maybe<Scalars['String']['output']>;
  /** URL banner */
  url_banner?: Maybe<Scalars['String']['output']>;
};

export type BannerConfig = {
  __typename?: 'BannerConfig';
  /** The content of page. */
  content?: Maybe<Scalars['String']['output']>;
  /** The banner image. */
  image?: Maybe<Scalars['String']['output']>;
};

/** Main banner information */
export type BannerItems = {
  __typename?: 'BannerItems';
  /** An array of banners */
  items?: Maybe<Array<Maybe<Banner>>>;
  /** The layout of banners. */
  layout?: Maybe<BannerLayoutData>;
};

/** The layout data. */
export type BannerLayoutData = {
  __typename?: 'BannerLayoutData';
  /** The label of layout. */
  label?: Maybe<Scalars['String']['output']>;
  /** The value of layout. */
  value?: Maybe<Scalars['String']['output']>;
};

export enum BannerPageType {
  EmptyCart = 'EMPTY_CART',
  OrderFailure = 'ORDER_FAILURE',
  OrderSuccess = 'ORDER_SUCCESS',
  ReferralFriend = 'REFERRAL_FRIEND'
}

/** Banners information */
export type Banners = {
  __typename?: 'Banners';
  /** An array of banners. */
  items?: Maybe<Array<Maybe<Banner>>>;
  /** The layout of banners. */
  layout?: Maybe<LayoutData>;
};

export type BeginAddToCartInternalEventInput = {
  product_id?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  session_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type BeginAddToCartInternalEventRequest = {
  context?: InputMaybe<EventContextInput>;
  data?: InputMaybe<BeginAddToCartInternalEventInput>;
};

export type BillingAddressInput = {
  address?: InputMaybe<CartAddressInput>;
  customer_address_id?: InputMaybe<Scalars['Int']['input']>;
  /** The invoice company address of customer. */
  invoice_company_address?: InputMaybe<Scalars['String']['input']>;
  /** The invoice company name of customer. */
  invoice_company_name?: InputMaybe<Scalars['String']['input']>;
  /** The invoice vat id of customer. */
  invoice_vat_id?: InputMaybe<Scalars['String']['input']>;
  /** Set billing address same as shipping */
  same_as_shipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** Deprecated: use `same_as_shipping` field instead */
  use_for_shipping?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingCartAddress = CartAddressInterface & {
  __typename?: 'BillingCartAddress';
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: CartAddressCountry;
  /** @deprecated The field is used only in shipping address */
  customer_notes?: Maybe<Scalars['String']['output']>;
  firstname: Scalars['String']['output'];
  /** The invoice company address of customer. */
  invoice_company_address?: Maybe<Scalars['String']['output']>;
  /** The invoice company name of customer. */
  invoice_company_name?: Maybe<Scalars['String']['output']>;
  /** The invoice vat id of customer. */
  invoice_vat_id?: Maybe<Scalars['String']['output']>;
  lastname: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CartAddressRegion>;
  street: Array<Maybe<Scalars['String']['output']>>;
  telephone: Scalars['String']['output'];
};

/** The Products object is the top-level object returned in a product list. */
export type BlockProducts = {
  __typename?: 'BlockProducts';
  /** An array of products that match the specified query data */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
};

export enum BlockTypeEnum {
  Bestseller = 'BESTSELLER',
  Highlight = 'HIGHLIGHT',
  Interested = 'INTERESTED',
  NewArrival = 'NEW_ARRIVAL'
}

export type BraintreeCcVaultInput = {
  device_data?: InputMaybe<Scalars['String']['input']>;
  public_hash: Scalars['String']['input'];
};

export type BraintreeInput = {
  /** Contains a fingerprint provided by Braintree JS SDK and should be sent with sale transaction details to the Braintree payment gateway. Should be specified only in a case if Kount (advanced fraud protection) is enabled for Braintree payment integration. */
  device_data?: InputMaybe<Scalars['String']['input']>;
  /** States whether an entered by a customer credit/debit card should be tokenized for later usage. Required only if Vault is enabled for Braintree payment integration. */
  is_active_payment_token_enabler: Scalars['Boolean']['input'];
  /** The one-time payment token generated by Braintree payment gateway based on card details. Required field to make sale transaction. */
  payment_method_nonce: Scalars['String']['input'];
};

export type BrandLayout = {
  __typename?: 'BrandLayout';
  /** The banner image. */
  banner_image?: Maybe<Scalars['String']['output']>;
  /** The banner link. */
  banner_link?: Maybe<Scalars['String']['output']>;
  /** The border type for each brand. */
  border_type?: Maybe<Scalars['String']['output']>;
  /** The layout of brand. */
  layout?: Maybe<LayoutData>;
  /** The limit quantity display on block. */
  limit_qty?: Maybe<Scalars['Int']['output']>;
  /** The row qty display on block. */
  row_qty?: Maybe<Scalars['Int']['output']>;
};

/** The brands for category. */
export type Brands = {
  __typename?: 'Brands';
  /** The list of brands. */
  items?: Maybe<Array<Maybe<HighlightBrand>>>;
  /** The page size of brands. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of brands. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Breadcrumb item. */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  /** Category ID. */
  category_id?: Maybe<Scalars['Int']['output']>;
  /** Category level. */
  category_level?: Maybe<Scalars['Int']['output']>;
  /** Category name. */
  category_name?: Maybe<Scalars['String']['output']>;
  /** Category URL key. */
  category_url_key?: Maybe<Scalars['String']['output']>;
  /** Category URL path. */
  category_url_path?: Maybe<Scalars['String']['output']>;
};

export type BssPopup = {
  __typename?: 'BssPopup';
  /** Time to show popup after page load. The value of X equals (seconds) corresponds to event_display = 1 - After customer spend X seconds on page. */
  after_load?: Maybe<Scalars['Int']['output']>;
  /** The value of X equals (%) corresponds to event_display = 2 - After customers scroll page by X percent. */
  after_scroll?: Maybe<Scalars['Int']['output']>;
  close_outside?: Maybe<Scalars['Int']['output']>;
  /** The cookie expires (minutes) of popup. */
  cookie_expires?: Maybe<Scalars['Int']['output']>;
  /** The customer group of popup. */
  customer_group?: Maybe<Scalars['String']['output']>;
  /** The start date to show popup. */
  display_from?: Maybe<Scalars['String']['output']>;
  /** The end date to show popup. */
  display_to?: Maybe<Scalars['String']['output']>;
  /** The Display Animation of popup. */
  effect_display?: Maybe<Scalars['Int']['output']>;
  /** The rule to show popup. */
  event_display?: Maybe<Scalars['Int']['output']>;
  exclude_category?: Maybe<Scalars['String']['output']>;
  exclude_product?: Maybe<Scalars['String']['output']>;
  /** The display frequency of popup. */
  frequently?: Maybe<Scalars['Int']['output']>;
  /** Auto close popup after X seconds. */
  hide_after?: Maybe<Scalars['Int']['output']>;
  /** The id of popup. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Return an array layouts page to show popup. */
  layouts?: Maybe<Array<Maybe<Layout>>>;
  page_display?: Maybe<Scalars['String']['output']>;
  /** The value of X equals corresponds to event_display = 3 - After customer view X pages. */
  page_view?: Maybe<Scalars['Int']['output']>;
  /** The display frequency of popup. */
  popup_content?: Maybe<Scalars['String']['output']>;
  /** The css of popup. */
  popup_css?: Maybe<Scalars['String']['output']>;
  /** The name of popup. */
  popup_name?: Maybe<Scalars['String']['output']>;
  /** The url of popup. */
  popup_url?: Maybe<Scalars['String']['output']>;
  /** The position of popup. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The priority of popup. */
  priority?: Maybe<Scalars['Int']['output']>;
  /** The status of popup. */
  status?: Maybe<Scalars['Int']['output']>;
  /** The store view of popup. */
  storeview?: Maybe<Scalars['String']['output']>;
};

export type BssPopups = {
  __typename?: 'BssPopups';
  items?: Maybe<Array<Maybe<BssPopup>>>;
};

export type BundleCartItem = CartItemInterface & {
  __typename?: 'BundleCartItem';
  bundle_options: Array<Maybe<SelectedBundleOption>>;
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

/** BundleItem defines an individual item in a bundle product. */
export type BundleItem = {
  __typename?: 'BundleItem';
  /** An ID assigned to each type of item in a bundle product. */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** An array of additional options for this bundle item. */
  options?: Maybe<Array<Maybe<BundleItemOption>>>;
  /** he relative position of this item compared to the other bundle items. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the item must be included in the bundle. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The SKU of the bundle product. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The display name of the item. */
  title?: Maybe<Scalars['String']['output']>;
  /** The input type that the customer uses to select the item. Examples include radio button and checkbox. */
  type?: Maybe<Scalars['String']['output']>;
};

/** BundleItemOption defines characteristics and options for a specific bundle item. */
export type BundleItemOption = {
  __typename?: 'BundleItemOption';
  /** Indicates whether the customer can change the number of items for this option. */
  can_change_quantity?: Maybe<Scalars['Boolean']['output']>;
  /** The ID assigned to the bundled item option. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether this option is the default option. */
  is_default?: Maybe<Scalars['Boolean']['output']>;
  /** The text that identifies the bundled item option. */
  label?: Maybe<Scalars['String']['output']>;
  /** When a bundle item contains multiple options, the relative position of this option compared to the other options. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The price of the selected option. */
  price?: Maybe<Scalars['Float']['output']>;
  /** One of FIXED, PERCENT, or DYNAMIC. */
  price_type?: Maybe<PriceTypeEnum>;
  /** Contains details about this product option. */
  product?: Maybe<ProductInterface>;
  /**
   * Indicates the quantity of this specific bundle item.
   * @deprecated The `qty` is deprecated. Use `quantity` instead.
   */
  qty?: Maybe<Scalars['Float']['output']>;
  /** Indicates the quantity of this specific bundle item. */
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type BundleOptionInput = {
  id: Scalars['Int']['input'];
  quantity: Scalars['Float']['input'];
  value: Array<InputMaybe<Scalars['String']['input']>>;
};

/** BundleProduct defines basic features of a bundle product and contains multiple BundleItems. */
export type BundleProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & {
  __typename?: 'BundleProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the bundle product has a dynamic price. */
  dynamic_price?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the bundle product has a dynamic SK. */
  dynamic_sku?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the bundle product has a dynamically calculated weight. */
  dynamic_weight?: Maybe<Scalars['Boolean']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  /** An array containing information about individual bundle items. */
  items?: Maybe<Array<Maybe<BundleItem>>>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** One of PRICE_RANGE or AS_LOW_AS. */
  price_view?: Maybe<PriceViewEnum>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether to ship bundle items together or individually. */
  ship_bundle_items?: Maybe<ShipBundleItemsEnum>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

export type BundleProductCartItemInput = {
  bundle_options: Array<InputMaybe<BundleOptionInput>>;
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  data: CartItemInput;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CancelOrderInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  order_number: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type Cart = {
  __typename?: 'Cart';
  /**
   * An array of coupons that have been applied to the cart
   * @deprecated Use applied_coupons instead
   */
  applied_coupon?: Maybe<AppliedCoupon>;
  /** An array of `AppliedCoupon` objects. Each object contains the `code` text attribute, which specifies the coupon code */
  applied_coupons?: Maybe<Array<Maybe<AppliedCoupon>>>;
  /** Available payment methods */
  available_payment_methods?: Maybe<Array<Maybe<AvailablePaymentMethod>>>;
  billing_address?: Maybe<BillingCartAddress>;
  /** Returns information about discount kicoins */
  discount_kicoins?: Maybe<DiscountKicoins>;
  email?: Maybe<Scalars['String']['output']>;
  /** The ID of the cart. */
  id: Scalars['ID']['output'];
  is_virtual: Scalars['Boolean']['output'];
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
  prices?: Maybe<CartPrices>;
  selected_payment_method?: Maybe<SelectedPaymentMethod>;
  shipping_addresses: Array<Maybe<ShippingCartAddress>>;
  total_quantity: Scalars['Float']['output'];
};

export type CartAddressCountry = {
  __typename?: 'CartAddressCountry';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CartAddressInput = {
  city: Scalars['String']['input'];
  company?: InputMaybe<Scalars['String']['input']>;
  country_code: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  district_id?: InputMaybe<Scalars['Int']['input']>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  save_in_address_book?: InputMaybe<Scalars['Boolean']['input']>;
  street: Array<InputMaybe<Scalars['String']['input']>>;
  telephone: Scalars['String']['input'];
  ward?: InputMaybe<Scalars['String']['input']>;
  ward_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CartAddressInterface = {
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: CartAddressCountry;
  firstname: Scalars['String']['output'];
  lastname: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CartAddressRegion>;
  street: Array<Maybe<Scalars['String']['output']>>;
  telephone: Scalars['String']['output'];
};

export type CartAddressRegion = {
  __typename?: 'CartAddressRegion';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type CartDiscount = {
  __typename?: 'CartDiscount';
  amount: Money;
  label: Array<Maybe<Scalars['String']['output']>>;
};

export type CartInfoInput = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<Array<AddToCartContentInput>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type CartItemInput = {
  quantity: Scalars['Float']['input'];
  sku: Scalars['String']['input'];
};

export type CartItemInterface = {
  id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

export type CartItemMeta = {
  __typename?: 'CartItemMeta';
  /** Serialized additional data or custom options associated with this item. */
  additional_data?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of applied sales rule IDs for discounts. */
  applied_rule_ids?: Maybe<Scalars['String']['output']>;
  /** The discount amount applied in the base currency. */
  base_discount_amount?: Maybe<Scalars['Float']['output']>;
  /** The price of the product in the base currency. */
  base_price?: Maybe<Scalars['Float']['output']>;
  /** The price including tax in base currency. */
  base_price_incl_tax?: Maybe<Scalars['Float']['output']>;
  /** The total (price × qty) excluding discounts and taxes in the base currency. */
  base_row_total?: Maybe<Scalars['Float']['output']>;
  /** The total row amount including tax in base currency. */
  base_row_total_incl_tax?: Maybe<Scalars['Float']['output']>;
  /** Custom price manually set for this item (e.g., via admin or promo rule). */
  custom_price?: Maybe<Scalars['Float']['output']>;
  /** The detailed description of the product at the time of adding to cart. */
  description?: Maybe<Scalars['String']['output']>;
  /** The discount amount applied in the quote currency. */
  discount_amount?: Maybe<Scalars['Float']['output']>;
  /** The discount percentage applied to this item. */
  discount_percent?: Maybe<Scalars['Float']['output']>;
  /** Cart item ID. */
  id?: Maybe<Scalars['String']['output']>;
  /** Indicates if the quantity for this product can be a decimal value (used for weight-based products). */
  is_qty_decimal?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether this item is virtual (non-shippable). */
  is_virtual?: Maybe<Scalars['Int']['output']>;
  /** The product name displayed in the cart. */
  name?: Maybe<Scalars['String']['output']>;
  /** Flag to indicate that discounts are disabled for this item. */
  no_discount?: Maybe<Scalars['Int']['output']>;
  /** Original custom price set before any recalculation or override. */
  original_custom_price?: Maybe<Scalars['Float']['output']>;
  /** Parent item ID for child items. */
  parent_item_id?: Maybe<Scalars['Int']['output']>;
  /** The price of the product in the quote currency. */
  price?: Maybe<Scalars['Float']['output']>;
  /** The price including tax in quote currency. */
  price_incl_tax?: Maybe<Scalars['Float']['output']>;
  /** Product ID. */
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The product type (e.g., simple, configurable, bundle). */
  product_type?: Maybe<Scalars['String']['output']>;
  /** Quantity of this product in the cart. */
  qty?: Maybe<Scalars['Float']['output']>;
  /** The total (price × qty) excluding discounts and taxes in the quote currency. */
  row_total?: Maybe<Scalars['Float']['output']>;
  /** The total row amount including tax in quote currency. */
  row_total_incl_tax?: Maybe<Scalars['Float']['output']>;
  /** The total after discount but before tax. */
  row_total_with_discount?: Maybe<Scalars['Float']['output']>;
  /** Total weight for this item row (weight × qty). */
  row_weight?: Maybe<Scalars['Float']['output']>;
  /** The SKU of the product. */
  sku?: Maybe<Scalars['String']['output']>;
  /** Weight of a single unit of this product. */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type CartItemPrices = {
  __typename?: 'CartItemPrices';
  /** An array of discounts to be applied to the cart item */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  price: Money;
  row_total: Money;
  row_total_including_tax: Money;
  /** The total of all discounts applied to the item */
  total_item_discount?: Maybe<Money>;
};

/** Deprecated: `cart_items` field of `ShippingCartAddress` returns now  `CartItemInterface` instead of `CartItemQuantity` */
export type CartItemQuantity = {
  __typename?: 'CartItemQuantity';
  /** @deprecated `cart_items` field of `ShippingCartAddress` returns now `CartItemInterface` instead of `CartItemQuantity` */
  cart_item_id: Scalars['Int']['output'];
  /** @deprecated `cart_items` field of `ShippingCartAddress` returns now `CartItemInterface` instead of `CartItemQuantity` */
  quantity: Scalars['Float']['output'];
};

export type CartItemSelectedOptionValuePrice = {
  __typename?: 'CartItemSelectedOptionValuePrice';
  type: PriceTypeEnum;
  units: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type CartItemUpdateInput = {
  cart_item_id: Scalars['Int']['input'];
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
};

export type CartMeta = {
  __typename?: 'CartMeta';
  /** A comma-separated list of applied sales rule IDs for discounts and promotions. */
  applied_rule_ids?: Maybe<Scalars['String']['output']>;
  /** The base currency code used for the website. */
  base_currency_code?: Maybe<Scalars['String']['output']>;
  /** The total amount payable for the cart in the base currency, including taxes and discounts. */
  base_grand_total?: Maybe<Scalars['Float']['output']>;
  /** The subtotal of the cart in the base currency, before taxes and discounts. */
  base_subtotal?: Maybe<Scalars['Float']['output']>;
  /** The subtotal of the cart in the base currency, including discounts but before taxes. */
  base_subtotal_with_discount?: Maybe<Scalars['Float']['output']>;
  /** Indicates whether order confirmation should be made via phone (1 = yes, 0 = no). */
  confirm_by_phone?: Maybe<Scalars['Int']['output']>;
  /** The coupon code applied to the cart, if any. */
  coupon_code?: Maybe<Scalars['String']['output']>;
  /** The date of birth of the customer, if available. */
  customer_dob?: Maybe<Scalars['String']['output']>;
  /** The email address of the customer associated with the cart. */
  customer_email?: Maybe<Scalars['String']['output']>;
  /** The first name of the customer. */
  customer_firstname?: Maybe<Scalars['String']['output']>;
  /** The gender of the customer, if provided. */
  customer_gender?: Maybe<Scalars['String']['output']>;
  /** The last name of the customer. */
  customer_lastname?: Maybe<Scalars['String']['output']>;
  /** The middle name of the customer. */
  customer_middlename?: Maybe<Scalars['String']['output']>;
  /** An optional note left by the customer for the order. */
  customer_note?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the customer should be notified about the note (1 = yes, 0 = no). */
  customer_note_notify?: Maybe<Scalars['Int']['output']>;
  /** The prefix (e.g., Mr., Ms.) of the customer name. */
  customer_prefix?: Maybe<Scalars['String']['output']>;
  /** The suffix (e.g., Jr., Sr.) of the customer name. */
  customer_suffix?: Maybe<Scalars['String']['output']>;
  /** The tax or VAT identification number of the customer. */
  customer_taxvat?: Maybe<Scalars['String']['output']>;
  /** The grand total of the cart. */
  grand_total?: Maybe<Scalars['Float']['output']>;
  /** The ID of the cart. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Indicates whether the cart has been modified since the last calculation (1 = yes, 0 = no). */
  is_changed?: Maybe<Scalars['Int']['output']>;
  /** Returns an array of cart items. */
  items?: Maybe<Array<Maybe<CartItemMeta>>>;
  /** The number of items in the cart. */
  items_count?: Maybe<Scalars['Int']['output']>;
  /** The total quantity of items in the cart. */
  items_qty?: Maybe<Scalars['Int']['output']>;
  /** The currency code used for the current cart/quote. */
  quote_currency_code?: Maybe<Scalars['String']['output']>;
  /** An optional note or instruction related to shipping for this cart. */
  shipping_note?: Maybe<Scalars['String']['output']>;
  /** The currency code used by the store view. */
  store_currency_code?: Maybe<Scalars['String']['output']>;
  /** The conversion rate from store currency to base currency. */
  store_to_base_rate?: Maybe<Scalars['Float']['output']>;
  /** The conversion rate from store currency to quote currency. */
  store_to_quote_rate?: Maybe<Scalars['Float']['output']>;
  /** The subtotal of the cart in the quote currency, before taxes and discounts. */
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** The subtotal of the cart in the quote currency, including discounts but before taxes. */
  subtotal_with_discount?: Maybe<Scalars['Float']['output']>;
};

export type CartPrices = {
  __typename?: 'CartPrices';
  applied_taxes?: Maybe<Array<Maybe<CartTaxItem>>>;
  /** @deprecated Use discounts instead  */
  discount?: Maybe<CartDiscount>;
  /** An array of applied discounts */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  grand_total?: Maybe<Money>;
  subtotal_excluding_tax?: Maybe<Money>;
  subtotal_including_tax?: Maybe<Money>;
  subtotal_with_discount_excluding_tax?: Maybe<Money>;
};

export type CartTaxItem = {
  __typename?: 'CartTaxItem';
  amount: Money;
  label: Scalars['String']['output'];
};

/** Data detect from magento catalog-products-list widget */
export type CatalogProductsListWidget = ContentFragmentDataInterface & {
  __typename?: 'CatalogProductsListWidget';
  /** Cache key for App view more button */
  cache_key?: Maybe<Scalars['String']['output']>;
  /** Config of widget */
  config?: Maybe<ProductListConfig>;
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Product skus list */
  skus: Array<Scalars['String']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export type CatalogStatusMessageResponse = {
  __typename?: 'CatalogStatusMessageResponse';
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type CategoryBanners = {
  __typename?: 'CategoryBanners';
  /** An array of banners */
  items?: Maybe<Array<Maybe<Banner>>>;
  /** The layout of banners. */
  layout?: Maybe<BannerLayoutData>;
};

/** CategoryFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type CategoryFilterInput = {
  /** Filter by category ID that uniquely identifies the category. */
  ids?: InputMaybe<FilterEqualTypeInput>;
  /** Filter by the display name of the category. */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Filter by the part of the URL that identifies the category */
  url_key?: InputMaybe<FilterEqualTypeInput>;
};

/** The Products object is the top-level object returned in a product list. */
export type CategoryHighlightProducts = {
  __typename?: 'CategoryHighlightProducts';
  /** An array of products that match the specified query data */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
};

/** CategoryInterface contains the full set of attributes that can be returned in a category search. */
export type CategoryInterface = {
  /** Achievement information of the Category */
  achievement?: Maybe<Achievement>;
  amtoolkit_robots?: Maybe<Scalars['String']['output']>;
  author_email?: Maybe<Scalars['String']['output']>;
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  background_app_icon?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  banner_active_from?: Maybe<Scalars['String']['output']>;
  banner_active_to?: Maybe<Scalars['String']['output']>;
  banner_from_date?: Maybe<Scalars['String']['output']>;
  banner_head?: Maybe<Scalars['String']['output']>;
  banner_menu_image?: Maybe<Scalars['String']['output']>;
  banner_mobile_image?: Maybe<Scalars['String']['output']>;
  banner_to_date?: Maybe<Scalars['String']['output']>;
  banner_url?: Maybe<Scalars['String']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  category_image_for_app?: Maybe<Scalars['String']['output']>;
  category_tags?: Maybe<Scalars['String']['output']>;
  child_tags?: Maybe<Scalars['String']['output']>;
  children_count?: Maybe<Scalars['String']['output']>;
  /** Category CMS Block. */
  cms_block?: Maybe<CmsBlock>;
  /** Timestamp indicating when the category was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  custom_layout_update_file?: Maybe<Scalars['String']['output']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']['output']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']['output']>;
  display_mode?: Maybe<Scalars['String']['output']>;
  featured_app_icon?: Maybe<Scalars['String']['output']>;
  featured_icon?: Maybe<Scalars['String']['output']>;
  filter_price_range?: Maybe<Scalars['Float']['output']>;
  first_post?: Maybe<Scalars['String']['output']>;
  fourth_post?: Maybe<Scalars['String']['output']>;
  highlight_post?: Maybe<Scalars['String']['output']>;
  highlight_product_app_qty?: Maybe<Scalars['String']['output']>;
  highlight_product_app_sku?: Maybe<Scalars['String']['output']>;
  highlight_product_app_type?: Maybe<Scalars['String']['output']>;
  /** An ID that uniquely identifies the category. */
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  image1?: Maybe<Scalars['String']['output']>;
  image_desktop_active_from?: Maybe<Scalars['String']['output']>;
  image_desktop_active_to?: Maybe<Scalars['String']['output']>;
  image_mobile_active_from?: Maybe<Scalars['String']['output']>;
  image_mobile_active_to?: Maybe<Scalars['String']['output']>;
  include_in_menu?: Maybe<Scalars['Int']['output']>;
  is_anchor?: Maybe<Scalars['Int']['output']>;
  is_featured?: Maybe<Scalars['Boolean']['output']>;
  is_virtual_category?: Maybe<Scalars['Int']['output']>;
  landing_page?: Maybe<Scalars['Int']['output']>;
  /** Indicates the depth of the category within the tree. */
  level?: Maybe<Scalars['Int']['output']>;
  menu_icon?: Maybe<Scalars['String']['output']>;
  menu_icon_over?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  mobile_image?: Maybe<Scalars['String']['output']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** Category Path. */
  path?: Maybe<Scalars['String']['output']>;
  /** Category path in store. */
  path_in_store?: Maybe<Scalars['String']['output']>;
  /** The popular search keywords for category page. */
  popularSearchKeywords?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  /** The number of products in the category. */
  product_count?: Maybe<Scalars['Int']['output']>;
  product_deal?: Maybe<Scalars['String']['output']>;
  product_deal_time?: Maybe<Scalars['String']['output']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  searchindex_weight?: Maybe<Scalars['String']['output']>;
  second_post?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  slider_params?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  third_post?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the category was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The url key assigned to the category. */
  url_key?: Maybe<Scalars['String']['output']>;
  /** The url path assigned to the category. */
  url_path?: Maybe<Scalars['String']['output']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_name_in_product_search?: Maybe<Scalars['Int']['output']>;
  use_store_positions?: Maybe<Scalars['Int']['output']>;
  virtual_category_root?: Maybe<Scalars['Int']['output']>;
  virtual_rule?: Maybe<Scalars['String']['output']>;
};


/** CategoryInterface contains the full set of attributes that can be returned in a category search. */
export type CategoryInterfaceProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** An array posts in category. */
export type CategoryPosts = {
  __typename?: 'CategoryPosts';
  /** An array of posts that match the specified query data. */
  items?: Maybe<Array<Maybe<Post>>>;
};

/** The category products object returned in the Category query. */
export type CategoryProducts = {
  __typename?: 'CategoryProducts';
  /** An array of products that are assigned to the category. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of products returned. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Tag items for category. */
export type CategoryTags = {
  __typename?: 'CategoryTags';
  /** An array of tags */
  items?: Maybe<Array<Maybe<Tag>>>;
};

/** Category Tree implementation. */
export type CategoryTree = CategoryInterface & {
  __typename?: 'CategoryTree';
  /** Achievement information of the Category */
  achievement?: Maybe<Achievement>;
  amtoolkit_robots?: Maybe<Scalars['String']['output']>;
  author_email?: Maybe<Scalars['String']['output']>;
  available_sort_by?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  background_app_icon?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  banner_active_from?: Maybe<Scalars['String']['output']>;
  banner_active_to?: Maybe<Scalars['String']['output']>;
  banner_from_date?: Maybe<Scalars['String']['output']>;
  banner_head?: Maybe<Scalars['String']['output']>;
  banner_menu_image?: Maybe<Scalars['String']['output']>;
  banner_mobile_image?: Maybe<Scalars['String']['output']>;
  banner_to_date?: Maybe<Scalars['String']['output']>;
  banner_url?: Maybe<Scalars['String']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Categories' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  category_image_for_app?: Maybe<Scalars['String']['output']>;
  category_tags?: Maybe<Scalars['String']['output']>;
  child_tags?: Maybe<Scalars['String']['output']>;
  /** Child categories tree. */
  children?: Maybe<Array<Maybe<CategoryTree>>>;
  children_count?: Maybe<Scalars['String']['output']>;
  /** Category CMS Block. */
  cms_block?: Maybe<CmsBlock>;
  /** Timestamp indicating when the category was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  custom_layout_update_file?: Maybe<Scalars['String']['output']>;
  /** The attribute to use for sorting. */
  default_sort_by?: Maybe<Scalars['String']['output']>;
  /** An optional description of the category. */
  description?: Maybe<Scalars['String']['output']>;
  display_mode?: Maybe<Scalars['String']['output']>;
  featured_app_icon?: Maybe<Scalars['String']['output']>;
  featured_icon?: Maybe<Scalars['String']['output']>;
  filter_price_range?: Maybe<Scalars['Float']['output']>;
  first_post?: Maybe<Scalars['String']['output']>;
  fourth_post?: Maybe<Scalars['String']['output']>;
  highlight_post?: Maybe<Scalars['String']['output']>;
  highlight_product_app_qty?: Maybe<Scalars['String']['output']>;
  highlight_product_app_sku?: Maybe<Scalars['String']['output']>;
  highlight_product_app_type?: Maybe<Scalars['String']['output']>;
  /** An array attribute object. */
  highlight_product_attributes?: Maybe<Array<Maybe<Attribute>>>;
  /** An ID that uniquely identifies the category. */
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  image1?: Maybe<Scalars['String']['output']>;
  image_desktop_active_from?: Maybe<Scalars['String']['output']>;
  image_desktop_active_to?: Maybe<Scalars['String']['output']>;
  image_mobile_active_from?: Maybe<Scalars['String']['output']>;
  image_mobile_active_to?: Maybe<Scalars['String']['output']>;
  include_in_menu?: Maybe<Scalars['Int']['output']>;
  is_anchor?: Maybe<Scalars['Int']['output']>;
  is_featured?: Maybe<Scalars['Boolean']['output']>;
  is_virtual_category?: Maybe<Scalars['Int']['output']>;
  landing_page?: Maybe<Scalars['Int']['output']>;
  /** Indicates the depth of the category within the tree. */
  level?: Maybe<Scalars['Int']['output']>;
  menu_icon?: Maybe<Scalars['String']['output']>;
  menu_icon_over?: Maybe<Scalars['String']['output']>;
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Scalars['String']['output']>;
  meta_title?: Maybe<Scalars['String']['output']>;
  mobile_image?: Maybe<Scalars['String']['output']>;
  /** The display name of the category. */
  name?: Maybe<Scalars['String']['output']>;
  /** Category Path. */
  path?: Maybe<Scalars['String']['output']>;
  /** Category path in store. */
  path_in_store?: Maybe<Scalars['String']['output']>;
  /** The popular search keywords for category page. */
  popularSearchKeywords?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /** The position of the category relative to other categories at the same level in tree. */
  position?: Maybe<Scalars['Int']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  /** The number of products in the category. */
  product_count?: Maybe<Scalars['Int']['output']>;
  product_deal?: Maybe<Scalars['String']['output']>;
  product_deal_time?: Maybe<Scalars['String']['output']>;
  /** The list of products assigned to the category. */
  products?: Maybe<CategoryProducts>;
  searchindex_weight?: Maybe<Scalars['String']['output']>;
  second_post?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  slider_params?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  third_post?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the category was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** The url key assigned to the category. */
  url_key?: Maybe<Scalars['String']['output']>;
  /** The url path assigned to the category. */
  url_path?: Maybe<Scalars['String']['output']>;
  /** The part of the category URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_name_in_product_search?: Maybe<Scalars['Int']['output']>;
  use_store_positions?: Maybe<Scalars['Int']['output']>;
  virtual_category_root?: Maybe<Scalars['Int']['output']>;
  virtual_rule?: Maybe<Scalars['String']['output']>;
};


/** Category Tree implementation. */
export type CategoryTreeProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};

/** Defines all Checkout Agreement information */
export type CheckoutAgreement = {
  __typename?: 'CheckoutAgreement';
  /** Checkout Agreement identifier */
  agreement_id: Scalars['Int']['output'];
  /** Checkout Agreement checkbox text */
  checkbox_text: Scalars['String']['output'];
  /** Checkout Agreement content */
  content: Scalars['String']['output'];
  /** Checkout Agreement content height */
  content_height?: Maybe<Scalars['String']['output']>;
  /** Is Checkout Agreement content in HTML format */
  is_html: Scalars['Boolean']['output'];
  mode: CheckoutAgreementMode;
  /** Checkout Agreement name */
  name: Scalars['String']['output'];
};

export enum CheckoutAgreementMode {
  /** @deprecated  */
  Auto = 'AUTO',
  /** @deprecated  */
  Manual = 'MANUAL'
}

export type CheckoutInfoInput = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<Array<InitiateCheckoutContentInput>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientCredentialInput = {
  client_id: Scalars['String']['input'];
  client_secret: Scalars['String']['input'];
};

/** CMS block defines all CMS block information */
export type CmsBlock = {
  __typename?: 'CmsBlock';
  /** CMS block content */
  content?: Maybe<Scalars['String']['output']>;
  /** CMS block identifier */
  identifier?: Maybe<Scalars['String']['output']>;
  /** CMS block title */
  title?: Maybe<Scalars['String']['output']>;
};

/** CMS blocks information */
export type CmsBlocks = {
  __typename?: 'CmsBlocks';
  /** An array of CMS blocks */
  items?: Maybe<Array<Maybe<CmsBlock>>>;
};

/** CMS page defines all CMS page information */
export type CmsPage = {
  __typename?: 'CmsPage';
  /** CMS page content */
  content?: Maybe<Scalars['String']['output']>;
  /** CMS page content heading */
  content_heading?: Maybe<Scalars['String']['output']>;
  /** Identifier of the CMS page */
  identifier?: Maybe<Scalars['String']['output']>;
  /** CMS page meta description */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** CMS page meta keywords */
  meta_keywords?: Maybe<Scalars['String']['output']>;
  /** CMS page meta title */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** CMS page content heading */
  page_layout?: Maybe<Scalars['String']['output']>;
  /** CMS page title */
  title?: Maybe<Scalars['String']['output']>;
  /** URL key of CMS page */
  url_key?: Maybe<Scalars['String']['output']>;
};

export type CmsPageResponse = {
  __typename?: 'CmsPageResponse';
  /** Cms html */
  content?: Maybe<Scalars['String']['output']>;
  /** Data extracted from html element used to render in frontend  */
  content_fragment: Array<ContentFragment>;
  /** Heading of cms page */
  content_heading?: Maybe<Scalars['String']['output']>;
  /** Identification key of page */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Mega description of cms page */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** Mega keywords of cms page */
  meta_keywords?: Maybe<Scalars['String']['output']>;
  /** Mega title of cms page */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** Layout name of page in magento */
  page_layout?: Maybe<Scalars['String']['output']>;
  /** Url of shared image */
  social_image?: Maybe<Scalars['String']['output']>;
  /** Title of cms page */
  title?: Maybe<Scalars['String']['output']>;
  /** Url key of cms page */
  url_key?: Maybe<Scalars['String']['output']>;
};

export type ColorSwatchData = SwatchDataInterface & {
  __typename?: 'ColorSwatchData';
  /** Value of swatch item (HEX color code, image link or textual value) */
  value?: Maybe<Scalars['String']['output']>;
};

export type CompleteRegistrationEventInput = {
  user: UserDataInput;
};

export type CompleteRegistrationTrackingEventRequest = {
  context?: InputMaybe<EventContextInput>;
  data?: InputMaybe<CompleteRegistrationEventInput>;
};

export type ComplexTextValue = {
  __typename?: 'ComplexTextValue';
  /** HTML format */
  html: Scalars['String']['output'];
};

/** Data return for image */
export type CompositeImageWidget = ContentFragmentDataInterface & {
  __typename?: 'CompositeImageWidget';
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Images in CompositeImageWidget */
  images?: Maybe<Array<Maybe<ImageItem>>>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export type Condition = {
  __typename?: 'Condition';
  aggregator?: Maybe<Scalars['String']['output']>;
  attribute?: Maybe<Scalars['String']['output']>;
  conditions?: Maybe<Array<Maybe<Condition>>>;
  is_value_processed?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** ConfigurableAttributeOption contains the value_index (and other related information) assigned to a configurable product option */
export type ConfigurableAttributeOption = {
  __typename?: 'ConfigurableAttributeOption';
  /** The ID assigned to the attribute */
  code?: Maybe<Scalars['String']['output']>;
  /** A string that describes the configurable attribute option */
  label?: Maybe<Scalars['String']['output']>;
  /** A unique index number assigned to the configurable product option */
  value_index?: Maybe<Scalars['Int']['output']>;
};

export type ConfigurableCartItem = CartItemInterface & {
  __typename?: 'ConfigurableCartItem';
  configurable_options: Array<Maybe<SelectedConfigurableOption>>;
  /** Product details of the cart item. */
  configured_variant: ProductInterface;
  customizable_options: Array<Maybe<SelectedCustomizableOption>>;
  id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

/** ConfigurableProduct defines basic features of a configurable product and its simple product variants */
export type ConfigurableProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & {
  __typename?: 'ConfigurableProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** An array of linked simple product items */
  configurable_options?: Maybe<Array<Maybe<ConfigurableProductOptions>>>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  sold_quantity?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /** An array of variants of products */
  variants?: Maybe<Array<Maybe<ConfigurableVariant>>>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

export type ConfigurableProductCartItemInput = {
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  data: CartItemInput;
  /** Configurable product SKU. */
  parent_sku?: InputMaybe<Scalars['String']['input']>;
  variant_sku?: InputMaybe<Scalars['String']['input']>;
};

/** ConfigurableProductOptions defines configurable attributes for the specified product */
export type ConfigurableProductOptions = {
  __typename?: 'ConfigurableProductOptions';
  /** A string that identifies the attribute */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the attribute */
  attribute_id?: Maybe<Scalars['String']['output']>;
  /** The configurable option ID number assigned by the system */
  id?: Maybe<Scalars['Int']['output']>;
  /** A string that describes the configurable product option, which is displayed on the UI */
  label?: Maybe<Scalars['String']['output']>;
  /** A number that indicates the order in which the attribute is displayed */
  position?: Maybe<Scalars['Int']['output']>;
  /** This is the same as a product's id field */
  product_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is the default */
  use_default?: Maybe<Scalars['Boolean']['output']>;
  /** An array that defines the value_index codes assigned to the configurable product */
  values?: Maybe<Array<Maybe<ConfigurableProductOptionsValues>>>;
};

/** ConfigurableProductOptionsValues contains the index number assigned to a configurable product option */
export type ConfigurableProductOptionsValues = {
  __typename?: 'ConfigurableProductOptionsValues';
  /** The label of the product on the default store */
  default_label?: Maybe<Scalars['String']['output']>;
  /** The label of the product */
  label?: Maybe<Scalars['String']['output']>;
  /** The label of the product on the current store */
  store_label?: Maybe<Scalars['String']['output']>;
  /** Swatch data for configurable product option */
  swatch_data?: Maybe<SwatchDataInterface>;
  /** Indicates whether to use the default_label */
  use_default_value?: Maybe<Scalars['Boolean']['output']>;
  /** A unique index number assigned to the configurable product option */
  value_index?: Maybe<Scalars['Int']['output']>;
};

/** An array containing all the simple product variants of a configurable product */
export type ConfigurableVariant = {
  __typename?: 'ConfigurableVariant';
  attributes?: Maybe<Array<Maybe<ConfigurableAttributeOption>>>;
  product?: Maybe<SimpleProduct>;
};

export type ConfirmRequestedValidationPhoneResponse = {
  __typename?: 'ConfirmRequestedValidationPhoneResponse';
  /** Error Code if any */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** Secret to use for next request */
  secret?: Maybe<Scalars['String']['output']>;
  /** Success */
  success: Scalars['Boolean']['output'];
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  contact?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  socials?: Maybe<Array<Maybe<SocialChannel>>>;
  website?: Maybe<Scalars['String']['output']>;
};

/** Data extracted from html element */
export type ContentFragment = {
  __typename?: 'ContentFragment';
  /** Additional data diffirent on each widget type */
  data?: Maybe<ContentFragmentDataInterface>;
  /** Html of widget */
  html: Scalars['String']['output'];
  /** Magento widget id */
  widget_id?: Maybe<Scalars['String']['output']>;
};

export type ContentFragmentDataInterface = {
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export type CoreConfig = {
  __typename?: 'CoreConfig';
  image_upload_quantity_limit?: Maybe<Scalars['Int']['output']>;
  image_upload_size_limit?: Maybe<Scalars['Int']['output']>;
  video_upload_quantity_limit?: Maybe<Scalars['Int']['output']>;
  video_upload_size_limit?: Maybe<Scalars['Int']['output']>;
};

export type Country = {
  __typename?: 'Country';
  available_regions?: Maybe<Array<Maybe<Region>>>;
  full_name_english?: Maybe<Scalars['String']['output']>;
  full_name_locale?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  three_letter_abbreviation?: Maybe<Scalars['String']['output']>;
  two_letter_abbreviation?: Maybe<Scalars['String']['output']>;
};

/** The list of countries codes */
export enum CountryCodeEnum {
  /**
   * Andorra
   * @deprecated
   */
  Ad = 'AD',
  /**
   * United Arab Emirates
   * @deprecated
   */
  Ae = 'AE',
  /**
   * Afghanistan
   * @deprecated
   */
  Af = 'AF',
  /**
   * Antigua & Barbuda
   * @deprecated
   */
  Ag = 'AG',
  /**
   * Anguilla
   * @deprecated
   */
  Ai = 'AI',
  /**
   * Albania
   * @deprecated
   */
  Al = 'AL',
  /**
   * Armenia
   * @deprecated
   */
  Am = 'AM',
  /**
   * Netherlands Antilles
   * @deprecated
   */
  An = 'AN',
  /**
   * Angola
   * @deprecated
   */
  Ao = 'AO',
  /**
   * Antarctica
   * @deprecated
   */
  Aq = 'AQ',
  /**
   * Argentina
   * @deprecated
   */
  Ar = 'AR',
  /**
   * American Samoa
   * @deprecated
   */
  As = 'AS',
  /**
   * Austria
   * @deprecated
   */
  At = 'AT',
  /**
   * Australia
   * @deprecated
   */
  Au = 'AU',
  /**
   * Aruba
   * @deprecated
   */
  Aw = 'AW',
  /**
   * Åland Islands
   * @deprecated
   */
  Ax = 'AX',
  /**
   * Azerbaijan
   * @deprecated
   */
  Az = 'AZ',
  /**
   * Bosnia & Herzegovina
   * @deprecated
   */
  Ba = 'BA',
  /**
   * Barbados
   * @deprecated
   */
  Bb = 'BB',
  /**
   * Bangladesh
   * @deprecated
   */
  Bd = 'BD',
  /**
   * Belgium
   * @deprecated
   */
  Be = 'BE',
  /**
   * Burkina Faso
   * @deprecated
   */
  Bf = 'BF',
  /**
   * Bulgaria
   * @deprecated
   */
  Bg = 'BG',
  /**
   * Bahrain
   * @deprecated
   */
  Bh = 'BH',
  /**
   * Burundi
   * @deprecated
   */
  Bi = 'BI',
  /**
   * Benin
   * @deprecated
   */
  Bj = 'BJ',
  /**
   * St. Barthélemy
   * @deprecated
   */
  Bl = 'BL',
  /**
   * Bermuda
   * @deprecated
   */
  Bm = 'BM',
  /**
   * Brunei
   * @deprecated
   */
  Bn = 'BN',
  /**
   * Bolivia
   * @deprecated
   */
  Bo = 'BO',
  /**
   * Brazil
   * @deprecated
   */
  Br = 'BR',
  /**
   * Bahamas
   * @deprecated
   */
  Bs = 'BS',
  /**
   * Bhutan
   * @deprecated
   */
  Bt = 'BT',
  /**
   * Bouvet Island
   * @deprecated
   */
  Bv = 'BV',
  /**
   * Botswana
   * @deprecated
   */
  Bw = 'BW',
  /**
   * Belarus
   * @deprecated
   */
  By = 'BY',
  /**
   * Belize
   * @deprecated
   */
  Bz = 'BZ',
  /**
   * Canada
   * @deprecated
   */
  Ca = 'CA',
  /**
   * Cocos (Keeling) Islands
   * @deprecated
   */
  Cc = 'CC',
  /**
   * Congo-Kinshasa
   * @deprecated
   */
  Cd = 'CD',
  /**
   * Central African Republic
   * @deprecated
   */
  Cf = 'CF',
  /**
   * Congo-Brazzaville
   * @deprecated
   */
  Cg = 'CG',
  /**
   * Switzerland
   * @deprecated
   */
  Ch = 'CH',
  /**
   * Côte d’Ivoire
   * @deprecated
   */
  Ci = 'CI',
  /**
   * Cook Islands
   * @deprecated
   */
  Ck = 'CK',
  /**
   * Chile
   * @deprecated
   */
  Cl = 'CL',
  /**
   * Cameroon
   * @deprecated
   */
  Cm = 'CM',
  /**
   * China
   * @deprecated
   */
  Cn = 'CN',
  /**
   * Colombia
   * @deprecated
   */
  Co = 'CO',
  /**
   * Costa Rica
   * @deprecated
   */
  Cr = 'CR',
  /**
   * Cuba
   * @deprecated
   */
  Cu = 'CU',
  /**
   * Cape Verde
   * @deprecated
   */
  Cv = 'CV',
  /**
   * Christmas Island
   * @deprecated
   */
  Cx = 'CX',
  /**
   * Cyprus
   * @deprecated
   */
  Cy = 'CY',
  /**
   * Czech Republic
   * @deprecated
   */
  Cz = 'CZ',
  /**
   * Germany
   * @deprecated
   */
  De = 'DE',
  /**
   * Djibouti
   * @deprecated
   */
  Dj = 'DJ',
  /**
   * Denmark
   * @deprecated
   */
  Dk = 'DK',
  /**
   * Dominica
   * @deprecated
   */
  Dm = 'DM',
  /**
   * Dominican Republic
   * @deprecated
   */
  Do = 'DO',
  /**
   * Algeria
   * @deprecated
   */
  Dz = 'DZ',
  /**
   * Ecuador
   * @deprecated
   */
  Ec = 'EC',
  /**
   * Estonia
   * @deprecated
   */
  Ee = 'EE',
  /**
   * Egypt
   * @deprecated
   */
  Eg = 'EG',
  /**
   * Western Sahara
   * @deprecated
   */
  Eh = 'EH',
  /**
   * Eritrea
   * @deprecated
   */
  Er = 'ER',
  /**
   * Spain
   * @deprecated
   */
  Es = 'ES',
  /**
   * Ethiopia
   * @deprecated
   */
  Et = 'ET',
  /**
   * Finland
   * @deprecated
   */
  Fi = 'FI',
  /**
   * Fiji
   * @deprecated
   */
  Fj = 'FJ',
  /**
   * Falkland Islands
   * @deprecated
   */
  Fk = 'FK',
  /**
   * Micronesia
   * @deprecated
   */
  Fm = 'FM',
  /**
   * Faroe Islands
   * @deprecated
   */
  Fo = 'FO',
  /**
   * France
   * @deprecated
   */
  Fr = 'FR',
  /**
   * Gabon
   * @deprecated
   */
  Ga = 'GA',
  /**
   * United Kingdom
   * @deprecated
   */
  Gb = 'GB',
  /**
   * Grenada
   * @deprecated
   */
  Gd = 'GD',
  /**
   * Georgia
   * @deprecated
   */
  Ge = 'GE',
  /**
   * French Guiana
   * @deprecated
   */
  Gf = 'GF',
  /**
   * Guernsey
   * @deprecated
   */
  Gg = 'GG',
  /**
   * Ghana
   * @deprecated
   */
  Gh = 'GH',
  /**
   * Gibraltar
   * @deprecated
   */
  Gi = 'GI',
  /**
   * Greenland
   * @deprecated
   */
  Gl = 'GL',
  /**
   * Gambia
   * @deprecated
   */
  Gm = 'GM',
  /**
   * Guinea
   * @deprecated
   */
  Gn = 'GN',
  /**
   * Guadeloupe
   * @deprecated
   */
  Gp = 'GP',
  /**
   * Equatorial Guinea
   * @deprecated
   */
  Gq = 'GQ',
  /**
   * Greece
   * @deprecated
   */
  Gr = 'GR',
  /**
   * South Georgia & South Sandwich Islands
   * @deprecated
   */
  Gs = 'GS',
  /**
   * Guatemala
   * @deprecated
   */
  Gt = 'GT',
  /**
   * Guam
   * @deprecated
   */
  Gu = 'GU',
  /**
   * Guinea-Bissau
   * @deprecated
   */
  Gw = 'GW',
  /**
   * Guyana
   * @deprecated
   */
  Gy = 'GY',
  /**
   * Hong Kong SAR China
   * @deprecated
   */
  Hk = 'HK',
  /**
   * Heard &amp; McDonald Islands
   * @deprecated
   */
  Hm = 'HM',
  /**
   * Honduras
   * @deprecated
   */
  Hn = 'HN',
  /**
   * Croatia
   * @deprecated
   */
  Hr = 'HR',
  /**
   * Haiti
   * @deprecated
   */
  Ht = 'HT',
  /**
   * Hungary
   * @deprecated
   */
  Hu = 'HU',
  /**
   * Indonesia
   * @deprecated
   */
  Id = 'ID',
  /**
   * Ireland
   * @deprecated
   */
  Ie = 'IE',
  /**
   * Israel
   * @deprecated
   */
  Il = 'IL',
  /**
   * Isle of Man
   * @deprecated
   */
  Im = 'IM',
  /**
   * India
   * @deprecated
   */
  In = 'IN',
  /**
   * British Indian Ocean Territory
   * @deprecated
   */
  Io = 'IO',
  /**
   * Iraq
   * @deprecated
   */
  Iq = 'IQ',
  /**
   * Iran
   * @deprecated
   */
  Ir = 'IR',
  /**
   * Iceland
   * @deprecated
   */
  Is = 'IS',
  /**
   * Italy
   * @deprecated
   */
  It = 'IT',
  /**
   * Jersey
   * @deprecated
   */
  Je = 'JE',
  /**
   * Jamaica
   * @deprecated
   */
  Jm = 'JM',
  /**
   * Jordan
   * @deprecated
   */
  Jo = 'JO',
  /**
   * Japan
   * @deprecated
   */
  Jp = 'JP',
  /**
   * Kenya
   * @deprecated
   */
  Ke = 'KE',
  /**
   * Kyrgyzstan
   * @deprecated
   */
  Kg = 'KG',
  /**
   * Cambodia
   * @deprecated
   */
  Kh = 'KH',
  /**
   * Kiribati
   * @deprecated
   */
  Ki = 'KI',
  /**
   * Comoros
   * @deprecated
   */
  Km = 'KM',
  /**
   * St. Kitts & Nevis
   * @deprecated
   */
  Kn = 'KN',
  /**
   * North Korea
   * @deprecated
   */
  Kp = 'KP',
  /**
   * South Korea
   * @deprecated
   */
  Kr = 'KR',
  /**
   * Kuwait
   * @deprecated
   */
  Kw = 'KW',
  /**
   * Cayman Islands
   * @deprecated
   */
  Ky = 'KY',
  /**
   * Kazakhstan
   * @deprecated
   */
  Kz = 'KZ',
  /**
   * Laos
   * @deprecated
   */
  La = 'LA',
  /**
   * Lebanon
   * @deprecated
   */
  Lb = 'LB',
  /**
   * St. Lucia
   * @deprecated
   */
  Lc = 'LC',
  /**
   * Liechtenstein
   * @deprecated
   */
  Li = 'LI',
  /**
   * Sri Lanka
   * @deprecated
   */
  Lk = 'LK',
  /**
   * Liberia
   * @deprecated
   */
  Lr = 'LR',
  /**
   * Lesotho
   * @deprecated
   */
  Ls = 'LS',
  /**
   * Lithuania
   * @deprecated
   */
  Lt = 'LT',
  /**
   * Luxembourg
   * @deprecated
   */
  Lu = 'LU',
  /**
   * Latvia
   * @deprecated
   */
  Lv = 'LV',
  /**
   * Libya
   * @deprecated
   */
  Ly = 'LY',
  /**
   * Morocco
   * @deprecated
   */
  Ma = 'MA',
  /**
   * Monaco
   * @deprecated
   */
  Mc = 'MC',
  /**
   * Moldova
   * @deprecated
   */
  Md = 'MD',
  /**
   * Montenegro
   * @deprecated
   */
  Me = 'ME',
  /**
   * St. Martin
   * @deprecated
   */
  Mf = 'MF',
  /**
   * Madagascar
   * @deprecated
   */
  Mg = 'MG',
  /**
   * Marshall Islands
   * @deprecated
   */
  Mh = 'MH',
  /**
   * Macedonia
   * @deprecated
   */
  Mk = 'MK',
  /**
   * Mali
   * @deprecated
   */
  Ml = 'ML',
  /**
   * Myanmar (Burma)
   * @deprecated
   */
  Mm = 'MM',
  /**
   * Mongolia
   * @deprecated
   */
  Mn = 'MN',
  /**
   * Macau SAR China
   * @deprecated
   */
  Mo = 'MO',
  /**
   * Northern Mariana Islands
   * @deprecated
   */
  Mp = 'MP',
  /**
   * Martinique
   * @deprecated
   */
  Mq = 'MQ',
  /**
   * Mauritania
   * @deprecated
   */
  Mr = 'MR',
  /**
   * Montserrat
   * @deprecated
   */
  Ms = 'MS',
  /**
   * Malta
   * @deprecated
   */
  Mt = 'MT',
  /**
   * Mauritius
   * @deprecated
   */
  Mu = 'MU',
  /**
   * Maldives
   * @deprecated
   */
  Mv = 'MV',
  /**
   * Malawi
   * @deprecated
   */
  Mw = 'MW',
  /**
   * Mexico
   * @deprecated
   */
  Mx = 'MX',
  /**
   * Malaysia
   * @deprecated
   */
  My = 'MY',
  /**
   * Mozambique
   * @deprecated
   */
  Mz = 'MZ',
  /**
   * Namibia
   * @deprecated
   */
  Na = 'NA',
  /**
   * New Caledonia
   * @deprecated
   */
  Nc = 'NC',
  /**
   * Niger
   * @deprecated
   */
  Ne = 'NE',
  /**
   * Norfolk Island
   * @deprecated
   */
  Nf = 'NF',
  /**
   * Nigeria
   * @deprecated
   */
  Ng = 'NG',
  /**
   * Nicaragua
   * @deprecated
   */
  Ni = 'NI',
  /**
   * Netherlands
   * @deprecated
   */
  Nl = 'NL',
  /**
   * Norway
   * @deprecated
   */
  No = 'NO',
  /**
   * Nepal
   * @deprecated
   */
  Np = 'NP',
  /**
   * Nauru
   * @deprecated
   */
  Nr = 'NR',
  /**
   * Niue
   * @deprecated
   */
  Nu = 'NU',
  /**
   * New Zealand
   * @deprecated
   */
  Nz = 'NZ',
  /**
   * Oman
   * @deprecated
   */
  Om = 'OM',
  /**
   * Panama
   * @deprecated
   */
  Pa = 'PA',
  /**
   * Peru
   * @deprecated
   */
  Pe = 'PE',
  /**
   * French Polynesia
   * @deprecated
   */
  Pf = 'PF',
  /**
   * Papua New Guinea
   * @deprecated
   */
  Pg = 'PG',
  /**
   * Philippines
   * @deprecated
   */
  Ph = 'PH',
  /**
   * Pakistan
   * @deprecated
   */
  Pk = 'PK',
  /**
   * Poland
   * @deprecated
   */
  Pl = 'PL',
  /**
   * St. Pierre & Miquelon
   * @deprecated
   */
  Pm = 'PM',
  /**
   * Pitcairn Islands
   * @deprecated
   */
  Pn = 'PN',
  /**
   * Palestinian Territories
   * @deprecated
   */
  Ps = 'PS',
  /**
   * Portugal
   * @deprecated
   */
  Pt = 'PT',
  /**
   * Palau
   * @deprecated
   */
  Pw = 'PW',
  /**
   * Paraguay
   * @deprecated
   */
  Py = 'PY',
  /**
   * Qatar
   * @deprecated
   */
  Qa = 'QA',
  /**
   * Réunion
   * @deprecated
   */
  Re = 'RE',
  /**
   * Romania
   * @deprecated
   */
  Ro = 'RO',
  /**
   * Serbia
   * @deprecated
   */
  Rs = 'RS',
  /**
   * Russia
   * @deprecated
   */
  Ru = 'RU',
  /**
   * Rwanda
   * @deprecated
   */
  Rw = 'RW',
  /**
   * Saudi Arabia
   * @deprecated
   */
  Sa = 'SA',
  /**
   * Solomon Islands
   * @deprecated
   */
  Sb = 'SB',
  /**
   * Seychelles
   * @deprecated
   */
  Sc = 'SC',
  /**
   * Sudan
   * @deprecated
   */
  Sd = 'SD',
  /**
   * Sweden
   * @deprecated
   */
  Se = 'SE',
  /**
   * Singapore
   * @deprecated
   */
  Sg = 'SG',
  /**
   * St. Helena
   * @deprecated
   */
  Sh = 'SH',
  /**
   * Slovenia
   * @deprecated
   */
  Si = 'SI',
  /**
   * Svalbard & Jan Mayen
   * @deprecated
   */
  Sj = 'SJ',
  /**
   * Slovakia
   * @deprecated
   */
  Sk = 'SK',
  /**
   * Sierra Leone
   * @deprecated
   */
  Sl = 'SL',
  /**
   * San Marino
   * @deprecated
   */
  Sm = 'SM',
  /**
   * Senegal
   * @deprecated
   */
  Sn = 'SN',
  /**
   * Somalia
   * @deprecated
   */
  So = 'SO',
  /**
   * Suriname
   * @deprecated
   */
  Sr = 'SR',
  /**
   * São Tomé & Príncipe
   * @deprecated
   */
  St = 'ST',
  /**
   * El Salvador
   * @deprecated
   */
  Sv = 'SV',
  /**
   * Syria
   * @deprecated
   */
  Sy = 'SY',
  /**
   * Swaziland
   * @deprecated
   */
  Sz = 'SZ',
  /**
   * Turks & Caicos Islands
   * @deprecated
   */
  Tc = 'TC',
  /**
   * Chad
   * @deprecated
   */
  Td = 'TD',
  /**
   * French Southern Territories
   * @deprecated
   */
  Tf = 'TF',
  /**
   * Togo
   * @deprecated
   */
  Tg = 'TG',
  /**
   * Thailand
   * @deprecated
   */
  Th = 'TH',
  /**
   * Tajikistan
   * @deprecated
   */
  Tj = 'TJ',
  /**
   * Tokelau
   * @deprecated
   */
  Tk = 'TK',
  /**
   * Timor-Leste
   * @deprecated
   */
  Tl = 'TL',
  /**
   * Turkmenistan
   * @deprecated
   */
  Tm = 'TM',
  /**
   * Tunisia
   * @deprecated
   */
  Tn = 'TN',
  /**
   * Tonga
   * @deprecated
   */
  To = 'TO',
  /**
   * Turkey
   * @deprecated
   */
  Tr = 'TR',
  /**
   * Trinidad & Tobago
   * @deprecated
   */
  Tt = 'TT',
  /**
   * Tuvalu
   * @deprecated
   */
  Tv = 'TV',
  /**
   * Taiwan
   * @deprecated
   */
  Tw = 'TW',
  /**
   * Tanzania
   * @deprecated
   */
  Tz = 'TZ',
  /**
   * Ukraine
   * @deprecated
   */
  Ua = 'UA',
  /**
   * Uganda
   * @deprecated
   */
  Ug = 'UG',
  /**
   * U.S. Outlying Islands
   * @deprecated
   */
  Um = 'UM',
  /**
   * United States
   * @deprecated
   */
  Us = 'US',
  /**
   * Uruguay
   * @deprecated
   */
  Uy = 'UY',
  /**
   * Uzbekistan
   * @deprecated
   */
  Uz = 'UZ',
  /**
   * Vatican City
   * @deprecated
   */
  Va = 'VA',
  /**
   * St. Vincent & Grenadines
   * @deprecated
   */
  Vc = 'VC',
  /**
   * Venezuela
   * @deprecated
   */
  Ve = 'VE',
  /**
   * British Virgin Islands
   * @deprecated
   */
  Vg = 'VG',
  /**
   * U.S. Virgin Islands
   * @deprecated
   */
  Vi = 'VI',
  /**
   * Vietnam
   * @deprecated
   */
  Vn = 'VN',
  /**
   * Vanuatu
   * @deprecated
   */
  Vu = 'VU',
  /**
   * Wallis & Futuna
   * @deprecated
   */
  Wf = 'WF',
  /**
   * Samoa
   * @deprecated
   */
  Ws = 'WS',
  /**
   * Yemen
   * @deprecated
   */
  Ye = 'YE',
  /**
   * Mayotte
   * @deprecated
   */
  Yt = 'YT',
  /**
   * South Africa
   * @deprecated
   */
  Za = 'ZA',
  /**
   * Zambia
   * @deprecated
   */
  Zm = 'ZM',
  /**
   * Zimbabwe
   * @deprecated
   */
  Zw = 'ZW'
}

export type CouponContentResponse = {
  __typename?: 'CouponContentResponse';
  background_color?: Maybe<Scalars['String']['output']>;
  border_color?: Maybe<Scalars['String']['output']>;
  /** Brand logo image */
  brand_image?: Maybe<Scalars['String']['output']>;
  /** Html to show condition of coupon */
  condition?: Maybe<Scalars['String']['output']>;
  coupon_config_id?: Maybe<Scalars['String']['output']>;
  /** Text to show description of coupon */
  description?: Maybe<Scalars['String']['output']>;
  /** text show devices */
  device?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  /** Html to show instruction of coupon */
  instruction?: Maybe<Scalars['String']['output']>;
  /** Coupon is stored in the customer wallet */
  is_in_wallet?: Maybe<Scalars['Boolean']['output']>;
  /** Name of coupon */
  name?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Array<Maybe<CouponPartner>>>;
  /** payment image url */
  payment_image?: Maybe<Scalars['String']['output']>;
  /** payment method in usage condition of the coupon */
  payment_method?: Maybe<Scalars['String']['output']>;
  payment_method_text?: Maybe<Scalars['String']['output']>;
  /** Html to show restriction of coupon */
  restriction?: Maybe<Scalars['String']['output']>;
  salesrule?: Maybe<Salesrule>;
  shipping_method?: Maybe<Scalars['String']['output']>;
  /** tag of coupon */
  tag?: Maybe<Scalars['String']['output']>;
};

export type CouponPartner = {
  __typename?: 'CouponPartner';
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  partner_key?: Maybe<Scalars['String']['output']>;
  partner_type?: Maybe<Scalars['String']['output']>;
};

/** Defines a filter that matches the input exactly. */
export type CouponWidgetFilterEqualTypeInput = {
  /** A string to filter on */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** An array of values to filter on */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CouponWidgetFilterInput = {
  brand?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
  category?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
  code?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
  partner?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
  payment?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
  product?: InputMaybe<CouponWidgetFilterEqualTypeInput>;
};

export type CreateAnswerRequest = {
  adminId: Scalars['Int']['input'];
  adminName: Scalars['String']['input'];
  answer: Scalars['String']['input'];
  questionId: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAnswerResponse = {
  __typename?: 'CreateAnswerResponse';
  result: Scalars['Boolean']['output'];
};

export type CreateClientCredentialResult = {
  __typename?: 'CreateClientCredentialResult';
  clientId: Scalars['String']['output'];
  clientSecret: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateEmptyCartInput = {
  cart_id?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for creating new event registration details */
export type CreateEventRegistrationDetailsInput = {
  /** Path to the birth certificate image */
  birth_certificate_image?: InputMaybe<Scalars['String']['input']>;
  /** Birth date of the registrant */
  birth_date?: InputMaybe<Scalars['String']['input']>;
  /** District ID of the registrant */
  district_id: Scalars['Int']['input'];
  /** District name of the registrant */
  district_name: Scalars['String']['input'];
  /** Due date for the registration */
  due_date?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the registrant */
  email: Scalars['String']['input'];
  /** Full name of the registrant */
  full_name: Scalars['String']['input'];
  /** Guardian's name */
  guardian_name?: InputMaybe<Scalars['String']['input']>;
  /** Guardian's phone number */
  guardian_phone_number?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the registrant */
  phone_number: Scalars['String']['input'];
  /** Path to the prenatal checkup image */
  prenatal_checkup_image?: InputMaybe<Scalars['String']['input']>;
  /** Region ID of the registrant */
  region_id: Scalars['Int']['input'];
  /** Region name of the registrant */
  region_name: Scalars['String']['input'];
  /** Specific address of the registrant */
  specific_address: Scalars['String']['input'];
  /** Store code where the registrant will exchange the event ticket */
  ticket_exchange_store_code?: InputMaybe<Scalars['String']['input']>;
  /** Store name where the registrant will exchange the event ticket */
  ticket_exchange_store_name?: InputMaybe<Scalars['String']['input']>;
  /** Ward ID of the registrant */
  ward_id: Scalars['Int']['input'];
  /** Ward name of the registrant */
  ward_name: Scalars['String']['input'];
};

/** Input type for creating a new event registration */
export type CreateEventRegistrationInput = {
  /** Activity ID for the registration */
  activity_id: Scalars['ID']['input'];
  /** Whether the user agreed to the terms */
  agreed_terms: Scalars['Boolean']['input'];
  /** Details of the registration */
  registration_details?: InputMaybe<Array<CreateEventRegistrationDetailsInput>>;
  /** The update secret to indicate that the action is performed by admin */
  update_secret?: InputMaybe<Scalars['String']['input']>;
  /** User ID for the registration - this is temporary user ID */
  user_temporary_id: Scalars['ID']['input'];
};

/** Input type for creating a new event user */
export type CreateEventUserInput = {
  /** Address of the user */
  address: Scalars['String']['input'];
  /** Birth date of the event user */
  birth_date?: InputMaybe<Scalars['String']['input']>;
  /** captcha token */
  captcha_token?: InputMaybe<Scalars['String']['input']>;
  /** District ID of the user */
  district_id: Scalars['Int']['input'];
  /** District name of the user */
  district_name: Scalars['String']['input'];
  /** Email address of the user */
  email: Scalars['String']['input'];
  /** Event ID for the registration */
  event_id: Scalars['ID']['input'];
  /** Full name of the user */
  full_name: Scalars['String']['input'];
  /** Participant type of the user */
  participant_type: ParticipantType;
  /** Phone number of the user */
  phone_number: Scalars['String']['input'];
  /** Referral code of the user */
  referral_code?: InputMaybe<Scalars['String']['input']>;
  /** referrer */
  referrer?: InputMaybe<Scalars['String']['input']>;
  /** Region ID of the user */
  region_id: Scalars['Int']['input'];
  /** Region name of the user */
  region_name: Scalars['String']['input'];
  /** Specific address of the user */
  specific_address: Scalars['String']['input'];
  /** update secret */
  update_secret?: InputMaybe<Scalars['String']['input']>;
  /** Id of temporary user */
  user_id?: InputMaybe<Scalars['String']['input']>;
  /** Id of temporary user */
  user_temporary_id?: InputMaybe<Scalars['String']['input']>;
  /** utm campaign */
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  /** utm content */
  utm_content?: InputMaybe<Scalars['String']['input']>;
  /** utm medium */
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  /** utm source where user navigate from */
  utm_source?: InputMaybe<Scalars['String']['input']>;
  /** utm term */
  utm_term?: InputMaybe<Scalars['String']['input']>;
  /** Ward ID of the user */
  ward_id: Scalars['Int']['input'];
  /** Ward name of the user */
  ward_name: Scalars['String']['input'];
};

export type CreateNotificationMessageInput = {
  /** message of notification */
  content: Scalars['String']['input'];
  /** icon of notification */
  icon?: InputMaybe<Scalars['String']['input']>;
  /** url of notification */
  link: Scalars['String']['input'];
  /** title */
  title: Scalars['String']['input'];
  /** type of notification */
  type_notification: TypeNotificationEnum;
};

export type CreateQuestionRequest = {
  customerId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  productId: Scalars['Int']['input'];
  question: Scalars['String']['input'];
  source: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateQuestionResponse = {
  __typename?: 'CreateQuestionResponse';
  result: Scalars['Boolean']['output'];
};

export type CreateReviewRequest = {
  /** Detail */
  detail: Scalars['String']['input'];
  /** Did Customer order the product */
  is_ordered_customer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nick name */
  nickname: Scalars['String']['input'];
  /** Rating code */
  rating_code?: InputMaybe<Scalars['String']['input']>;
  /** Product SKU */
  sku: Scalars['String']['input'];
  /** Source id */
  source_id?: InputMaybe<Scalars['Int']['input']>;
  /** Store code */
  store_code: Scalars['String']['input'];
  /** Title */
  title: Scalars['String']['input'];
  /** Value */
  value: Scalars['Float']['input'];
};

/** Contains credit memo details. */
export type CreditMemo = {
  __typename?: 'CreditMemo';
  /** Comments on the credit memo. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `CreditMemo` object. */
  id: Scalars['ID']['output'];
  /** An array containing details about refunded items. */
  items?: Maybe<Array<Maybe<CreditMemoItemInterface>>>;
  /** The sequential credit memo number. */
  number: Scalars['String']['output'];
  /** Details about the total refunded amount. */
  total?: Maybe<CreditMemoTotal>;
};

/** Credit memo item details. */
export type CreditMemoItemInterface = {
  /** Details about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for a `CreditMemoItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item the credit memo is applied to. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
};

/** Contains credit memo price details. */
export type CreditMemoTotal = {
  __typename?: 'CreditMemoTotal';
  /** An adjustment manually applied to the order. */
  adjustment: Money;
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the credit memo. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the credit memo. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The credit memo tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the credit memo. */
  total_shipping: Money;
  /** The amount of tax applied to the credit memo. */
  total_tax: Money;
};

export type Currency = {
  __typename?: 'Currency';
  available_currency_codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  base_currency_code?: Maybe<Scalars['String']['output']>;
  base_currency_symbol?: Maybe<Scalars['String']['output']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_code`. */
  default_display_currecy_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Symbol was missed. Use `default_display_currency_symbol`. */
  default_display_currecy_symbol?: Maybe<Scalars['String']['output']>;
  default_display_currency_code?: Maybe<Scalars['String']['output']>;
  default_display_currency_symbol?: Maybe<Scalars['String']['output']>;
  exchange_rates?: Maybe<Array<Maybe<ExchangeRate>>>;
};

/** The list of available currency codes */
export enum CurrencyEnum {
  /** @deprecated  */
  Aed = 'AED',
  /** @deprecated  */
  Afn = 'AFN',
  /** @deprecated  */
  All = 'ALL',
  /** @deprecated  */
  Amd = 'AMD',
  /** @deprecated  */
  Ang = 'ANG',
  /** @deprecated  */
  Aoa = 'AOA',
  /** @deprecated  */
  Ars = 'ARS',
  /** @deprecated  */
  Aud = 'AUD',
  /** @deprecated  */
  Awg = 'AWG',
  /** @deprecated  */
  Azm = 'AZM',
  /** @deprecated  */
  Azn = 'AZN',
  /** @deprecated  */
  Bam = 'BAM',
  /** @deprecated  */
  Bbd = 'BBD',
  /** @deprecated  */
  Bdt = 'BDT',
  /** @deprecated  */
  Bgn = 'BGN',
  /** @deprecated  */
  Bhd = 'BHD',
  /** @deprecated  */
  Bif = 'BIF',
  /** @deprecated  */
  Bmd = 'BMD',
  /** @deprecated  */
  Bnd = 'BND',
  /** @deprecated  */
  Bob = 'BOB',
  /** @deprecated  */
  Brl = 'BRL',
  /** @deprecated  */
  Bsd = 'BSD',
  /** @deprecated  */
  Btn = 'BTN',
  /** @deprecated  */
  Buk = 'BUK',
  /** @deprecated  */
  Bwp = 'BWP',
  /** @deprecated  */
  Byr = 'BYR',
  /** @deprecated  */
  Bzd = 'BZD',
  /** @deprecated  */
  Cad = 'CAD',
  /** @deprecated  */
  Cdf = 'CDF',
  /** @deprecated  */
  Che = 'CHE',
  /** @deprecated  */
  Chf = 'CHF',
  /** @deprecated  */
  Chw = 'CHW',
  /** @deprecated  */
  Clp = 'CLP',
  /** @deprecated  */
  Cny = 'CNY',
  /** @deprecated  */
  Cop = 'COP',
  /** @deprecated  */
  Crc = 'CRC',
  /** @deprecated  */
  Cup = 'CUP',
  /** @deprecated  */
  Cve = 'CVE',
  /** @deprecated  */
  Czk = 'CZK',
  /** @deprecated  */
  Djf = 'DJF',
  /** @deprecated  */
  Dkk = 'DKK',
  /** @deprecated  */
  Dop = 'DOP',
  /** @deprecated  */
  Dzd = 'DZD',
  /** @deprecated  */
  Eek = 'EEK',
  /** @deprecated  */
  Egp = 'EGP',
  /** @deprecated  */
  Ern = 'ERN',
  /** @deprecated  */
  Etb = 'ETB',
  /** @deprecated  */
  Eur = 'EUR',
  /** @deprecated  */
  Fjd = 'FJD',
  /** @deprecated  */
  Fkp = 'FKP',
  /** @deprecated  */
  Gbp = 'GBP',
  /** @deprecated  */
  Gek = 'GEK',
  /** @deprecated  */
  Gel = 'GEL',
  /** @deprecated  */
  Ghs = 'GHS',
  /** @deprecated  */
  Gip = 'GIP',
  /** @deprecated  */
  Gmd = 'GMD',
  /** @deprecated  */
  Gnf = 'GNF',
  /** @deprecated  */
  Gqe = 'GQE',
  /** @deprecated  */
  Gtq = 'GTQ',
  /** @deprecated  */
  Gyd = 'GYD',
  /** @deprecated  */
  Hkd = 'HKD',
  /** @deprecated  */
  Hnl = 'HNL',
  /** @deprecated  */
  Hrk = 'HRK',
  /** @deprecated  */
  Htg = 'HTG',
  /** @deprecated  */
  Huf = 'HUF',
  /** @deprecated  */
  Idr = 'IDR',
  /** @deprecated  */
  Ils = 'ILS',
  /** @deprecated  */
  Inr = 'INR',
  /** @deprecated  */
  Iqd = 'IQD',
  /** @deprecated  */
  Irr = 'IRR',
  /** @deprecated  */
  Isk = 'ISK',
  /** @deprecated  */
  Jmd = 'JMD',
  /** @deprecated  */
  Jod = 'JOD',
  /** @deprecated  */
  Jpy = 'JPY',
  /** @deprecated  */
  Kes = 'KES',
  /** @deprecated  */
  Kgs = 'KGS',
  /** @deprecated  */
  Khr = 'KHR',
  /** @deprecated  */
  Kmf = 'KMF',
  /** @deprecated  */
  Kpw = 'KPW',
  /** @deprecated  */
  Krw = 'KRW',
  /** @deprecated  */
  Kwd = 'KWD',
  /** @deprecated  */
  Kyd = 'KYD',
  /** @deprecated  */
  Kzt = 'KZT',
  /** @deprecated  */
  Lak = 'LAK',
  /** @deprecated  */
  Lbp = 'LBP',
  /** @deprecated  */
  Lkr = 'LKR',
  /** @deprecated  */
  Lrd = 'LRD',
  /** @deprecated  */
  Lsl = 'LSL',
  /** @deprecated  */
  Lsm = 'LSM',
  /** @deprecated  */
  Ltl = 'LTL',
  /** @deprecated  */
  Lvl = 'LVL',
  /** @deprecated  */
  Lyd = 'LYD',
  /** @deprecated  */
  Mad = 'MAD',
  /** @deprecated  */
  Mdl = 'MDL',
  /** @deprecated  */
  Mga = 'MGA',
  /** @deprecated  */
  Mkd = 'MKD',
  /** @deprecated  */
  Mmk = 'MMK',
  /** @deprecated  */
  Mnt = 'MNT',
  /** @deprecated  */
  Mop = 'MOP',
  /** @deprecated  */
  Mro = 'MRO',
  /** @deprecated  */
  Mur = 'MUR',
  /** @deprecated  */
  Mvr = 'MVR',
  /** @deprecated  */
  Mwk = 'MWK',
  /** @deprecated  */
  Mxn = 'MXN',
  /** @deprecated  */
  Myr = 'MYR',
  /** @deprecated  */
  Mzn = 'MZN',
  /** @deprecated  */
  Nad = 'NAD',
  /** @deprecated  */
  Ngn = 'NGN',
  /** @deprecated  */
  Nic = 'NIC',
  /** @deprecated  */
  Nok = 'NOK',
  /** @deprecated  */
  Npr = 'NPR',
  /** @deprecated  */
  Nzd = 'NZD',
  /** @deprecated  */
  Omr = 'OMR',
  /** @deprecated  */
  Pab = 'PAB',
  /** @deprecated  */
  Pen = 'PEN',
  /** @deprecated  */
  Pgk = 'PGK',
  /** @deprecated  */
  Php = 'PHP',
  /** @deprecated  */
  Pkr = 'PKR',
  /** @deprecated  */
  Pln = 'PLN',
  /** @deprecated  */
  Pyg = 'PYG',
  /** @deprecated  */
  Qar = 'QAR',
  /** @deprecated  */
  Rhd = 'RHD',
  /** @deprecated  */
  Rol = 'ROL',
  /** @deprecated  */
  Ron = 'RON',
  /** @deprecated  */
  Rsd = 'RSD',
  /** @deprecated  */
  Rub = 'RUB',
  /** @deprecated  */
  Rwf = 'RWF',
  /** @deprecated  */
  Sar = 'SAR',
  /** @deprecated  */
  Sbd = 'SBD',
  /** @deprecated  */
  Scr = 'SCR',
  /** @deprecated  */
  Sdg = 'SDG',
  /** @deprecated  */
  Sek = 'SEK',
  /** @deprecated  */
  Sgd = 'SGD',
  /** @deprecated  */
  Shp = 'SHP',
  /** @deprecated  */
  Skk = 'SKK',
  /** @deprecated  */
  Sll = 'SLL',
  /** @deprecated  */
  Sos = 'SOS',
  /** @deprecated  */
  Srd = 'SRD',
  /** @deprecated  */
  Std = 'STD',
  /** @deprecated  */
  Svc = 'SVC',
  /** @deprecated  */
  Syp = 'SYP',
  /** @deprecated  */
  Szl = 'SZL',
  /** @deprecated  */
  Thb = 'THB',
  /** @deprecated  */
  Tjs = 'TJS',
  /** @deprecated  */
  Tmm = 'TMM',
  /** @deprecated  */
  Tnd = 'TND',
  /** @deprecated  */
  Top = 'TOP',
  /** @deprecated  */
  Trl = 'TRL',
  /** @deprecated  */
  Try = 'TRY',
  /** @deprecated  */
  Ttd = 'TTD',
  /** @deprecated  */
  Twd = 'TWD',
  /** @deprecated  */
  Tzs = 'TZS',
  /** @deprecated  */
  Uah = 'UAH',
  /** @deprecated  */
  Ugx = 'UGX',
  /** @deprecated  */
  Usd = 'USD',
  /** @deprecated  */
  Uyu = 'UYU',
  /** @deprecated  */
  Uzs = 'UZS',
  /** @deprecated  */
  Veb = 'VEB',
  /** @deprecated  */
  Vef = 'VEF',
  /** @deprecated  */
  Vnd = 'VND',
  /** @deprecated  */
  Vuv = 'VUV',
  /** @deprecated  */
  Wst = 'WST',
  /** @deprecated  */
  Xcd = 'XCD',
  /** @deprecated  */
  Xof = 'XOF',
  /** @deprecated  */
  Xpf = 'XPF',
  /** @deprecated  */
  Yer = 'YER',
  /** @deprecated  */
  Ytl = 'YTL',
  /** @deprecated  */
  Zar = 'ZAR',
  /** @deprecated  */
  Zmk = 'ZMK',
  /** @deprecated  */
  Zwd = 'ZWD'
}

/** CustomAttributeMetadata defines an array of attribute_codes and entity_types */
export type CustomAttributeMetadata = {
  __typename?: 'CustomAttributeMetadata';
  /** An array of attributes */
  items?: Maybe<Array<Maybe<Attribute>>>;
};

export type Customer = {
  __typename?: 'Customer';
  /** An array containing the customer's shipping and billing addresses */
  addresses?: Maybe<Array<Maybe<CustomerAddress>>>;
  /** Timestamp indicating when the account was created */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The customer's date of birth */
  date_of_birth?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the billing address */
  default_billing?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the shipping address */
  default_shipping?: Maybe<Scalars['String']['output']>;
  /**
   * The customer's date of birth
   * @deprecated Use `date_of_birth` instead
   */
  dob?: Maybe<Scalars['String']['output']>;
  /** The customer's email address. Required */
  email?: Maybe<Scalars['String']['output']>;
  faq?: Maybe<CustomerFaq>;
  /** The customer's first name */
  firstname?: Maybe<Scalars['String']['output']>;
  /** The customer's gender (Male - 1, Female - 2) */
  gender?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Customer group should not be exposed in the storefront scenarios */
  group_id?: Maybe<Scalars['Int']['output']>;
  /**
   * The ID assigned to the customer
   * @deprecated id is not needed as part of Customer because on server side it can be identified based on customer token used for authentication. There is no need to know customer ID on the client side.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the customer is subscribed to the company's newsletter */
  is_subscribed?: Maybe<Scalars['Boolean']['output']>;
  /** The customer's family name */
  lastname?: Maybe<Scalars['String']['output']>;
  /** The customer's middle name */
  middlename?: Maybe<Scalars['String']['output']>;
  order_reviews?: Maybe<MyOrderReviews>;
  orders?: Maybe<CustomerOrders>;
  phone_number: Scalars['String']['output'];
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  questions?: Maybe<CustomerQuestions>;
  /** The rank of customer. */
  rank?: Maybe<Scalars['String']['output']>;
  /** Referral Code */
  referral_code?: Maybe<Scalars['String']['output']>;
  reviews?: Maybe<CustomerReviewsResponse>;
  search_keywords_history?: Maybe<Array<SearchKeywordHistory>>;
  /** A value such as Sr., Jr., or III */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers) */
  taxvat?: Maybe<Scalars['String']['output']>;
  /** The wishlist query returns the contents of a customer's wish lists */
  wishlist: Wishlist;
};


export type CustomerFaqArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerOrder_ReviewsArgs = {
  filter?: InputMaybe<MyOrderReviewFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerOrdersArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<CustomerOrdersFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<ScopeTypeEnum>;
  sort?: InputMaybe<CustomerOrderSortInput>;
};


export type CustomerQuestionsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


export type CustomerReviewsArgs = {
  filter: CustomerReviewFilterInput;
};

/** CustomerAddress contains detailed information about a customer's billing and shipping addresses */
export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  /** Address Type */
  address_type?: Maybe<Scalars['String']['output']>;
  /** The city or town */
  city?: Maybe<Scalars['String']['output']>;
  /** The customer's company */
  company?: Maybe<Scalars['String']['output']>;
  /** The customer's country */
  country_code?: Maybe<CountryCodeEnum>;
  /**
   * The customer's country
   * @deprecated Use `country_code` instead.
   */
  country_id?: Maybe<Scalars['String']['output']>;
  /** @deprecated Custom attributes should not be put into container */
  custom_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /**
   * The customer ID
   * @deprecated customer_id is not needed as part of CustomerAddress, address ID (id) is unique identifier for the addresses.
   */
  customer_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the address is the default billing address */
  default_billing?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the address is the default shipping address */
  default_shipping?: Maybe<Scalars['Boolean']['output']>;
  /** District Name */
  district?: Maybe<Scalars['String']['output']>;
  /** District ID */
  district_id?: Maybe<Scalars['Int']['output']>;
  /** Address extension attributes */
  extension_attributes?: Maybe<Array<Maybe<CustomerAddressAttribute>>>;
  /** The fax number */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the person associated with the shipping/billing address */
  firstname?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the address object */
  id?: Maybe<Scalars['Int']['output']>;
  /** The invoice company address of customer. */
  invoice_company_address?: Maybe<Scalars['String']['output']>;
  /** The invoice company name of customer. */
  invoice_company_name?: Maybe<Scalars['String']['output']>;
  /** The invoice vat id of customer. */
  invoice_vat_id?: Maybe<Scalars['String']['output']>;
  /** The family name of the person associated with the shipping/billing address */
  lastname?: Maybe<Scalars['String']['output']>;
  /** The middle name of the person associated with the shipping/billing address */
  middlename?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** An object containing the region name, region code, and region ID */
  region?: Maybe<CustomerAddressRegion>;
  /** @deprecated Region ID is excessive on storefront and region code should suffice for all scenarios */
  region_id?: Maybe<Scalars['Int']['output']>;
  /** An array of strings that define the street number and name */
  street?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A value such as Sr., Jr., or III */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The telephone number */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers) */
  vat_id?: Maybe<Scalars['String']['output']>;
  /** Ward Name */
  ward?: Maybe<Scalars['String']['output']>;
  /** Ward ID */
  ward_id?: Maybe<Scalars['Int']['output']>;
};

export type CustomerAddressAttribute = {
  __typename?: 'CustomerAddressAttribute';
  /** Attribute code */
  attribute_code?: Maybe<Scalars['String']['output']>;
  /** Attribute value */
  value?: Maybe<Scalars['String']['output']>;
};

export type CustomerAddressAttributeInput = {
  /** Attribute code */
  attribute_code: Scalars['String']['input'];
  /** Attribute value */
  value: Scalars['String']['input'];
};

export type CustomerAddressInput = {
  /** The address type. */
  address_type?: InputMaybe<AddressTypeEnum>;
  /** The city or town */
  city?: InputMaybe<Scalars['String']['input']>;
  /** The customer's company */
  company?: InputMaybe<Scalars['String']['input']>;
  /** The customer's country */
  country_code?: InputMaybe<CountryCodeEnum>;
  /** Deprecated: use `country_code` instead. */
  country_id?: InputMaybe<CountryCodeEnum>;
  /** Deprecated: Custom attributes should not be put into container. */
  custom_attributes?: InputMaybe<Array<InputMaybe<CustomerAddressAttributeInput>>>;
  /** Indicates whether the address is the default billing address */
  default_billing?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the address is the default shipping address */
  default_shipping?: InputMaybe<Scalars['Boolean']['input']>;
  /** The district name. */
  district?: InputMaybe<Scalars['String']['input']>;
  /** The district id. */
  district_id?: InputMaybe<Scalars['Int']['input']>;
  /** The fax number */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** The first name of the person associated with the shipping/billing address */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** The invoice company address of customer. */
  invoice_company_address?: InputMaybe<Scalars['String']['input']>;
  /** The invoice company name of customer. */
  invoice_company_name?: InputMaybe<Scalars['String']['input']>;
  /** The invoice vat id of customer. */
  invoice_vat_id?: InputMaybe<Scalars['String']['input']>;
  /** The family name of the person associated with the shipping/billing address */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** The middle name of the person associated with the shipping/billing address */
  middlename?: InputMaybe<Scalars['String']['input']>;
  /** The customer's ZIP or postal code */
  postcode?: InputMaybe<Scalars['String']['input']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** An object containing the region name, region code, and region ID */
  region?: InputMaybe<CustomerAddressRegionInput>;
  /** An array of strings that define the street number and name */
  street?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A value such as Sr., Jr., or III */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** The telephone number */
  telephone?: InputMaybe<Scalars['String']['input']>;
  /** The customer's Tax/VAT number (for corporate customers) */
  vat_id?: InputMaybe<Scalars['String']['input']>;
  /** The ward name. */
  ward?: InputMaybe<Scalars['String']['input']>;
  /** The ward id. */
  ward_id?: InputMaybe<Scalars['Int']['input']>;
};

/** CustomerAddressRegion defines the customer's state or province */
export type CustomerAddressRegion = {
  __typename?: 'CustomerAddressRegion';
  /** The state or province name */
  region?: Maybe<Scalars['String']['output']>;
  /** The address region code */
  region_code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Region ID is excessive on storefront and region code should suffice for all scenarios */
  region_id?: Maybe<Scalars['Int']['output']>;
};

export type CustomerAddressRegionInput = {
  /** The state or province name */
  region?: InputMaybe<Scalars['String']['input']>;
  /** The address region code */
  region_code?: InputMaybe<Scalars['String']['input']>;
  /** region_id is deprecated. Region ID is excessive on storefront and region code should suffice for all scenarios */
  region_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerDownloadableProduct = {
  __typename?: 'CustomerDownloadableProduct';
  date?: Maybe<Scalars['String']['output']>;
  download_url?: Maybe<Scalars['String']['output']>;
  order_increment_id?: Maybe<Scalars['String']['output']>;
  remaining_downloads?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CustomerDownloadableProducts = {
  __typename?: 'CustomerDownloadableProducts';
  /** List of purchased downloadable items */
  items?: Maybe<Array<Maybe<CustomerDownloadableProduct>>>;
};

export type CustomerFaq = {
  __typename?: 'CustomerFaq';
  data?: Maybe<Array<Maybe<CustomerFaqData>>>;
  pagination_metadata?: Maybe<PaginationData>;
};

export type CustomerFaqData = {
  __typename?: 'CustomerFaqData';
  content?: Maybe<Scalars['String']['output']>;
  create_at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  item?: Maybe<FaqItem>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['Int']['output']>;
};

export type CustomerInformation = {
  __typename?: 'CustomerInformation';
  profile?: Maybe<CustomerProfile>;
};

export type CustomerInput = {
  /** The customer's first name */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's family name */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** The customer's middle name */
  middlename?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerKicoin = {
  __typename?: 'CustomerKicoin';
  available?: Maybe<Scalars['Int']['output']>;
  balance?: Maybe<Scalars['Int']['output']>;
};

/** Contains details about each of the customer's orders. */
export type CustomerOrder = {
  __typename?: 'CustomerOrder';
  /** The billing address for the order. */
  billing_address?: Maybe<OrderAddress>;
  /** The shipping carrier for the order delivery. */
  carrier?: Maybe<Scalars['String']['output']>;
  /** Comments about the order. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** @deprecated Use the `order_date` field instead. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** A list of credit memos. */
  credit_memos?: Maybe<Array<Maybe<CreditMemo>>>;
  /** @deprecated Use the `totals.grand_total` field instead. */
  grand_total?: Maybe<Scalars['Float']['output']>;
  /** The unique ID for a `CustomerOrder` object. */
  id: Scalars['ID']['output'];
  /** @deprecated Use the `id` field instead. */
  increment_id?: Maybe<Scalars['String']['output']>;
  /** A list of invoices for the order. */
  invoices: Array<Maybe<Invoice>>;
  /** An array containing the items purchased in this order. */
  items?: Maybe<Array<Maybe<OrderItemInterface>>>;
  /** The order number. */
  number: Scalars['String']['output'];
  /** The date the order was placed. */
  order_date: Scalars['String']['output'];
  /**
   * The order number
   * @deprecated Use the `number` field instead.
   */
  order_number: Scalars['String']['output'];
  /** Payment details for the order. */
  payment_methods?: Maybe<Array<Maybe<OrderPaymentMethod>>>;
  /** A list of shipments for the order. */
  shipments?: Maybe<Array<Maybe<OrderShipment>>>;
  /** The shipping address for the order. */
  shipping_address?: Maybe<OrderAddress>;
  /** The delivery method for the order. */
  shipping_method?: Maybe<Scalars['String']['output']>;
  /** The current status of the order. */
  status: Scalars['String']['output'];
  /** The status code of the order. */
  status_code?: Maybe<Scalars['String']['output']>;
  /** The status history of this order, including timeline and available statuses. */
  status_history?: Maybe<OrderStatusHistory>;
  /** Details about the calculated totals for this order. */
  total?: Maybe<OrderTotal>;
};

export type CustomerOrderFilterV2 = {
  order_number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** CustomerOrderSortInput specifies the field to use for sorting search results and indicates whether the results are sorted in ascending or descending order. */
export type CustomerOrderSortInput = {
  /** This enumeration indicates whether to return results in ascending or descending order */
  sort_direction: SortEnum;
  /** Specifies the field to use for sorting */
  sort_field: CustomerOrderSortableField;
};

/** Specifies the field to use for sorting */
export enum CustomerOrderSortableField {
  /**
   * Sorts customer orders by created_at field
   * @deprecated
   */
  CreatedAt = 'CREATED_AT',
  /**
   * Sorts customer orders by number
   * @deprecated
   */
  Number = 'NUMBER'
}

/** The collection of orders that match the conditions defined in the filter. */
export type CustomerOrders = {
  __typename?: 'CustomerOrders';
  /** An array of customer orders. */
  items: Array<Maybe<CustomerOrder>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The total count of customer orders. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Identifies the filter to use for filtering orders. */
export type CustomerOrdersFilterInput = {
  /** Filters by order ID. */
  id?: InputMaybe<FilterEqualTypeInput>;
  /** Filters by order number. */
  number?: InputMaybe<FilterStringTypeInput>;
  /** Filters by order status. */
  status?: InputMaybe<FilterEqualTypeInput>;
};

/** The collection of orders that match the conditions defined in the filter. */
export type CustomerOrdersV2 = {
  __typename?: 'CustomerOrdersV2';
  /** An array of customer orders. */
  items: Array<Maybe<CustomerOrder>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<PageInfo>;
};

export type CustomerOutput = {
  __typename?: 'CustomerOutput';
  customer: Customer;
};

export type CustomerPaymentTokens = {
  __typename?: 'CustomerPaymentTokens';
  /** An array of payment tokens */
  items: Array<Maybe<PaymentToken>>;
};

export type CustomerProfile = {
  __typename?: 'CustomerProfile';
  /** App avatar */
  avatar?: Maybe<Scalars['String']['output']>;
  /** Customer email */
  email?: Maybe<Scalars['String']['output']>;
  /** The customer's first name */
  first_name?: Maybe<Scalars['String']['output']>;
  /** Profile id */
  id?: Maybe<Scalars['String']['output']>;
  /** The customer's family name */
  last_name?: Maybe<Scalars['String']['output']>;
  /** Customer phone number */
  phone_number?: Maybe<Scalars['String']['output']>;
};

export type CustomerProfileInput = {
  /** App avatar */
  avatar?: InputMaybe<Scalars['String']['input']>;
  /** The customer's first name */
  first_name?: InputMaybe<Scalars['String']['input']>;
  /** The customer's family name */
  last_name?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerProfileSign = {
  __typename?: 'CustomerProfileSign';
  id?: Maybe<Scalars['String']['output']>;
  sign?: Maybe<Scalars['String']['output']>;
};

export type CustomerQuestion = {
  __typename?: 'CustomerQuestion';
  product?: Maybe<ProductInterface>;
  question: FaqQuestion;
};

export type CustomerQuestions = {
  __typename?: 'CustomerQuestions';
  items: Array<Maybe<CustomerQuestion>>;
  page_info: PageInfo;
};

export type CustomerReferralCodeInput = {
  code: Scalars['String']['input'];
  salt: Scalars['String']['input'];
  sign: Scalars['String']['input'];
};

export type CustomerReferralCodeSignature = {
  __typename?: 'CustomerReferralCodeSignature';
  /** salt for security purpose */
  salt: Scalars['String']['output'];
  /** Sign for security purpose */
  sign: Scalars['String']['output'];
};

export type CustomerReviewFilterInput = {
  /** Current page */
  current_page?: InputMaybe<Scalars['Int']['input']>;
  /** Page size */
  page_size?: InputMaybe<Scalars['Int']['input']>;
  /** status of review */
  status_code?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerReviewsResponse = {
  __typename?: 'CustomerReviewsResponse';
  /** customer reviews */
  items?: Maybe<Array<Maybe<Review>>>;
  /** An object that includes the page_info and currentPage values specified in the query */
  page_info?: Maybe<PageInfo>;
  /** The number of reviews returned that match specified filter criteria */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type CustomerToken = {
  __typename?: 'CustomerToken';
  /** The customer token */
  access_token?: Maybe<Scalars['String']['output']>;
  expires_in?: Maybe<Scalars['Int']['output']>;
  id_token?: Maybe<Scalars['String']['output']>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
};

export type CustomizableOptionInput = {
  id: Scalars['Int']['input'];
  value_string: Scalars['String']['input'];
};

/** The CustomizableOptionInterface contains basic information about a customizable option. It can be implemented by several types of configurable options. */
export type CustomizableOptionInterface = {
  /** Option ID. */
  option_id?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the option is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The order in which the option is displayed. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name for this option. */
  title?: Maybe<Scalars['String']['output']>;
};

/** CustomizableProductInterface contains information about customizable product options. */
export type CustomizableProductInterface = {
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
};

export type DeletePaymentTokenOutput = {
  __typename?: 'DeletePaymentTokenOutput';
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  result: Scalars['Boolean']['output'];
};

export type DeliveryTime = {
  __typename?: 'DeliveryTime';
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DeviceRequestInput = {
  /** Device App Version */
  device_app_version: Scalars['String']['input'];
  /** Device ID */
  device_id: Scalars['String']['input'];
  /** Device Name */
  device_name: Scalars['String']['input'];
  /** Device OS */
  device_os: Scalars['String']['input'];
  /** Device OS Version */
  device_os_version: Scalars['String']['input'];
  /** Device Type ios | android */
  device_type: Scalars['String']['input'];
  /** Device Push Token */
  push_token: Scalars['String']['input'];
  /** Device Push User ID */
  user_id: Scalars['String']['input'];
};

/** Defines an individual discount. A discount can be applied to the cart as a whole or to an item. */
export type Discount = {
  __typename?: 'Discount';
  /** The amount of the discount */
  amount: Money;
  /** A description of the discount */
  label: Scalars['String']['output'];
};

export type DiscountKicoins = {
  __typename?: 'DiscountKicoins';
  title?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type District = {
  __typename?: 'District';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region_code: Scalars['String']['output'];
  region_id: Scalars['Int']['output'];
};

/** Downloadable Cart Item */
export type DownloadableCartItem = CartItemInterface & {
  __typename?: 'DownloadableCartItem';
  customizable_options?: Maybe<Array<Maybe<SelectedCustomizableOption>>>;
  id: Scalars['String']['output'];
  /** An array containing information about the links for the added to cart downloadable product */
  links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
  /** DownloadableProductSamples defines characteristics of a downloadable product */
  samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
};

export enum DownloadableFileTypeEnum {
  /** @deprecated `sample_url` serves to get the downloadable sample */
  File = 'FILE',
  /** @deprecated `sample_url` serves to get the downloadable sample */
  Url = 'URL'
}

/** DownloadableProduct defines a product that the customer downloads */
export type DownloadableProduct = CustomizableProductInterface & ProductInterface & {
  __typename?: 'DownloadableProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  /** An array containing information about the links for this downloadable product */
  downloadable_product_links?: Maybe<Array<Maybe<DownloadableProductLinks>>>;
  /** An array containing information about samples of this downloadable product. */
  downloadable_product_samples?: Maybe<Array<Maybe<DownloadableProductSamples>>>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  /** A value of 1 indicates that each link in the array must be purchased separately */
  links_purchased_separately?: Maybe<Scalars['Int']['output']>;
  /** The heading above the list of downloadable products */
  links_title?: Maybe<Scalars['String']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

export type DownloadableProductCartItemInput = {
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  data: CartItemInput;
  downloadable_product_links?: InputMaybe<Array<InputMaybe<DownloadableProductLinksInput>>>;
};

/** DownloadableProductLinks defines characteristics of a downloadable product */
export type DownloadableProductLinks = {
  __typename?: 'DownloadableProductLinks';
  /** @deprecated This information should not be exposed on frontend */
  id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated This information should not be exposed on frontend */
  is_shareable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  link_type?: Maybe<DownloadableFileTypeEnum>;
  /** @deprecated This information should not be exposed on frontend */
  number_of_downloads?: Maybe<Scalars['Int']['output']>;
  /** The price of the downloadable product */
  price?: Maybe<Scalars['Float']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** URL to the downloadable sample */
  sample_url?: Maybe<Scalars['String']['output']>;
  /** A number indicating the sort order */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name of the link */
  title?: Maybe<Scalars['String']['output']>;
};

export type DownloadableProductLinksInput = {
  link_id: Scalars['Int']['input'];
};

/** DownloadableProductSamples defines characteristics of a downloadable product */
export type DownloadableProductSamples = {
  __typename?: 'DownloadableProductSamples';
  /** @deprecated This information should not be exposed on frontend */
  id?: Maybe<Scalars['Int']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_file?: Maybe<Scalars['String']['output']>;
  /** @deprecated `sample_url` serves to get the downloadable sample */
  sample_type?: Maybe<DownloadableFileTypeEnum>;
  /** URL to the downloadable sample */
  sample_url?: Maybe<Scalars['String']['output']>;
  /** A number indicating the sort order */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The display name of the sample */
  title?: Maybe<Scalars['String']['output']>;
};

export type EnabledPaymentMethod = {
  __typename?: 'EnabledPaymentMethod';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  instruction?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** EntityUrl is an output object containing the `id`, `relative_url`, and `type` attributes */
export type EntityUrl = {
  __typename?: 'EntityUrl';
  /** @deprecated The canonical_url field is deprecated, use relative_url instead. */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The ID assigned to the object associated with the specified url. This could be a product ID, category ID, or page ID. */
  id?: Maybe<Scalars['Int']['output']>;
  /** 301 or 302 HTTP code for url permanent or temporary redirect or 0 for the 200 no redirect */
  redirectCode?: Maybe<Scalars['Int']['output']>;
  /** The internal relative URL. If the specified  url is a redirect, the query returns the redirected URL, not the original. */
  relative_url?: Maybe<Scalars['String']['output']>;
  /** One of PRODUCT, CATEGORY, or CMS_PAGE. */
  type?: Maybe<UrlRewriteEntityTypeEnum>;
  /** The ID is encoded. */
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Unique identifier for the activity */
export type EventActivity = {
  __typename?: 'EventActivity';
  /** Code of the activity */
  code: Scalars['String']['output'];
  /** Description of the activity */
  description?: Maybe<Scalars['String']['output']>;
  /** End time of the activity */
  end_time: Scalars['String']['output'];
  /** Unique identifier for the activity */
  id: Scalars['ID']['output'];
  /** Is the activity is open for register */
  is_open_for_register: Scalars['Boolean']['output'];
  /** Name of the activity */
  name: Scalars['String']['output'];
  /** Region ID of the activity */
  region_id: Scalars['Int']['output'];
  /** Position in activity group */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** Start time of the activity */
  start_time: Scalars['String']['output'];
};

export type EventActivityGroup = {
  __typename?: 'EventActivityGroup';
  activities?: Maybe<Array<Maybe<EventActivity>>>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sort_order: Scalars['Int']['output'];
};

/** Unique identifier for the attribute */
export type EventAttribute = {
  __typename?: 'EventAttribute';
  /** Code of the attribute */
  code: Scalars['String']['output'];
  /** Unique identifier for the attribute */
  id: Scalars['ID']['output'];
  /** Name of the attribute */
  name: Scalars['String']['output'];
  /** Type of the attribute */
  type: Scalars['String']['output'];
};

export type EventContextInput = {
  app_instance_id?: InputMaybe<Scalars['String']['input']>;
  client_id?: InputMaybe<Scalars['String']['input']>;
  event_id?: InputMaybe<Scalars['String']['input']>;
  screen?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type EventDataInput = {
  /** device information */
  deviceRequest?: InputMaybe<DeviceRequestInput>;
  nonce: Scalars['String']['input'];
  sign: Scalars['String']['input'];
};

/** Unique identifier for the event */
export type EventEntity = {
  __typename?: 'EventEntity';
  /** Description of the event */
  description?: Maybe<Scalars['String']['output']>;
  /** End time of the event */
  end_time: Scalars['String']['output'];
  /** Unique identifier for the event */
  id: Scalars['ID']['output'];
  /** Name of the event */
  name: Scalars['String']['output'];
  /** Region ID of the event */
  region_id: Scalars['Int']['output'];
  /** Start time of the event */
  start_time: Scalars['String']['output'];
  /** total number of users of the event */
  users_count: Scalars['Int']['output'];
};

/** Unique identifier for the registration */
export type EventRegistration = {
  __typename?: 'EventRegistration';
  /** Activities associated with the registration */
  activity: EventActivity;
  /** Whether the user agreed to the terms */
  agreed_terms: Scalars['Boolean']['output'];
  /** Creation timestamp */
  created_at: Scalars['String']['output'];
  /** Event associated with the registration */
  event: EventEntity;
  /** Unique identifier for the registration */
  id: Scalars['ID']['output'];
  registration_details?: Maybe<Array<EventRegistrationDetails>>;
  /** Last update timestamp */
  updated_at: Scalars['String']['output'];
  /** User associated with the registration */
  user: EventUser;
};

/** Unique identifier for the registration details */
export type EventRegistrationDetails = {
  __typename?: 'EventRegistrationDetails';
  /** Path to the birth certificate image */
  birth_certificate_image?: Maybe<Scalars['String']['output']>;
  /** Birth date of the registrant */
  birth_date?: Maybe<Scalars['String']['output']>;
  /** District ID of the registrant */
  district_id: Scalars['Int']['output'];
  /** District name of the user */
  district_name: Scalars['String']['output'];
  /** Due date for the registration */
  due_date?: Maybe<Scalars['String']['output']>;
  /** Email address of the registrant */
  email: Scalars['String']['output'];
  /** Full name of the registrant */
  full_name: Scalars['String']['output'];
  /** Guardian's name */
  guardian_name?: Maybe<Scalars['String']['output']>;
  /** Guardian's phone number */
  guardian_phone_number?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the registration details */
  id: Scalars['ID']['output'];
  /** Phone number of the registrant */
  phone_number: Scalars['String']['output'];
  /** Path to the prenatal checkup image */
  prenatal_checkup_image?: Maybe<Scalars['String']['output']>;
  /** Region ID of the registrant */
  region_id: Scalars['Int']['output'];
  /** Region name of the user */
  region_name: Scalars['String']['output'];
  /** Registration associated with the details */
  registration: EventRegistration;
  /** Specific address of the registrant */
  specific_address: Scalars['String']['output'];
  /** Store code where the registrant will exchange the event ticket */
  ticket_exchange_store_code?: Maybe<Scalars['String']['output']>;
  /** Store name where the registrant will exchange the event ticket */
  ticket_exchange_store_name?: Maybe<Scalars['String']['output']>;
  /** Ward ID of the registrant */
  ward_id: Scalars['Int']['output'];
  /** Ward name of the user */
  ward_name: Scalars['String']['output'];
};

export enum EventTypeEnum {
  ActiveApp = 'ACTIVE_APP',
  Login = 'LOGIN',
  Register = 'REGISTER'
}

/** Unique identifier for the user */
export type EventUser = {
  __typename?: 'EventUser';
  /** Address of the user */
  address: Scalars['String']['output'];
  /** Birth date of the event user */
  birth_date?: Maybe<Scalars['String']['output']>;
  contacted_status?: Maybe<Scalars['String']['output']>;
  /** Creation timestamp */
  created_at: Scalars['String']['output'];
  /** District ID of the user */
  district_id: Scalars['Int']['output'];
  /** District name of the user */
  district_name: Scalars['String']['output'];
  /** Email address of the user */
  email: Scalars['String']['output'];
  /** Full name of the user */
  full_name: Scalars['String']['output'];
  /** Unique identifier for the user */
  id?: Maybe<Scalars['ID']['output']>;
  /** Participant type of the user */
  participant_type: ParticipantType;
  /** Phone number of the user */
  phone_number: Scalars['String']['output'];
  /** Referral code of the user */
  referral_code?: Maybe<Scalars['String']['output']>;
  /** Region ID of the user */
  region_id: Scalars['Int']['output'];
  /** Region name of the user */
  region_name: Scalars['String']['output'];
  /** Signature */
  signature?: Maybe<Scalars['String']['output']>;
  /** Specific address of the user */
  specific_address: Scalars['String']['output'];
  /** Last update timestamp */
  updated_at: Scalars['String']['output'];
  /** Unique identifier for the temporary user (before registration - initial user) */
  user_temporary_id: Scalars['ID']['output'];
  /** Ward ID of the user */
  ward_id: Scalars['Int']['output'];
  /** Ward name of the user */
  ward_name: Scalars['String']['output'];
};

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  currency_to?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
};

export type FaqAnswer = {
  __typename?: 'FaqAnswer';
  admin_answered?: Maybe<Array<Maybe<AdminAnswered>>>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type FaqArticle = {
  __typename?: 'FaqArticle';
  /** created at timestamp for the article FAQ */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Description of the article FAQ */
  description?: Maybe<Scalars['String']['output']>;
  /** Article Id of the category FAQ */
  id?: Maybe<Scalars['Int']['output']>;
  /** URL Image of the article FAQ */
  image?: Maybe<Scalars['String']['output']>;
  /** Short description of the article FAQ */
  short_description?: Maybe<Scalars['String']['output']>;
  /** Title of the article FAQ */
  title?: Maybe<Scalars['String']['output']>;
};

export type FaqArticles = {
  __typename?: 'FaqArticles';
  /** List of article FAQ */
  data?: Maybe<Array<Maybe<FaqArticle>>>;
  /** Pagination information */
  pagination?: Maybe<PageInfo>;
};

export type FaqCategories = {
  __typename?: 'FaqCategories';
  /** List of category FAQ */
  faq_categories?: Maybe<Array<Maybe<FaqCategory>>>;
  /** Pagination information */
  pagination?: Maybe<PageInfo>;
};

export type FaqCategory = {
  __typename?: 'FaqCategory';
  articles?: Maybe<FaqArticles>;
  /** Category Id of the category FAQ */
  category_id?: Maybe<Scalars['Int']['output']>;
  /** Icon of the category FAQ */
  icon?: Maybe<Scalars['String']['output']>;
  /** Name of the customer */
  questions?: Maybe<FaqCategoryQuestions>;
  /** Title of the category FAQ */
  title: Scalars['String']['output'];
  /** URL key of the category FAQ */
  url_key: Scalars['String']['output'];
};


export type FaqCategoryArticlesArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


export type FaqCategoryQuestionsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

export type FaqCategoryAnswer = {
  __typename?: 'FaqCategoryAnswer';
  /** Answer content of the category FAQ */
  content?: Maybe<Scalars['String']['output']>;
  /** Created at timestamp for the category FAQ */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Answer Id of the category FAQ */
  id?: Maybe<Scalars['String']['output']>;
  /** Interactive action of the category FAQ */
  interactive_action?: Maybe<Scalars['String']['output']>;
  /** Is Admin of the category FAQ */
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the customer */
  name?: Maybe<Scalars['String']['output']>;
  /** Total number of answers for the category FAQ */
  total_satisfied?: Maybe<Scalars['Int']['output']>;
  /** Total number of unsatisfied answers for the category FAQ */
  total_unsatisfied?: Maybe<Scalars['Int']['output']>;
};

export type FaqCategoryFilters = {
  /** URL key of the category FAQ */
  url_key?: InputMaybe<Scalars['String']['input']>;
};

export type FaqCategoryQuestion = {
  __typename?: 'FaqCategoryQuestion';
  /** Answer content of Question FAQ */
  answers?: Maybe<Array<Maybe<FaqCategoryAnswer>>>;
  /** Created at timestamp for the category FAQ */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Name of the customer */
  customer_name?: Maybe<Scalars['String']['output']>;
  /** Question Id of the category FAQ */
  question_id?: Maybe<Scalars['Int']['output']>;
  /** Title of the question category FAQ */
  title: Scalars['String']['output'];
  /** URL key of the Question FAQ */
  url_key: Scalars['String']['output'];
};

export type FaqCategoryQuestions = {
  __typename?: 'FaqCategoryQuestions';
  /** List of category FAQ */
  data?: Maybe<Array<Maybe<FaqCategoryQuestion>>>;
  /** Pagination information */
  pagination?: Maybe<PageInfo>;
};

export type FaqFilterInput = {
  /** Filter FAQs by brand_id. */
  brand?: InputMaybe<FilterEqualTypeInput>;
  /** Filter FAQs by category_id. */
  category_id?: InputMaybe<FilterEqualTypeInput>;
  /** Filter FAQs by sku. */
  sku?: InputMaybe<FilterEqualTypeInput>;
};

export type FaqItem = {
  __typename?: 'FaqItem';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url_key?: Maybe<Scalars['String']['output']>;
};

export type FaqListBySku = {
  __typename?: 'FaqListBySku';
  /** List of FAQ answers */
  data?: Maybe<Array<Maybe<FaqAnswer>>>;
  /** Pagination information */
  pagination?: Maybe<PageInfo>;
};

/** A product FAQ question. */
export type FaqQuestion = {
  __typename?: 'FaqQuestion';
  admin_answered?: Maybe<Array<Maybe<AdminAnswered>>>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  is_purchased?: Maybe<Scalars['Boolean']['output']>;
  like_count?: Maybe<Scalars['Int']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  total_satisfied?: Maybe<Scalars['Int']['output']>;
};

export type FaqReaction = {
  __typename?: 'FaqReaction';
  entity_id?: Maybe<Scalars['Int']['output']>;
  entity_type?: Maybe<Scalars['String']['output']>;
};

export type FaqSuggestionTag = {
  __typename?: 'FaqSuggestionTag';
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

/** Fast cart totals without full price calculation */
export type FastCartTotals = {
  __typename?: 'FastCartTotals';
  /** The masked cart ID */
  cart_id?: Maybe<Scalars['String']['output']>;
  /** Applied coupon code */
  coupon_code?: Maybe<Scalars['String']['output']>;
  /** Currency code */
  currency_code?: Maybe<Scalars['String']['output']>;
  /** Total discount amount */
  discount_amount?: Maybe<Scalars['Float']['output']>;
  /** Cart grand total */
  grand_total?: Maybe<Scalars['Float']['output']>;
  /** Whether cart contains only virtual items */
  is_virtual?: Maybe<Scalars['Boolean']['output']>;
  /** Number of different items in cart */
  items_count?: Maybe<Scalars['Int']['output']>;
  /** Total quantity of all items */
  items_qty?: Maybe<Scalars['Float']['output']>;
  /** Shipping amount */
  shipping_amount?: Maybe<Scalars['Float']['output']>;
  /** Cart subtotal */
  subtotal?: Maybe<Scalars['Float']['output']>;
  /** Subtotal after discount */
  subtotal_with_discount?: Maybe<Scalars['Float']['output']>;
  /** Total tax amount */
  tax_amount?: Maybe<Scalars['Float']['output']>;
};

export type FavoriteBrandFilter = {
  /** The id of the brand. */
  brand_id?: InputMaybe<Scalars['Int']['input']>;
};

/** The featured image info. */
export type FeaturedImageData = {
  __typename?: 'FeaturedImageData';
  /** The link of featured image. */
  link?: Maybe<Scalars['String']['output']>;
  /** The URL of featured image. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Defines a filter that matches the input exactly. */
export type FilterEqualTypeInput = {
  /** A string to filter on */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** An array of values to filter on */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Defines a filter that performs a fuzzy search. */
export type FilterMatchTypeInput = {
  /** One or more words to filter on */
  match?: InputMaybe<Scalars['String']['input']>;
};

/** Defines a filter that matches a range of values, such as prices or dates. */
export type FilterRangeTypeInput = {
  /** The beginning of the range */
  from?: InputMaybe<Scalars['String']['input']>;
  /** The end of the range */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Defines a filter for an input string. */
export type FilterStringTypeInput = {
  /** Filters items that are exactly the same as the specified string. */
  eq?: InputMaybe<Scalars['String']['input']>;
  /** Filters items that are exactly the same as entries specified in an array of strings. */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Defines a filter that performs a fuzzy search using the specified string. */
  match?: InputMaybe<Scalars['String']['input']>;
};

/** FilterTypeInput specifies which action will be performed in a query  */
export type FilterTypeInput = {
  /** Equals */
  eq?: InputMaybe<Scalars['String']['input']>;
  finset?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** From. Must be used with 'to' */
  from?: InputMaybe<Scalars['String']['input']>;
  /** Greater than */
  gt?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to */
  gteq?: InputMaybe<Scalars['String']['input']>;
  /** In. The value can contain a set of comma-separated values */
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Like. The specified value can contain % (percent signs) to allow matching of 0 or more characters */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Less than */
  lt?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to */
  lteq?: InputMaybe<Scalars['String']['input']>;
  /** More than or equal to */
  moreq?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to */
  neq?: InputMaybe<Scalars['String']['input']>;
  /** Not in. The value can contain a set of comma-separated values */
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Not null */
  notnull?: InputMaybe<Scalars['String']['input']>;
  /** Is null */
  null?: InputMaybe<Scalars['String']['input']>;
  /** To. Must be used with 'from' */
  to?: InputMaybe<Scalars['String']['input']>;
};

/** A single FPT that can be applied to a product price. */
export type FixedProductTax = {
  __typename?: 'FixedProductTax';
  /** Amount of the FPT as a money object. */
  amount?: Maybe<Money>;
  /** The label assigned to the FPT to be displayed on the frontend. */
  label?: Maybe<Scalars['String']['output']>;
};

/** This enumeration display settings for the fixed product tax */
export enum FixedProductTaxDisplaySetting {
  /**
   * The displayed price does not include the FPT amount. The values of ProductPrice.fixed_product_taxes and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price'
   * @deprecated
   */
  ExcludeFptAndIncludeWithDetails = 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS',
  /**
   * The displayed price does not include the FPT amount. The values from ProductPrice.fixed_product_taxes are not displayed. This value corresponds to 'Excluding FPT'
   * @deprecated
   */
  ExcludeFptWithoutDetails = 'EXCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The FPT feature is not enabled. You can omit  ProductPrice.fixed_product_taxes from your query
   * @deprecated
   */
  FptDisabled = 'FPT_DISABLED',
  /**
   * The displayed price includes the FPT amount without displaying the ProductPrice.fixed_product_taxes values. This value corresponds to 'Including FPT only'
   * @deprecated
   */
  IncludeFptWithoutDetails = 'INCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The displayed price includes the FPT amount while displaying the values of ProductPrice.fixed_product_taxes separately. This value corresponds to 'Including FPT and FPT description'
   * @deprecated
   */
  IncludeFptWithDetails = 'INCLUDE_FPT_WITH_DETAILS'
}

/** This enumeration display settings for the fixed product tax */
export enum FixedProductTaxDisplaySettings {
  /**
   * The displayed price does not include the FPT amount. The values of ProductPrice.fixed_product_taxes and the price including the FPT are displayed separately. This value corresponds to 'Excluding FPT, Including FPT description and final price'
   * @deprecated
   */
  ExcludeFptAndIncludeWithDetails = 'EXCLUDE_FPT_AND_INCLUDE_WITH_DETAILS',
  /**
   * The displayed price does not include the FPT amount. The values from ProductPrice.fixed_product_taxes are not displayed. This value corresponds to 'Excluding FPT'
   * @deprecated
   */
  ExcludeFptWithoutDetails = 'EXCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The FPT feature is not enabled. You can omit  ProductPrice.fixed_product_taxes from your query
   * @deprecated
   */
  FptDisabled = 'FPT_DISABLED',
  /**
   * The displayed price includes the FPT amount without displaying the ProductPrice.fixed_product_taxes values. This value corresponds to 'Including FPT only'
   * @deprecated
   */
  IncludeFptWithoutDetails = 'INCLUDE_FPT_WITHOUT_DETAILS',
  /**
   * The displayed price includes the FPT amount while displaying the values of ProductPrice.fixed_product_taxes separately. This value corresponds to 'Including FPT and FPT description'
   * @deprecated
   */
  IncludeFptWithDetails = 'INCLUDE_FPT_WITH_DETAILS'
}

/** Flash sale information */
export type FlashSale = {
  __typename?: 'FlashSale';
  /** The created at of the flash sale */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The date from of the flash sale */
  date_from?: Maybe<Scalars['String']['output']>;
  /** The date to of the flash sale */
  date_to?: Maybe<Scalars['String']['output']>;
  /** The deal qty of the flash sale */
  deal_qty?: Maybe<Scalars['Int']['output']>;
  /** The deal type of the flash sale */
  deal_type?: Maybe<Scalars['String']['output']>;
  /** The ID of the flash sale */
  flashsale_id?: Maybe<Scalars['Int']['output']>;
  /** The type of the flash sale */
  flashsale_type?: Maybe<Scalars['String']['output']>;
  /** The image of the flash sale */
  image?: Maybe<Scalars['String']['output']>;
  /** The is featured of the flash sale */
  is_featured?: Maybe<Scalars['Int']['output']>;
  /** The name of the flash sale */
  name?: Maybe<Scalars['String']['output']>;
  /** The out of stock of the flash sale */
  out_of_stock?: Maybe<Scalars['Int']['output']>;
  /** The sold out of the flash sale */
  sold_out?: Maybe<Scalars['Int']['output']>;
  /** The status of the flash sale */
  status?: Maybe<Scalars['Int']['output']>;
  /** The store ids of the flash sale */
  store_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  /** The updated at of the flash sale */
  updated_at?: Maybe<Scalars['String']['output']>;
};

/** The flash sale products. */
export type FlashSaleItems = {
  __typename?: 'FlashSaleItems';
  /** Flash sale information of product */
  items?: Maybe<Array<Maybe<FlashSaleProduct>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The number of flash sale products returned. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Flash sale information of product */
export type FlashSaleProduct = {
  __typename?: 'FlashSaleProduct';
  /** The product information. */
  product?: Maybe<ProductInterface>;
  /** The flash sale information of a product */
  sales_data?: Maybe<FlashSaleProductData>;
};

/** The flash sale information of a product */
export type FlashSaleProductData = {
  __typename?: 'FlashSaleProductData';
  /** The created at of flash sale product. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The date from of the flash sale. */
  date_from?: Maybe<Scalars['String']['output']>;
  /** The date to of the flash sale. */
  date_to?: Maybe<Scalars['String']['output']>;
  /** The deal id of product. */
  deal_id?: Maybe<Scalars['Int']['output']>;
  /** The deal price of product. */
  deal_price?: Maybe<Scalars['Float']['output']>;
  /** The deal qty of product. */
  deal_qty?: Maybe<Scalars['Int']['output']>;
  /** The deal value of product. */
  deal_value?: Maybe<Scalars['Int']['output']>;
  /** The ID of the flash sale. */
  flashsale_id?: Maybe<Scalars['Int']['output']>;
  /** The flash sale product limit for each order. */
  limit_per_order?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale price for product. */
  price?: Maybe<ProductPrice>;
  /** The ID of product. */
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The name of product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sku of product. */
  product_sku?: Maybe<Scalars['String']['output']>;
  /** The sale qty of product. */
  sale_qty?: Maybe<Scalars['Int']['output']>;
  /** The flash sale status of product. */
  status?: Maybe<Scalars['Int']['output']>;
  /** The store ids of the flash sale. */
  store_ids?: Maybe<Scalars['Int']['output']>;
  /** The updated at of flash sale product. */
  updated_at?: Maybe<Scalars['String']['output']>;
};

/** The Products object is the top-level object returned in a product list. */
export type FlashSaleProducts = {
  __typename?: 'FlashSaleProducts';
  /** Flash sale information */
  flash_sale?: Maybe<FlashSale>;
  /** An array of products that match the specified query data */
  items?: Maybe<Array<Maybe<FlashSaleProduct>>>;
};

/** The Products object is the top-level object returned in a product list. */
export type FlashSaleProductsV2 = {
  __typename?: 'FlashSaleProductsV2';
  /** An array banners of flash sale. */
  banner_items?: Maybe<BannerItems>;
  /** Flash sale information */
  flash_sale?: Maybe<FlashSale>;
  /** An array of flash sale products. */
  flash_sale_items?: Maybe<FlashSaleItems>;
  /** The identifier. */
  id?: Maybe<Scalars['String']['output']>;
};


/** The Products object is the top-level object returned in a product list. */
export type FlashSaleProductsV2Flash_Sale_ItemsArgs = {
  current_page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
};

export type FlashSaleWidget = ContentFragmentDataInterface & {
  __typename?: 'FlashSaleWidget';
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export enum FollowerActionEnum {
  Dislike = 'DISLIKE',
  Like = 'LIKE'
}

export type FooterConfig = {
  __typename?: 'FooterConfig';
  html_content: Scalars['String']['output'];
  image_url: Scalars['String']['output'];
};

export type FormConfig = {
  __typename?: 'FormConfig';
  configs: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FormConfigData = {
  __typename?: 'FormConfigData';
  form_config?: Maybe<FormConfig>;
};

export type FreeGiftCart = {
  __typename?: 'FreeGiftCart';
  /** An array of the free gifts in a cart. */
  items?: Maybe<Array<Maybe<CartItemInterface>>>;
};

/** The free gifts of the product. */
export type FreeGifts = {
  __typename?: 'FreeGifts';
  /** An array of free gifts that match the specified available rule. */
  items?: Maybe<Array<Maybe<FreeGiftsData>>>;
};

/** The free gifts of the product. */
export type FreeGiftsData = {
  __typename?: 'FreeGiftsData';
  /** An array of products that match the specified query data. */
  products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The rule is applied for the product. */
  rule?: Maybe<Rule>;
};

export type GeneratedOtpTokenResponse = {
  __typename?: 'GeneratedOtpTokenResponse';
  /** Secret to verify OTP */
  secret: Scalars['String']['output'];
};

export type GetCmsPageSchemaByIdentifierResponse = {
  __typename?: 'GetCmsPageSchemaByIdentifierResponse';
  content?: Maybe<Scalars['String']['output']>;
  identifier?: Maybe<Scalars['String']['output']>;
};

/** Input type to get user entity */
export type GetEventUserEntityInput = {
  /** Id of user */
  id: Scalars['String']['input'];
  /** signature */
  signature: Scalars['String']['input'];
};

export type GetFaqListBySkuResponse = {
  __typename?: 'GetFaqListBySkuResponse';
  current_page?: Maybe<Scalars['Int']['output']>;
  /** List of FAQ answers */
  data?: Maybe<Array<Maybe<FaqAnswer>>>;
  total_count?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

/** Returns information about an gift item in cart. */
export type GiftCartItem = {
  __typename?: 'GiftCartItem';
  /** The gift cart item info. */
  gift_item?: Maybe<CartItemInterface>;
  /** The rule info. */
  rule?: Maybe<Rule>;
};

export type GiftIndexedInfo = {
  __typename?: 'GiftIndexedInfo';
  /** The rule id. */
  id?: Maybe<Scalars['Int']['output']>;
  /** An array image urls of list gift. */
  image_urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The rule name. */
  rule_name?: Maybe<Scalars['String']['output']>;
};

/** GroupedProduct defines a grouped product */
export type GroupedProduct = PhysicalProductInterface & ProductInterface & {
  __typename?: 'GroupedProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  /** An array containing grouped product items */
  items?: Maybe<Array<Maybe<GroupedProductItem>>>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

/** GroupedProductItem contains information about an individual grouped product item */
export type GroupedProductItem = {
  __typename?: 'GroupedProductItem';
  /** The relative position of this item compared to the other group items */
  position?: Maybe<Scalars['Int']['output']>;
  /** The ProductInterface object, which contains details about this product option */
  product?: Maybe<ProductInterface>;
  /** The quantity of this grouped product item */
  qty?: Maybe<Scalars['Float']['output']>;
};

/** The highlight brand */
export type HighlightBrand = {
  __typename?: 'HighlightBrand';
  /** Achievement information of the Brand */
  achievement?: Maybe<Achievement>;
  /** The alt of the brand. */
  alt?: Maybe<Scalars['String']['output']>;
  /** The banner image of the brand. */
  banner_image?: Maybe<Scalars['String']['output']>;
  /** The description of the brand. */
  description?: Maybe<Scalars['String']['output']>;
  /** The highlight products of the brand. */
  highlight_products?: Maybe<Products>;
  /** The id of the brand. It is option_id of brand attribute */
  id?: Maybe<Scalars['Int']['output']>;
  /** The image of the brand. */
  img?: Maybe<Scalars['String']['output']>;
  /** The name of the brand. */
  label?: Maybe<Scalars['String']['output']>;
  /** The like count of the brand. */
  like_count?: Maybe<Scalars['Int']['output']>;
  /** The description of the brand. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** The description of the brand. */
  meta_title?: Maybe<Scalars['String']['output']>;
  /** The position of the brand. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The review count of the brand. */
  review_count?: Maybe<Scalars['Int']['output']>;
  /** The sold count of the brand. */
  sold_count?: Maybe<Scalars['Int']['output']>;
  /** The title description of the brand. */
  title_description?: Maybe<Scalars['String']['output']>;
  /** The url of the brand. */
  url?: Maybe<Scalars['String']['output']>;
  /** The list posts of the brand. */
  wp_posts?: Maybe<Posts>;
};


/** The highlight brand */
export type HighlightBrandHighlight_ProductsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** The highlight brand */
export type HighlightBrandWp_PostsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};

/** The highlight brand items. */
export type HighlightBrands = {
  __typename?: 'HighlightBrands';
  /** Returns highlight brand layout for Category. */
  category_layout?: Maybe<BrandLayout>;
  /** Returns highlight brand layout for Homepage. */
  homepage_layout?: Maybe<BrandLayout>;
  /** The identifier. */
  id?: Maybe<Scalars['String']['output']>;
  /** The highlight brand information. */
  items?: Maybe<Array<Maybe<HighlightBrand>>>;
};

/** The information of highlight categories. */
export type HighlightCategories = {
  __typename?: 'HighlightCategories';
  /** The highlight category information. */
  items?: Maybe<Array<Maybe<HighlightCategory>>>;
};

export type HighlightCategory = {
  __typename?: 'HighlightCategory';
  /** The background app icon of category. */
  background_app_icon?: Maybe<Scalars['String']['output']>;
  /** The featured app icon of category. */
  featured_app_icon?: Maybe<Scalars['String']['output']>;
  /** The featured icon of category. */
  featured_icon?: Maybe<Scalars['String']['output']>;
  /** The featured icon solid of category. */
  featured_icon_solid?: Maybe<Scalars['String']['output']>;
  /** The ID of category. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The name of category. */
  name?: Maybe<Scalars['String']['output']>;
  /** The priority of category. */
  priority?: Maybe<Scalars['String']['output']>;
  /** The url of category. */
  url?: Maybe<Scalars['String']['output']>;
};

export type HighlightProductBlocks = {
  __typename?: 'HighlightProductBlocks';
  /** The identifier */
  id?: Maybe<Scalars['String']['output']>;
  /** An array highlight product block. */
  items?: Maybe<Array<Maybe<ProductBlock>>>;
};

/** Item of Highlight Products */
export type HighlightProductItem = {
  __typename?: 'HighlightProductItem';
  /** Icon of product */
  icon?: Maybe<Scalars['String']['output']>;
  /** The id of item. This ID will be product ID. */
  id?: Maybe<Scalars['Int']['output']>;
  /** Label of product */
  label?: Maybe<Scalars['String']['output']>;
  /** The ProductInterface contains attributes that are common to all types of products. Note that descriptions may not be available for custom and EAV attributes. */
  product?: Maybe<ProductInterface>;
};

/** The Products object is the top-level object returned in a product list. */
export type HighlightProducts = {
  __typename?: 'HighlightProducts';
  /** An array of highlight products that match the specified query data */
  highlight_items?: Maybe<Array<Maybe<HighlightProductItem>>>;
  /** An array of products that match the specified query data */
  hot_new_items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The identifier. */
  id?: Maybe<Scalars['String']['output']>;
};

export type HomePageFloatBanner = {
  __typename?: 'HomePageFloatBanner';
  left_banner_img?: Maybe<Scalars['String']['output']>;
  left_banner_url?: Maybe<Scalars['String']['output']>;
  right_banner_img?: Maybe<Scalars['String']['output']>;
  right_banner_url?: Maybe<Scalars['String']['output']>;
};

/** The HomepageFeaturedBlock object is the top-level object returned in featured block. */
export type HomepageFeaturedBlock = {
  __typename?: 'HomepageFeaturedBlock';
  /** An array of banners for App. */
  app_banner_images?: Maybe<BannerItems>;
  /** An array of category. */
  category_items?: Maybe<Array<Maybe<CategoryTree>>>;
  /** The featured image of block. */
  featured_images?: Maybe<Array<Maybe<FeaturedImageData>>>;
  /** Highlight product attribute of block. */
  highlight_attribute?: Maybe<Aggregation>;
  /** The first highlight product. */
  highlight_item?: Maybe<HighlightProductItem>;
  /** The identifier. */
  id?: Maybe<Scalars['String']['output']>;
  /** The layout to show featured image. */
  layout?: Maybe<Scalars['String']['output']>;
  /** The layout of products App on Homepage. */
  layout_product_app?: Maybe<LayoutData>;
  /** The number of products to show on Homepage block. */
  limit_product_block?: Maybe<Scalars['Int']['output']>;
  /** The limit of products on Homepage App. */
  limit_product_homepage_app?: Maybe<Scalars['Int']['output']>;
  /** The limit of products for each page. */
  limit_product_page?: Maybe<Scalars['Int']['output']>;
  /** An array of banners. */
  mobile_banner_images?: Maybe<Array<Maybe<Banner>>>;
  /** The name of featured block. */
  name?: Maybe<Scalars['String']['output']>;
  /** An array of products app. */
  product_app_items?: Maybe<Products>;
  /** An array attributes of block. */
  product_attributes?: Maybe<Array<Maybe<Aggregation>>>;
  /** An array of products that match the specified query data */
  product_items?: Maybe<Array<Maybe<ProductInterface>>>;
};


/** The HomepageFeaturedBlock object is the top-level object returned in featured block. */
export type HomepageFeaturedBlockProduct_App_ItemsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type HomepagePopularSearchKeywords = {
  __typename?: 'HomepagePopularSearchKeywords';
  items?: Maybe<Array<Maybe<Keywords>>>;
};

/** An array posts in homepage. */
export type HomepagePosts = {
  __typename?: 'HomepagePosts';
  /** Background color code */
  background_color?: Maybe<Scalars['String']['output']>;
  /** An array posts in homepage. */
  items?: Maybe<Array<Maybe<Post>>>;
  /** URL of banner */
  post_banner?: Maybe<Scalars['String']['output']>;
};

/** Data return for html or not supported magento widgets */
export type HtmlWidget = ContentFragmentDataInterface & {
  __typename?: 'HtmlWidget';
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

/** The object details of target path parameters */
export type HttpQueryParameter = {
  __typename?: 'HttpQueryParameter';
  /** Parameter name */
  name?: Maybe<Scalars['String']['output']>;
  /** Parameter value */
  value?: Maybe<Scalars['String']['output']>;
};

export type IframeWidget = ContentFragmentDataInterface & {
  __typename?: 'IframeWidget';
  /** Classes of iframe tag */
  class_name?: Maybe<Scalars['String']['output']>;
  /** Height of iframe content */
  height?: Maybe<Scalars['String']['output']>;
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Url of iframe */
  iframe_url: Scalars['String']['output'];
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Title of iframe tag */
  title?: Maybe<Scalars['String']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export type ImageItem = {
  __typename?: 'ImageItem';
  /** Image alt */
  alt?: Maybe<Scalars['String']['output']>;
  /** Image height */
  height?: Maybe<Scalars['String']['output']>;
  /** Url when clicking on image */
  href?: Maybe<Scalars['String']['output']>;
  /** Html id */
  html_id?: Maybe<Scalars['String']['output']>;
  /** Url link for image */
  image_url: Scalars['String']['output'];
  /** Image width */
  width?: Maybe<Scalars['String']['output']>;
};

export type ImageSwatchData = SwatchDataInterface & {
  __typename?: 'ImageSwatchData';
  /** Thumbnail swatch image URL */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Value of swatch item (HEX color code, image link or textual value) */
  value?: Maybe<Scalars['String']['output']>;
};

/** Data return for image */
export type ImageWidget = ContentFragmentDataInterface & {
  __typename?: 'ImageWidget';
  /** Image alt */
  alt?: Maybe<Scalars['String']['output']>;
  /** Image height */
  height?: Maybe<Scalars['String']['output']>;
  /** Url when clicking on image */
  href?: Maybe<Scalars['String']['output']>;
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Html id */
  html_id?: Maybe<Scalars['String']['output']>;
  /** Url link for image */
  image_url: Scalars['String']['output'];
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
  /** Image width */
  width?: Maybe<Scalars['String']['output']>;
};

export type InitiateCheckoutContentInput = {
  product_id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type InitiateCheckoutEventInput = {
  checkout_info?: InputMaybe<CheckoutInfoInput>;
  user: UserDataInput;
};

export type InitiateCheckoutTrackingEventRequest = {
  context?: InputMaybe<EventContextInput>;
  data?: InputMaybe<InitiateCheckoutEventInput>;
};

export type InteractiveRequestData = {
  answer_id: Scalars['Int']['input'];
  interactive_type: Scalars['Int']['input'];
};

/** The Products object is the top-level object returned in a product list. */
export type InterestedProducts = {
  __typename?: 'InterestedProducts';
  /** An array of products that match the specified query data. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
};

/** Contains invoice details. */
export type Invoice = {
  __typename?: 'Invoice';
  /** Comments on the invoice. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `Invoice` object. */
  id: Scalars['ID']['output'];
  /** Invoiced product details. */
  items?: Maybe<Array<Maybe<InvoiceItemInterface>>>;
  /** Sequential invoice number. */
  number: Scalars['String']['output'];
  /** Invoice total amount details. */
  total?: Maybe<InvoiceTotal>;
};

/** Contains detailes about invoiced items. */
export type InvoiceItemInterface = {
  /** Information about the final discount amount for the base product, including discounts on options. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The unique ID for an `InvoiceItemInterface` object. */
  id: Scalars['ID']['output'];
  /** Details about an individual order item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
};

/** Contains price details from an invoice. */
export type InvoiceTotal = {
  __typename?: 'InvoiceTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the invoice. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the invoice. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the invoice, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The invoice tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the invoice. */
  total_shipping: Money;
  /** The amount of tax applied to the invoice. */
  total_tax: Money;
};

export type IsEmailAvailableOutput = {
  __typename?: 'IsEmailAvailableOutput';
  /** Is email availabel value */
  is_email_available?: Maybe<Scalars['Boolean']['output']>;
};

export type IssuedCoupon = {
  __typename?: 'IssuedCoupon';
  /** Code issued for users */
  code?: Maybe<Scalars['String']['output']>;
  /** The time coupon is issued */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Coupon description */
  description?: Maybe<Scalars['String']['output']>;
  /** The discount amount of coupon */
  discount_amount?: Maybe<Scalars['Int']['output']>;
  /** The starting date for coupon's validity period */
  from_date?: Maybe<Scalars['DateTime']['output']>;
  /** Masked phone number of user */
  masked_phone_number?: Maybe<Scalars['String']['output']>;
  /** Coupon name */
  name?: Maybe<Scalars['String']['output']>;
  /** Phone number of user */
  phone_number?: Maybe<Scalars['String']['output']>;
  /** The end date for coupon's validity period */
  to_date?: Maybe<Scalars['DateTime']['output']>;
  /** The usage limit of coupon per customer */
  uses_per_customer?: Maybe<Scalars['Int']['output']>;
};

export type ItemStatus = {
  __typename?: 'ItemStatus';
  sku: Scalars['String']['output'];
  stock_status: StockStatus;
};

/** Contains a key-value pair. */
export type KeyValue = {
  __typename?: 'KeyValue';
  /** The name part of the key/value pair. */
  name?: Maybe<Scalars['String']['output']>;
  /** The value part of the key/value pair. */
  value?: Maybe<Scalars['String']['output']>;
};

export type Keywords = {
  __typename?: 'Keywords';
  tag_name?: Maybe<Scalars['String']['output']>;
  tag_url?: Maybe<Scalars['String']['output']>;
};

export type LayerFilter = {
  __typename?: 'LayerFilter';
  /**
   * Array of filter items.
   * @deprecated Use Aggregation.options instead.
   */
  filter_items?: Maybe<Array<Maybe<LayerFilterItemInterface>>>;
  /**
   * Count of filter items in filter group.
   * @deprecated Use Aggregation.count instead.
   */
  filter_items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * Layered navigation filter name.
   * @deprecated Use Aggregation.label instead.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Request variable name for filter query.
   * @deprecated Use Aggregation.attribute_code instead.
   */
  request_var?: Maybe<Scalars['String']['output']>;
};

export type LayerFilterItemInterface = {
  /**
   * Count of items by filter.
   * @deprecated Use AggregationOption.count instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * Filter label.
   * @deprecated Use AggregationOption.label instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  /**
   * Value for filter request variable to be used in query.
   * @deprecated Use AggregationOption.value instead.
   */
  value_string?: Maybe<Scalars['String']['output']>;
};

export type Layout = {
  __typename?: 'Layout';
  entities?: Maybe<Scalars['String']['output']>;
  layout_handle?: Maybe<Scalars['String']['output']>;
  layout_id?: Maybe<Scalars['Int']['output']>;
  page_for?: Maybe<Scalars['String']['output']>;
  page_group?: Maybe<Scalars['String']['output']>;
};

export type LayoutData = {
  __typename?: 'LayoutData';
  /** The label of layout. */
  label?: Maybe<Scalars['String']['output']>;
  /** The value of layout. */
  value?: Maybe<Scalars['Int']['output']>;
};

export enum Location {
  Account = 'ACCOUNT',
  Authentication = 'AUTHENTICATION'
}

export type LoginDevice = {
  /** Device App Version */
  device_app_version: Scalars['String']['input'];
  /** Device ID */
  device_id: Scalars['String']['input'];
  /** Device Name */
  device_name: Scalars['String']['input'];
  /** Device OS */
  device_os: Scalars['String']['input'];
  /** Device OS Version */
  device_os_version: Scalars['String']['input'];
  /** Device Type ios | android */
  device_type: Scalars['String']['input'];
  /** Device Push Token */
  push_token: Scalars['String']['input'];
  /** Device Push User ID */
  user_id: Scalars['String']['input'];
};

export type LoginEventInput = {
  user: UserDataInput;
};

/** Login Success Response */
export type LoginSuccessResponse = {
  __typename?: 'LoginSuccessResponse';
  /** Session Cookies */
  cookies: Scalars['String']['output'];
  /** Message */
  message: Scalars['String']['output'];
  /** Success */
  success: Scalars['Boolean']['output'];
  /** Session Token */
  token?: Maybe<Scalars['String']['output']>;
};

export type LoginTrackingEventRequest = {
  context?: InputMaybe<EventContextInput>;
  data?: InputMaybe<LoginEventInput>;
};

export type LogoData = {
  __typename?: 'LogoData';
  id?: Maybe<Scalars['String']['output']>;
  original?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type LogoutInternalEventInput = {
  session_id?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type LogoutInternalEventRequest = {
  context?: InputMaybe<EventContextInput>;
  data?: InputMaybe<LogoutInternalEventInput>;
};

/** Input type to get look up user */
export type LookUpEventUserInput = {
  /** Captcha token */
  captcha_token?: InputMaybe<Scalars['String']['input']>;
  /** Event id */
  event_id: Scalars['String']['input'];
  /** Phone number of user */
  searchString: Scalars['String']['input'];
  /** Update secret */
  update_secret?: InputMaybe<Scalars['String']['input']>;
};

export type LookupCustomerResponse = {
  __typename?: 'LookupCustomerResponse';
  is_existed_phone: Scalars['Boolean']['output'];
};

/** MediaGalleryEntry defines characteristics about images and videos associated with a specific product. */
export type MediaGalleryEntry = {
  __typename?: 'MediaGalleryEntry';
  /** Contains a ProductMediaGalleryEntriesContent object. */
  content?: Maybe<ProductMediaGalleryEntriesContent>;
  /** Whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The path of the image on the server. */
  file?: Maybe<Scalars['String']['output']>;
  /** The identifier assigned to the object. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The alt text displayed on the UI when the user points to the image. */
  label?: Maybe<Scalars['String']['output']>;
  /** image or video. */
  media_type?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Array of image types. It can have the following values: image, small_image, thumbnail. */
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Contains a ProductMediaGalleryEntriesVideoContent object. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** Contains basic information about a product image or video. */
export type MediaGalleryInterface = {
  /** Whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
};

/** A Money object defines a monetary value, including a numeric value and a currency code. */
export type Money = {
  __typename?: 'Money';
  /** A three-letter currency code, such as USD or EUR */
  currency?: Maybe<CurrencyEnum>;
  /** A number expressing a monetary value */
  value?: Maybe<Scalars['Float']['output']>;
};

/** Mutation type for modifying data */
export type Mutation = {
  __typename?: 'Mutation';
  addBundleProductsToCart?: Maybe<AddBundleProductsToCartOutput>;
  addConfigurableProductsToCart?: Maybe<AddConfigurableProductsToCartOutput>;
  addCouponToMyList?: Maybe<StatusMessageResponse>;
  addDeviceToUser: Scalars['Boolean']['output'];
  addDownloadableProductsToCart?: Maybe<AddDownloadableProductsToCartOutput>;
  /** Auto add free gift to cart. */
  addGiftsToCart?: Maybe<AddGiftsToCartOutput>;
  addNewIp: Result;
  /** Adds product to the specified wish list. */
  addProductToWishlist?: Maybe<ProductToWishlistOutput>;
  addSimpleProductsToCart?: Maybe<AddSimpleProductsToCartOutput>;
  addVirtualProductsToCart?: Maybe<AddVirtualProductsToCartOutput>;
  applyCouponToCart?: Maybe<ApplyCouponToCartOutput>;
  /** Apply kicoins to cart */
  applyKicoins?: Maybe<ApplyKicoinsOutput>;
  /** Assign a logged-in customer to the specified guest shopping cart */
  assignCustomerToGuestCart: Cart;
  /** Assign a provider to a client. */
  assignProviderToClient: Result;
  cancelCustomerOrder?: Maybe<StatusMessageResponse>;
  /** Changes the password for the logged-in customer */
  changeCustomerPassword?: Maybe<Customer>;
  /** Configure credential for a SMS service provider. */
  configureSmsServiceProvider: Result;
  confirmRequestedValidationPhone: ConfirmRequestedValidationPhoneResponse;
  createAnswer?: Maybe<CreateAnswerResponse>;
  /** Creates Client Token for Braintree Javascript SDK initialization. */
  createBraintreeClientToken: Scalars['String']['output'];
  /** Create a new client to access the SMS service. */
  createClient: CreateClientCredentialResult;
  createClientQuota: Result;
  /** Create customer address */
  createCustomerAddress?: Maybe<CustomerAddress>;
  /** Creates an empty shopping cart for a guest or logged in user */
  createEmptyCart?: Maybe<Scalars['String']['output']>;
  /** Create empty cart for web via GraphQL */
  createEmptyWebCart?: Maybe<Cart>;
  /** Create a new event registration */
  createEventRegistration?: Maybe<Array<EventRegistration>>;
  createQuestion?: Maybe<CreateQuestionResponse>;
  deleteAllIps: Result;
  /** Delete customer address */
  deleteCustomerAddress?: Maybe<Scalars['Boolean']['output']>;
  /** Delete a customer payment token */
  deletePaymentToken?: Maybe<DeletePaymentTokenOutput>;
  /** Delete a single keyword from history */
  deleteSearchKeyword: StatusMessageResponse;
  generateCustomerProfileSign?: Maybe<CustomerProfileSign>;
  /** Generate the customer token */
  generateCustomerToken?: Maybe<CustomerToken>;
  /** Generate referral code */
  generateReferralCode: ReferralCodeResponse;
  /** Initiate password reset by phone number */
  initiatePasswordResetByPhone: GeneratedOtpTokenResponse;
  /** "like or dislike a brand */
  likeBrand: CatalogStatusMessageResponse;
  /** Login customer by username and password */
  loginCustomerByUsernameAndPassword: CustomerToken;
  /** Login user by phone number and OTP */
  loginWithPhoneAndOtp: CustomerToken;
  /** Merges the source cart into the destination cart */
  mergeCarts: Cart;
  placeOrder?: Maybe<PlaceOrderOutput>;
  pushAddToCartErrorInternalEvent?: Maybe<TrackEventResult>;
  pushAddToCartTrackingEvent?: Maybe<TrackEventResult>;
  pushApiErrorInternalEvent?: Maybe<TrackEventResult>;
  pushAuthErrorInternalEvent?: Maybe<TrackEventResult>;
  pushBeginAddToCartInternalEvent?: Maybe<TrackEventResult>;
  pushCompleteRegistrationTrackingEvent?: Maybe<TrackEventResult>;
  pushInitiateCheckoutTrackingEvent?: Maybe<TrackEventResult>;
  pushLoginTrackingEvent?: Maybe<TrackEventResult>;
  pushLogoutInternalEvent?: Maybe<TrackEventResult>;
  pushPurchaseTrackingEvent?: Maybe<TrackEventResult>;
  pushScrollDepthInternalEvent?: Maybe<TrackEventResult>;
  /** Refresh customer token */
  refreshToken: CustomerToken;
  registerNewAccountByOtp: RegisterResponse;
  /** Register a user to an event */
  registerUserToEvent: EventUser;
  removeCouponFromCart?: Maybe<RemoveCouponFromCartOutput>;
  removeIp: Result;
  removeItemFromCart?: Maybe<RemoveItemFromCartOutput>;
  /** Remove kicoins from cart */
  removeKicoins?: Maybe<RemoveKicoinsOutput>;
  requestValidatePhone: RequestValidatePhoneResponse;
  /** Reset password by OTP token */
  resetPasswordByOtp: ResetPasswordResponse;
  /** Revoke the customer token */
  revokeCustomerToken?: Maybe<RevokeCustomerTokenOutput>;
  saveFaqAnswer?: Maybe<Scalars['Boolean']['output']>;
  saveFaqInteractive?: Maybe<Scalars['Boolean']['output']>;
  saveFaqQuestion?: Maybe<Scalars['Boolean']['output']>;
  saveFaqReaction?: Maybe<Scalars['Boolean']['output']>;
  /** Like/dislike action for a review */
  saveReviewReaction?: Maybe<ReviewReactionResponse>;
  sendOrderReview?: Maybe<StatusMessageResponse>;
  /** Send review request */
  sendReview?: Maybe<Review>;
  setBillingAddressOnCart?: Maybe<SetBillingAddressOnCartOutput>;
  setGuestEmailOnCart?: Maybe<SetGuestEmailOnCartOutput>;
  /** @deprecated Should use setPaymentMethodOnCart and placeOrder mutations in single request. */
  setPaymentMethodAndPlaceOrder?: Maybe<PlaceOrderOutput>;
  setPaymentMethodOnCart?: Maybe<SetPaymentMethodOnCartOutput>;
  setShippingAddressesOnCart?: Maybe<SetShippingAddressesOnCartOutput>;
  setShippingMethodsOnCart?: Maybe<SetShippingMethodsOnCartOutput>;
  /** Api for saving active app event for non-logged in user */
  trackEvent?: Maybe<TrackEventResult>;
  /** Api for saving active app event for logged in user */
  trackEventSession?: Maybe<TrackEventResult>;
  updateCartItems?: Maybe<UpdateCartItemsOutput>;
  /** Update the customer's personal information */
  updateCustomer?: Maybe<CustomerOutput>;
  /** Update customer address */
  updateCustomerAddress?: Maybe<CustomerAddress>;
  updateCustomerProfile?: Maybe<StatusMessageResponse>;
  updateQuotaAmount: Result;
  /** Returns an array coupon codes. */
  validateCoupons?: Maybe<Array<Maybe<SalesRule>>>;
  /** Validate password reset token */
  validateResetPasswordToken: ResetPasswordResponse;
};


/** Mutation type for modifying data */
export type MutationAddBundleProductsToCartArgs = {
  input?: InputMaybe<AddBundleProductsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationAddConfigurableProductsToCartArgs = {
  input?: InputMaybe<AddConfigurableProductsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationAddCouponToMyListArgs = {
  coupon_code: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationAddDeviceToUserArgs = {
  push_id: Scalars['String']['input'];
  push_token: Scalars['String']['input'];
  type_device: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationAddDownloadableProductsToCartArgs = {
  input?: InputMaybe<AddDownloadableProductsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationAddGiftsToCartArgs = {
  input?: InputMaybe<AddGiftsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationAddNewIpArgs = {
  ip: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationAddProductToWishlistArgs = {
  input?: InputMaybe<AddProductToWishlistInput>;
};


/** Mutation type for modifying data */
export type MutationAddSimpleProductsToCartArgs = {
  input?: InputMaybe<AddSimpleProductsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationAddVirtualProductsToCartArgs = {
  input?: InputMaybe<AddVirtualProductsToCartInput>;
};


/** Mutation type for modifying data */
export type MutationApplyCouponToCartArgs = {
  input?: InputMaybe<ApplyCouponToCartInput>;
};


/** Mutation type for modifying data */
export type MutationApplyKicoinsArgs = {
  input?: InputMaybe<ApplyKicoinsInput>;
};


/** Mutation type for modifying data */
export type MutationAssignCustomerToGuestCartArgs = {
  cart_id: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationAssignProviderToClientArgs = {
  clientId: Scalars['String']['input'];
  credentialProviderId: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationCancelCustomerOrderArgs = {
  input: CancelOrderInput;
};


/** Mutation type for modifying data */
export type MutationChangeCustomerPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationConfigureSmsServiceProviderArgs = {
  provider: ProviderEnum;
  providerId: Scalars['String']['input'];
  providerSecret: Scalars['String']['input'];
  serviceProviderName: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationConfirmRequestedValidationPhoneArgs = {
  otp: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationCreateAnswerArgs = {
  input?: InputMaybe<CreateAnswerRequest>;
};


/** Mutation type for modifying data */
export type MutationCreateClientArgs = {
  clientName: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationCreateClientQuotaArgs = {
  clientId: Scalars['String']['input'];
  quotaAmount: Scalars['Int']['input'];
  quotaLevel: QuotaLevelEnum;
};


/** Mutation type for modifying data */
export type MutationCreateCustomerAddressArgs = {
  input: CustomerAddressInput;
};


/** Mutation type for modifying data */
export type MutationCreateEmptyCartArgs = {
  input?: InputMaybe<CreateEmptyCartInput>;
};


/** Mutation type for modifying data */
export type MutationCreateEventRegistrationArgs = {
  input?: InputMaybe<Array<CreateEventRegistrationInput>>;
};


/** Mutation type for modifying data */
export type MutationCreateQuestionArgs = {
  input?: InputMaybe<CreateQuestionRequest>;
};


/** Mutation type for modifying data */
export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['Int']['input'];
};


/** Mutation type for modifying data */
export type MutationDeletePaymentTokenArgs = {
  public_hash: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationDeleteSearchKeywordArgs = {
  query: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationGenerateCustomerTokenArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationInitiatePasswordResetByPhoneArgs = {
  phone_number: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationLikeBrandArgs = {
  action: FollowerActionEnum;
  brand_id: Scalars['Int']['input'];
};


/** Mutation type for modifying data */
export type MutationLoginCustomerByUsernameAndPasswordArgs = {
  device?: InputMaybe<LoginDevice>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number: Scalars['String']['input'];
  sign?: InputMaybe<Scalars['String']['input']>;
};


/** Mutation type for modifying data */
export type MutationLoginWithPhoneAndOtpArgs = {
  device: LoginDevice;
  otp: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  secret: Scalars['String']['input'];
  sign: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationMergeCartsArgs = {
  destination_cart_id: Scalars['String']['input'];
  source_cart_id: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationPlaceOrderArgs = {
  input?: InputMaybe<PlaceOrderInput>;
};


/** Mutation type for modifying data */
export type MutationPushAddToCartErrorInternalEventArgs = {
  input?: InputMaybe<AddToCartErrorInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushAddToCartTrackingEventArgs = {
  input?: InputMaybe<AddToCartTrackingEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushApiErrorInternalEventArgs = {
  input?: InputMaybe<ApiErrorInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushAuthErrorInternalEventArgs = {
  input?: InputMaybe<AuthErrorInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushBeginAddToCartInternalEventArgs = {
  input?: InputMaybe<BeginAddToCartInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushCompleteRegistrationTrackingEventArgs = {
  input?: InputMaybe<CompleteRegistrationTrackingEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushInitiateCheckoutTrackingEventArgs = {
  input?: InputMaybe<InitiateCheckoutTrackingEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushLoginTrackingEventArgs = {
  input?: InputMaybe<LoginTrackingEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushLogoutInternalEventArgs = {
  input?: InputMaybe<LogoutInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationPushPurchaseTrackingEventArgs = {
  input?: InputMaybe<PurchaseTrackingEventInput>;
};


/** Mutation type for modifying data */
export type MutationPushScrollDepthInternalEventArgs = {
  input?: InputMaybe<ScrollDepthInternalEventRequest>;
};


/** Mutation type for modifying data */
export type MutationRefreshTokenArgs = {
  refresh_token: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationRegisterNewAccountByOtpArgs = {
  accountInfo: RegisterAccountInfo;
  deviceRequest?: InputMaybe<LoginDevice>;
  otp: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  referralCode?: InputMaybe<CustomerReferralCodeInput>;
  secret: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationRegisterUserToEventArgs = {
  input: CreateEventUserInput;
};


/** Mutation type for modifying data */
export type MutationRemoveCouponFromCartArgs = {
  input?: InputMaybe<RemoveCouponFromCartInput>;
};


/** Mutation type for modifying data */
export type MutationRemoveIpArgs = {
  ip: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationRemoveItemFromCartArgs = {
  input?: InputMaybe<RemoveItemFromCartInput>;
};


/** Mutation type for modifying data */
export type MutationRemoveKicoinsArgs = {
  input?: InputMaybe<RemoveKicoinsInput>;
};


/** Mutation type for modifying data */
export type MutationRequestValidatePhoneArgs = {
  captchaResponseToken?: InputMaybe<Scalars['String']['input']>;
  notificationChannel: NotificationChannel;
  phone_number: Scalars['String']['input'];
  sign?: InputMaybe<Scalars['String']['input']>;
  validateType: ValidatePhoneType;
};


/** Mutation type for modifying data */
export type MutationResetPasswordByOtpArgs = {
  new_password: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};


/** Mutation type for modifying data */
export type MutationSaveFaqAnswerArgs = {
  answerRequest?: InputMaybe<AnswerRequest>;
};


/** Mutation type for modifying data */
export type MutationSaveFaqInteractiveArgs = {
  interactiveRequestData?: InputMaybe<InteractiveRequestData>;
};


/** Mutation type for modifying data */
export type MutationSaveFaqQuestionArgs = {
  questionRequest?: InputMaybe<QuestionRequest>;
};


/** Mutation type for modifying data */
export type MutationSaveFaqReactionArgs = {
  entity_id: Scalars['Int']['input'];
  entity_type: Scalars['String']['input'];
  reaction_type: Scalars['Int']['input'];
};


/** Mutation type for modifying data */
export type MutationSaveReviewReactionArgs = {
  input: ReviewReactionRequest;
};


/** Mutation type for modifying data */
export type MutationSendOrderReviewArgs = {
  captchaResponseToken: Scalars['String']['input'];
  images?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  order: OrderReviewInformation;
  reviewRequest: CreateReviewRequest;
  videos?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
};


/** Mutation type for modifying data */
export type MutationSendReviewArgs = {
  captchaResponseToken: Scalars['String']['input'];
  images?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  reviewRequest: CreateReviewRequest;
  video?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
};


/** Mutation type for modifying data */
export type MutationSetBillingAddressOnCartArgs = {
  input?: InputMaybe<SetBillingAddressOnCartInput>;
};


/** Mutation type for modifying data */
export type MutationSetGuestEmailOnCartArgs = {
  input?: InputMaybe<SetGuestEmailOnCartInput>;
};


/** Mutation type for modifying data */
export type MutationSetPaymentMethodAndPlaceOrderArgs = {
  input?: InputMaybe<SetPaymentMethodAndPlaceOrderInput>;
};


/** Mutation type for modifying data */
export type MutationSetPaymentMethodOnCartArgs = {
  input?: InputMaybe<SetPaymentMethodOnCartInput>;
};


/** Mutation type for modifying data */
export type MutationSetShippingAddressesOnCartArgs = {
  input?: InputMaybe<SetShippingAddressesOnCartInput>;
};


/** Mutation type for modifying data */
export type MutationSetShippingMethodsOnCartArgs = {
  input?: InputMaybe<SetShippingMethodsOnCartInput>;
};


/** Mutation type for modifying data */
export type MutationTrackEventArgs = {
  event?: InputMaybe<TrackEventInput>;
};


/** Mutation type for modifying data */
export type MutationTrackEventSessionArgs = {
  event?: InputMaybe<TrackEventInput>;
};


/** Mutation type for modifying data */
export type MutationUpdateCartItemsArgs = {
  input?: InputMaybe<UpdateCartItemsInput>;
};


/** Mutation type for modifying data */
export type MutationUpdateCustomerArgs = {
  input: CustomerInput;
};


/** Mutation type for modifying data */
export type MutationUpdateCustomerAddressArgs = {
  id: Scalars['Int']['input'];
  input?: InputMaybe<CustomerAddressInput>;
};


/** Mutation type for modifying data */
export type MutationUpdateCustomerProfileArgs = {
  input: CustomerProfileInput;
};


/** Mutation type for modifying data */
export type MutationUpdateQuotaAmountArgs = {
  clientId: Scalars['String']['input'];
  quotaAmount: Scalars['Int']['input'];
  quotaLevel: QuotaLevelEnum;
};


/** Mutation type for modifying data */
export type MutationValidateCouponsArgs = {
  input?: InputMaybe<ValidateCouponsInput>;
};


/** Mutation type for modifying data */
export type MutationValidateResetPasswordTokenArgs = {
  otp: Scalars['String']['input'];
  phone_number: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type MyFavoriteBrands = {
  __typename?: 'MyFavoriteBrands';
  /** The list of brands. */
  brands?: Maybe<Array<Maybe<HighlightBrand>>>;
  /** The pagination information for the brands. */
  pagination?: Maybe<PageInfo>;
};

export type MyOrderReviewFilter = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type MyOrderReviews = {
  __typename?: 'MyOrderReviews';
  page_info?: Maybe<PageInfo>;
  reviews?: Maybe<Array<Maybe<Review>>>;
};

export type MyQuestion = {
  __typename?: 'MyQuestion';
  answers?: Maybe<Array<Maybe<AdminAnswered>>>;
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  customer_id?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  question_id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
};

export type MyQuestions = {
  __typename?: 'MyQuestions';
  data?: Maybe<Array<Maybe<MyQuestion>>>;
  pagination?: Maybe<PageInfo>;
};

/** The Products object is the top-level object returned in a product list. */
export type NewArrivalProducts = {
  __typename?: 'NewArrivalProducts';
  /** An array of products that match the specified query data. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Limit product at Homepage for only App. */
  limit_product_for_app?: Maybe<Scalars['Int']['output']>;
  /** Limit product at Homepage for only Web. */
  limit_product_for_web?: Maybe<Scalars['Int']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  content?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  expiry_date?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  order_date?: Maybe<Scalars['DateTime']['output']>;
  order_number?: Maybe<Scalars['String']['output']>;
  order_status?: Maybe<Scalars['String']['output']>;
  read?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export enum NotificationChannel {
  /** Send OTP via SMS */
  Sms = 'SMS',
  /** Send OTP via ZALO */
  Zalo = 'ZALO'
}

export type NotificationCustomer = {
  __typename?: 'NotificationCustomer';
  messages?: Maybe<Array<Maybe<NotificationMessage>>>;
  paginationMetadata?: Maybe<NotificationPagination>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type NotificationHistoryFilterInput = {
  type: Scalars['String']['input'];
};

export type NotificationMessage = {
  __typename?: 'NotificationMessage';
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  read?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  typeNotification?: Maybe<Scalars['String']['output']>;
};

export type NotificationPagination = {
  __typename?: 'NotificationPagination';
  currentPage?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type Notifications = {
  __typename?: 'Notifications';
  data?: Maybe<NotificationsData>;
  pagination?: Maybe<PageInfo>;
};

export type NotificationsData = {
  __typename?: 'NotificationsData';
  notification?: Maybe<Array<Maybe<Notification>>>;
  total_unread?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  /** @deprecated The order_id field is deprecated, use order_number instead. */
  order_id?: Maybe<Scalars['String']['output']>;
  order_number: Scalars['String']['output'];
};

/** Contains detailed information about an order's billing and shipping addresses. */
export type OrderAddress = {
  __typename?: 'OrderAddress';
  /** The city or town. */
  city: Scalars['String']['output'];
  /** The customer's company. */
  company?: Maybe<Scalars['String']['output']>;
  /** The customer's country. */
  country_code?: Maybe<CountryCodeEnum>;
  /** The district name. */
  district?: Maybe<Scalars['String']['output']>;
  /** The district id. */
  district_id?: Maybe<Scalars['ID']['output']>;
  /** The fax number. */
  fax?: Maybe<Scalars['String']['output']>;
  /** The first name of the person associated with the shipping/billing address. */
  firstname: Scalars['String']['output'];
  /** The family name of the person associated with the shipping/billing address. */
  lastname: Scalars['String']['output'];
  /** The middle name of the person associated with the shipping/billing address. */
  middlename?: Maybe<Scalars['String']['output']>;
  /** The customer's ZIP or postal code. */
  postcode?: Maybe<Scalars['String']['output']>;
  /** An honorific, such as Dr., Mr., or Mrs. */
  prefix?: Maybe<Scalars['String']['output']>;
  /** The state or province name. */
  region?: Maybe<Scalars['String']['output']>;
  /** The unique ID for a `Region` object of a pre-defined region. */
  region_id?: Maybe<Scalars['ID']['output']>;
  /** An array of strings that define the street number and name. */
  street: Array<Maybe<Scalars['String']['output']>>;
  /** A value such as Sr., Jr., or III. */
  suffix?: Maybe<Scalars['String']['output']>;
  /** The telephone number. */
  telephone?: Maybe<Scalars['String']['output']>;
  /** The customer's Value-added tax (VAT) number (for corporate customers). */
  vat_id?: Maybe<Scalars['String']['output']>;
  /** The ward name. */
  ward?: Maybe<Scalars['String']['output']>;
  /** The ward id. */
  ward_id?: Maybe<Scalars['ID']['output']>;
};

export type OrderItem = OrderItemInterface & {
  __typename?: 'OrderItem';
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The image URL of the base product. */
  product_image?: Maybe<Scalars['String']['output']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** Detect if this item has a review yet */
  reviewed: Scalars['Boolean']['output'];
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Order item details. */
export type OrderItemInterface = {
  /** The final discount information for the product. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The entered option for the base product, such as a logo or image. */
  entered_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The unique ID for an `OrderItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The image URL of the base product. */
  product_image?: Maybe<Scalars['String']['output']>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price of the base product, including selected options. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The type of product, such as simple, configurable, etc. */
  product_type?: Maybe<Scalars['String']['output']>;
  /** URL key of the base product. */
  product_url_key?: Maybe<Scalars['String']['output']>;
  /** The number of canceled items. */
  quantity_canceled?: Maybe<Scalars['Float']['output']>;
  /** The number of invoiced items. */
  quantity_invoiced?: Maybe<Scalars['Float']['output']>;
  /** The number of units ordered for this item. */
  quantity_ordered?: Maybe<Scalars['Float']['output']>;
  /** The number of refunded items. */
  quantity_refunded?: Maybe<Scalars['Float']['output']>;
  /** The number of returned items. */
  quantity_returned?: Maybe<Scalars['Float']['output']>;
  /** The number of shipped items. */
  quantity_shipped?: Maybe<Scalars['Float']['output']>;
  /** The selected options for the base product, such as color or size. */
  selected_options?: Maybe<Array<Maybe<OrderItemOption>>>;
  /** The status of the order item. */
  status?: Maybe<Scalars['String']['output']>;
};

/** Represents order item options like selected or entered. */
export type OrderItemOption = {
  __typename?: 'OrderItemOption';
  /** The name of the option. */
  label: Scalars['String']['output'];
  /** The value of the option. */
  value: Scalars['String']['output'];
};

/** Contains details about the payment method used to pay for the order. */
export type OrderPaymentMethod = {
  __typename?: 'OrderPaymentMethod';
  /** Additional data per payment method type. */
  additional_data?: Maybe<Array<Maybe<KeyValue>>>;
  /** The label that describes the payment method. */
  name: Scalars['String']['output'];
  /** The payment method code that indicates how the order was paid for. */
  type: Scalars['String']['output'];
};

export type OrderReviewInformation = {
  /** Order number */
  order_number: Scalars['String']['input'];
  /** SKU */
  sku: Scalars['String']['input'];
};

/** Contains order shipment details. */
export type OrderShipment = {
  __typename?: 'OrderShipment';
  /** Comments added to the shipment. */
  comments?: Maybe<Array<Maybe<SalesCommentItem>>>;
  /** The unique ID for a `OrderShipment` object. */
  id: Scalars['ID']['output'];
  /** An array of items included in the shipment. */
  items?: Maybe<Array<Maybe<ShipmentItemInterface>>>;
  /** The sequential credit shipment number. */
  number: Scalars['String']['output'];
  /** An array of shipment tracking details. */
  tracking?: Maybe<Array<Maybe<ShipmentTracking>>>;
};

/** Represents an available status the order can transition to. */
export type OrderStatus = {
  __typename?: 'OrderStatus';
  label: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

/** Status history and possible next statuses of an order. */
export type OrderStatusHistory = {
  __typename?: 'OrderStatusHistory';
  available_statuses: AvailableOrderHistoryStatuses;
  history: Array<OrderStatusHistoryItem>;
};

/** Describes an item in the order's status history timeline. */
export type OrderStatusHistoryItem = {
  __typename?: 'OrderStatusHistoryItem';
  created_at: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Contains details about the sales total amounts used to calculate the final price. */
export type OrderTotal = {
  __typename?: 'OrderTotal';
  /** The final base grand total amount in the base currency. */
  base_grand_total: Money;
  /** The applied discounts to the order. */
  discounts?: Maybe<Array<Maybe<Discount>>>;
  /** The final total amount, including shipping, discounts, and taxes. */
  grand_total: Money;
  /** Details about the shipping and handling costs for the order. */
  shipping_handling?: Maybe<ShippingHandling>;
  /** The subtotal of the order, excluding shipping, discounts, and taxes. */
  subtotal: Money;
  /** The order tax details. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The shipping amount for the order. */
  total_shipping: Money;
  /** The amount of tax applied to the order. */
  total_tax: Money;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** The current page of brands. */
  current_page?: Maybe<Scalars['Int']['output']>;
  /** The page size of brands. */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** The total number of items. */
  total_count?: Maybe<Scalars['Int']['output']>;
  /** The total number of pages. */
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PaginationData = {
  __typename?: 'PaginationData';
  current_page?: Maybe<Scalars['Int']['output']>;
  items_count?: Maybe<Scalars['Int']['output']>;
  items_per_page?: Maybe<Scalars['Int']['output']>;
  total_items?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

/** Enum for participant types */
export enum ParticipantType {
  Fandom = 'FANDOM',
  NursingFather = 'NURSING_FATHER',
  NursingMother = 'NURSING_MOTHER',
  Other = 'OTHER',
  PregnantFather = 'PREGNANT_FATHER',
  PregnantMother = 'PREGNANT_MOTHER'
}

export type PaymentInformation = {
  __typename?: 'PaymentInformation';
  payment_url: Scalars['String']['output'];
};

export type PaymentMethodInput = {
  braintree?: InputMaybe<BraintreeInput>;
  braintree_cc_vault?: InputMaybe<BraintreeCcVaultInput>;
  /** Payment method code */
  code: Scalars['String']['input'];
  /** Purchase order number */
  purchase_order_number?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentMethodSettings = {
  __typename?: 'PaymentMethodSettings';
  payment_method_configs?: Maybe<Array<Maybe<EnabledPaymentMethod>>>;
};

export type PaymentOrderInformation = {
  __typename?: 'PaymentOrderInformation';
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** Success */
  success: Scalars['Boolean']['output'];
  /** Order payment token */
  token?: Maybe<Scalars['String']['output']>;
  /** Order payment Link */
  url?: Maybe<Scalars['String']['output']>;
};

export type PaymentOrderLinkResponse = {
  __typename?: 'PaymentOrderLinkResponse';
  /** Checksum of the payment order link. This is used to verify the authenticity of the payment order link. */
  checksum: Scalars['String']['output'];
  /** Error Code */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** Signature of the payment order link. This is used to verify the authenticity of the payment order link. */
  signature: Scalars['String']['output'];
  /** Success */
  success: Scalars['Boolean']['output'];
  /** Target of the payment order link. This is the URL where the user should be redirected to. */
  target: Scalars['String']['output'];
  /** Payment Order Link */
  url: Scalars['String']['output'];
};

export type PaymentOrderTransactionStatusResponse = {
  __typename?: 'PaymentOrderTransactionStatusResponse';
  create_time?: Maybe<Scalars['Int']['output']>;
  /** Error Code */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  reference_id: Scalars['String']['output'];
  status?: Maybe<Scalars['Int']['output']>;
  /** Success */
  success: Scalars['Boolean']['output'];
  transaction_type?: Maybe<Scalars['Int']['output']>;
  update_time?: Maybe<Scalars['Int']['output']>;
};

/** The stored payment method available to the customer */
export type PaymentToken = {
  __typename?: 'PaymentToken';
  /** Stored account details */
  details?: Maybe<Scalars['String']['output']>;
  /** The payment method code associated with the token */
  payment_method_code: Scalars['String']['output'];
  /** The public hash of the token */
  public_hash: Scalars['String']['output'];
  type: PaymentTokenTypeEnum;
};

/** The list of available payment token types */
export enum PaymentTokenTypeEnum {
  /** @deprecated  */
  Account = 'account',
  /** @deprecated  */
  Card = 'card'
}

/** PhysicalProductInterface contains attributes specific to tangible products. */
export type PhysicalProductInterface = {
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
};

export type PickedGiftInput = {
  /** The rule id of cart price rule. */
  rule_id: Scalars['Int']['input'];
  /** The product sku. */
  sku: Scalars['String']['input'];
};

export type PlaceOrderInput = {
  cart_id: Scalars['String']['input'];
};

export type PlaceOrderOutput = {
  __typename?: 'PlaceOrderOutput';
  order: Order;
};

/** popular search keyword input and response */
export type PopularSearchKeyword = {
  __typename?: 'PopularSearchKeyword';
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** The post information. */
export type Post = {
  __typename?: 'Post';
  /** The author of the post. */
  author?: Maybe<Scalars['String']['output']>;
  /** The comment status of the post. */
  comment_status?: Maybe<Scalars['String']['output']>;
  /** The default url of the post. */
  guid?: Maybe<Scalars['String']['output']>;
  /** The id of the post. */
  id?: Maybe<Scalars['String']['output']>;
  /** The content of the post. */
  post_content?: Maybe<Scalars['String']['output']>;
  /** The date posted the post. */
  post_date?: Maybe<Scalars['String']['output']>;
  /** The excerpt of the post. */
  post_excerpt?: Maybe<Scalars['String']['output']>;
  /** The date modified the post. */
  post_modified?: Maybe<Scalars['String']['output']>;
  /** The date modified the post by GMT. */
  post_modified_gmt?: Maybe<Scalars['String']['output']>;
  /** The post name of the post. */
  post_name?: Maybe<Scalars['String']['output']>;
  /** The status of the post. */
  post_status?: Maybe<Scalars['String']['output']>;
  /** The title of the post. */
  post_title?: Maybe<Scalars['String']['output']>;
  /** The type of the post. */
  post_type?: Maybe<Scalars['String']['output']>;
  /** The url of the post. */
  post_url?: Maybe<Scalars['String']['output']>;
  /** The thumbnail image of the post. */
  thumb_img?: Maybe<Scalars['String']['output']>;
  /** The views count of the post. */
  views_count?: Maybe<Scalars['Int']['output']>;
};

/** An array posts. */
export type Posts = {
  __typename?: 'Posts';
  /** The background color of post block. */
  background_color?: Maybe<Scalars['String']['output']>;
  /** Returns an array post. */
  items?: Maybe<Array<Maybe<Post>>>;
  /** Contains pagination metadata. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** The banner of post block. */
  post_banner?: Maybe<Scalars['String']['output']>;
  /** The total count of brands. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Price is deprecated, replaced by ProductPrice. The Price object defines the price of a product as well as any tax-related adjustments. */
export type Price = {
  __typename?: 'Price';
  /**
   * An array that provides information about tax, weee, or weee_tax adjustments.
   * @deprecated Price is deprecated, use ProductPrice.
   */
  adjustments?: Maybe<Array<Maybe<PriceAdjustment>>>;
  /**
   * The price of a product plus a three-letter currency code.
   * @deprecated Price is deprecated, use ProductPrice.
   */
  amount?: Maybe<Money>;
};

/** PriceAdjustment is deprecated. Taxes will be included or excluded in the price. The PricedAdjustment object defines the amount of money to apply as an adjustment, the type of adjustment to apply, and whether the item is included or excluded from the adjustment. */
export type PriceAdjustment = {
  __typename?: 'PriceAdjustment';
  /** The amount of the price adjustment and its currency code. */
  amount?: Maybe<Money>;
  /**
   * Indicates whether the adjustment involves tax, weee, or weee_tax.
   * @deprecated PriceAdjustment is deprecated.
   */
  code?: Maybe<PriceAdjustmentCodesEnum>;
  /**
   * Indicates whether the entity described by the code attribute is included or excluded from the adjustment.
   * @deprecated PriceAdjustment is deprecated.
   */
  description?: Maybe<PriceAdjustmentDescriptionEnum>;
};

/** PriceAdjustment.code is deprecated. This enumeration contains values defined in modules other than the Catalog module. */
export enum PriceAdjustmentCodesEnum {
  /** @deprecated PriceAdjustmentCodesEnum is deprecated. Tax is included or excluded in price. Tax is not shown separtely in Catalog */
  Tax = 'TAX',
  /** @deprecated WEEE code is deprecated, use fixed_product_taxes.label */
  Weee = 'WEEE',
  /** @deprecated Use fixed_product_taxes. PriceAdjustmentCodesEnum is deprecated. Tax is included or excluded in price. Tax is not shown separtely in Catalog */
  WeeeTax = 'WEEE_TAX'
}

/** PriceAdjustmentDescriptionEnum is deprecated. This enumeration states whether a price adjustment is included or excluded. */
export enum PriceAdjustmentDescriptionEnum {
  /** @deprecated  */
  Excluded = 'EXCLUDED',
  /** @deprecated  */
  Included = 'INCLUDED'
}

/** Price range for a product. If the product has a single price, the minimum and maximum price will be the same. */
export type PriceRange = {
  __typename?: 'PriceRange';
  /** The highest possible price for the product. */
  maximum_price?: Maybe<ProductPrice>;
  /** The lowest possible price for the product. */
  minimum_price: ProductPrice;
};

/** This enumeration the price type. */
export enum PriceTypeEnum {
  /** @deprecated  */
  Dynamic = 'DYNAMIC',
  /** @deprecated  */
  Fixed = 'FIXED',
  /** @deprecated  */
  Percent = 'PERCENT'
}

/** This enumeration defines whether a bundle product's price is displayed as the lowest possible value or as a range. */
export enum PriceViewEnum {
  /** @deprecated  */
  AsLowAs = 'AS_LOW_AS',
  /** @deprecated  */
  PriceRange = 'PRICE_RANGE'
}

export type ProductAchievement = {
  __typename?: 'ProductAchievement';
  /** The background color of product achievement. */
  background_color?: Maybe<Scalars['String']['output']>;
  /** The border color of product achievement. */
  border_color?: Maybe<Scalars['String']['output']>;
  /** The description of product achievement. */
  description?: Maybe<Scalars['String']['output']>;
  /** The end date of product achievement. */
  end_date?: Maybe<Scalars['String']['output']>;
  /** The id of product achievement. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The image of product achievement. */
  image?: Maybe<Scalars['String']['output']>;
  /** The status of product achievement. */
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** The name of product achievement. */
  name?: Maybe<Scalars['String']['output']>;
  /** The position of product achievement. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The start date of product achievement. */
  start_date?: Maybe<Scalars['String']['output']>;
  /** The target link of product achievement. */
  target_link?: Maybe<Scalars['String']['output']>;
  /** The text color of product achievement. */
  text_color?: Maybe<Scalars['String']['output']>;
};

export type ProductAchievementContentFilter = {
  /** Entity ID of the Achievement */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Entity Type of the Achievement */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** ProductAttributeFilterInput defines the filters to be used in the search. A filter contains at least one attribute, a comparison operator, and the value that is being searched for. */
export type ProductAttributeFilterInput = {
  /** Attribute label: Chọn tuổi */
  age?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Best Selling */
  best_seller_sorting?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Brand */
  brand?: InputMaybe<FilterEqualTypeInput>;
  /** Filter product by category id */
  category_id?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Chất liệu */
  chat_lieu?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Chất liệu gỗ */
  chat_lieu_go?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Màu sắc */
  color?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Mệnh giá */
  denomination?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Dung tích */
  dungtich?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Khối lượng */
  gram?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Has Any Discount */
  has_any_discount?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Has gift */
  has_gift?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Is Discount */
  is_discount?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Kích thước (Bao bì) */
  kich_thuoc?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Xuất xứ */
  made_in?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Product Name */
  name?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Kích thước núm ty */
  nipple_size?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Price */
  price?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Promotion Information From */
  promotion_info_time_from?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Promotion Information To */
  promotion_info_time_to?: InputMaybe<FilterRangeTypeInput>;
  /** Attribute label: Product Rating */
  ratings_summary?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Giới tính */
  sex?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Kích thước */
  size?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Size bỉm */
  size_bim?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: SKU */
  sku?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: Số tầng */
  so_tang?: InputMaybe<FilterEqualTypeInput>;
  /** Attribute label: URL Key */
  url_key?: InputMaybe<FilterMatchTypeInput>;
  /** Attribute label: Cân nặng của bé */
  weight_bim?: InputMaybe<FilterEqualTypeInput>;
};

/** ProductAttributeSortInput specifies the attribute to use for sorting search results and indicates whether the results are sorted in ascending or descending order. It's possible to sort products using searchable attributes with enabled 'Use in Filter Options' option */
export type ProductAttributeSortInput = {
  /** Attribute label: Best Selling */
  best_seller_sorting?: InputMaybe<SortEnum>;
  /** Attribute label: Hot Product */
  hot_product?: InputMaybe<SortEnum>;
  /** Attribute label: New Product */
  new_product?: InputMaybe<SortEnum>;
  /** Sort by the position assigned to each product. */
  position?: InputMaybe<SortEnum>;
  /** Attribute label: Price High To Low */
  price?: InputMaybe<SortEnum>;
  /** Attribute label: Price Low To High */
  price_low_to_high?: InputMaybe<SortEnum>;
  /** Sort by the search relevance score (default). */
  relevance?: InputMaybe<SortEnum>;
};

export type ProductBadge = {
  __typename?: 'ProductBadge';
  /** The description product badge. */
  description?: Maybe<Scalars['String']['output']>;
  /** The end date product badge. */
  end_date?: Maybe<Scalars['String']['output']>;
  /** The id product badge. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The image product badge. */
  image?: Maybe<Scalars['String']['output']>;
  /** The status product badge. */
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** The name product badge. */
  name?: Maybe<Scalars['String']['output']>;
  /** The position product badge. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The start date product badge. */
  start_date?: Maybe<Scalars['String']['output']>;
};

export type ProductBlock = {
  __typename?: 'ProductBlock';
  /** The product layout for Homepage App. */
  app_layout_type?: Maybe<LayoutData>;
  /** The block type. */
  block_type?: Maybe<Scalars['String']['output']>;
  /** The first highlight product. */
  highlight_items?: Maybe<Array<Maybe<HighlightProductItem>>>;
  /** The identifier. */
  id?: Maybe<Scalars['String']['output']>;
  /** The is auto of product. */
  is_auto?: Maybe<Scalars['String']['output']>;
  /** The product limit for Home Page (App). */
  limit_products_for_app?: Maybe<Scalars['Int']['output']>;
  /** The product limit for Home Page (Web). */
  limit_products_for_web?: Maybe<Scalars['Int']['output']>;
  /** The limit quantity products. */
  limit_qty_products?: Maybe<Scalars['Int']['output']>;
  /** The name of block. */
  name?: Maybe<Scalars['String']['output']>;
  /** An array of products that match the specified query data */
  products?: Maybe<Products>;
};


export type ProductBlockProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductCartPriceRule = {
  __typename?: 'ProductCartPriceRule';
  description?: Maybe<Scalars['String']['output']>;
  discount_step?: Maybe<Scalars['Int']['output']>;
  discounted_price?: Maybe<Money>;
  from_date?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  percentage_discount?: Maybe<Scalars['Float']['output']>;
  rule_id?: Maybe<Scalars['Int']['output']>;
  savings?: Maybe<Money>;
  to_date?: Maybe<Scalars['String']['output']>;
};

/** A discount applied to a product price. */
export type ProductDiscount = {
  __typename?: 'ProductDiscount';
  /** The actual value of the discount. */
  amount_off?: Maybe<Scalars['Float']['output']>;
  /** The discount expressed a percentage. */
  percent_off?: Maybe<Scalars['Float']['output']>;
};

/** An array product FAQs. */
export type ProductFaQs = {
  __typename?: 'ProductFAQs';
  /** An array of product FAQs that match the specified search criteria. */
  items?: Maybe<Array<Maybe<FaqQuestion>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<PageInfo>;
  /** The number of FAQs returned. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

/** Product image information. Contains the image URL and label. */
export type ProductImage = MediaGalleryInterface & {
  __typename?: 'ProductImage';
  /** Whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
};

/** The ProductInterface contains attributes that are common to all types of products. Note that descriptions may not be available for custom and EAV attributes. */
export type ProductInterface = {
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** Return a related products array. */
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead. But in Magento 2.3.4 and higher versions __typename is not available for products. Use `... on SimpleProduct` instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

/** ProductLinks contains information about linked products, including the link type and product type of each item. */
export type ProductLinksInterface = {
  /** One of related, associated, upsell, or crosssell. */
  link_type?: Maybe<Scalars['String']['output']>;
  /** The SKU of the linked product. */
  linked_product_sku?: Maybe<Scalars['String']['output']>;
  /** The type of linked product (simple, virtual, bundle, downloadable, grouped, configurable). */
  linked_product_type?: Maybe<Scalars['String']['output']>;
  /** The position within the list of product links. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The identifier of the linked product. */
  sku?: Maybe<Scalars['String']['output']>;
};

/** Configs of catalog-products-list widget */
export type ProductListConfig = {
  __typename?: 'ProductListConfig';
  /** Number of product in initial loading */
  initial_load_count?: Maybe<Scalars['Int']['output']>;
  /** Layout type to show product list. Ex: Slide, Grid */
  layout_type?: Maybe<Scalars['Int']['output']>;
  /** Number of product for load more */
  load_more_count?: Maybe<Scalars['Int']['output']>;
};

/** ProductMediaGalleryEntriesContent contains an image in base64 format and basic information about the image. */
export type ProductMediaGalleryEntriesContent = {
  __typename?: 'ProductMediaGalleryEntriesContent';
  /** The image in base64 format. */
  base64_encoded_data?: Maybe<Scalars['String']['output']>;
  /** The file name of the image. */
  name?: Maybe<Scalars['String']['output']>;
  /** The MIME type of the file, such as image/png. */
  type?: Maybe<Scalars['String']['output']>;
};

/** ProductMediaGalleryEntriesVideoContent contains a link to a video file and basic information about the video. */
export type ProductMediaGalleryEntriesVideoContent = {
  __typename?: 'ProductMediaGalleryEntriesVideoContent';
  /** Must be external-video. */
  media_type?: Maybe<Scalars['String']['output']>;
  /** A description of the video. */
  video_description?: Maybe<Scalars['String']['output']>;
  /** Optional data about the video. */
  video_metadata?: Maybe<Scalars['String']['output']>;
  /** Describes the video source. */
  video_provider?: Maybe<Scalars['String']['output']>;
  /** The title of the video. */
  video_title?: Maybe<Scalars['String']['output']>;
  /** The URL to the video. */
  video_url?: Maybe<Scalars['String']['output']>;
};

export type ProductNotification = {
  __typename?: 'ProductNotification';
  content?: Maybe<Scalars['String']['output']>;
  notification_id?: Maybe<Scalars['Int']['output']>;
  notification_type?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Description for enumType ProductPageType. */
export enum ProductPageType {
  /**
   * The bestseller products.
   * @deprecated
   */
  Bestseller = 'BESTSELLER',
  /**
   * The highlight products.
   * @deprecated
   */
  Highlight = 'HIGHLIGHT',
  /**
   * The new arrival products.
   * @deprecated
   */
  NewArrival = 'NEW_ARRIVAL'
}

/** An array posts in product detail page. */
export type ProductPosts = {
  __typename?: 'ProductPosts';
  /** An array of posts that match the specified query data. */
  items?: Maybe<Array<Maybe<Post>>>;
};

/** Represents a product price. */
export type ProductPrice = {
  __typename?: 'ProductPrice';
  /** The price discount. Represents the difference between the regular and final price. */
  discount?: Maybe<ProductDiscount>;
  /** The final price of the product after discounts applied. */
  final_price: Money;
  /** The multiple FPTs that can be applied to a product price. */
  fixed_product_taxes?: Maybe<Array<Maybe<FixedProductTax>>>;
  /** The regular price of the product. */
  regular_price: Money;
};

/** ProductPrices is deprecated, replaced by PriceRange. The ProductPrices object contains the regular price of an item, as well as its minimum and maximum prices. Only composite products, which include bundle, configurable, and grouped products, can contain a minimum and maximum price. */
export type ProductPrices = {
  __typename?: 'ProductPrices';
  /**
   * The highest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the to value.
   * @deprecated Use PriceRange.maximum_price.
   */
  maximalPrice?: Maybe<Price>;
  /**
   * The lowest possible final price for all the options defined within a composite product. If you are specifying a price range, this would be the from value.
   * @deprecated Use PriceRange.minimum_price.
   */
  minimalPrice?: Maybe<Price>;
  /**
   * The base price of a product.
   * @deprecated Use regular_price from PriceRange.minimum_price or PriceRange.maximum_price.
   */
  regularPrice?: Maybe<Price>;
};

export type ProductReviewsAggregationResponse = {
  __typename?: 'ProductReviewsAggregationResponse';
  /** aggregation of reviews */
  aggregations?: Maybe<Array<Maybe<ReviewAggregation>>>;
  /** The rating average value returned that match the specified filter criteria */
  rating_average?: Maybe<Scalars['Float']['output']>;
};

export type ProductReviewsAggregationV2Response = {
  __typename?: 'ProductReviewsAggregationV2Response';
  /** aggregation of all reviews */
  all_reviews_aggregation?: Maybe<Array<Maybe<ReviewAggregation>>>;
  /** "The average rating value returned matches the specified filter criteria. */
  average_rating?: Maybe<Scalars['Float']['output']>;
  /** aggregation of reviews that had images */
  has_image_reviews_aggregation?: Maybe<Array<Maybe<ReviewAggregation>>>;
};

export type ProductReviewsResponse = {
  __typename?: 'ProductReviewsResponse';
  /** An array of review that match the specified filter criteria */
  items?: Maybe<Array<Maybe<Review>>>;
  /** An object that includes the page_info and currentPage values specified in the query */
  page_info?: Maybe<PageInfo>;
  /** The number of reviews returned that match specified filter criteria */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export type ProductSalableQuantity = {
  __typename?: 'ProductSalableQuantity';
  /** The available salable quantity of the product. */
  available_quantity?: Maybe<Scalars['Float']['output']>;
  /** An array of errors, if any occurred while checking the product. */
  errors?: Maybe<Array<Maybe<ProductSalableQuantityError>>>;
  /** Indicates whether the product is salable. True if the salable quantity > 0. */
  is_salable?: Maybe<Scalars['Boolean']['output']>;
  /** The SKU of the product. */
  sku?: Maybe<Scalars['String']['output']>;
};

export type ProductSalableQuantityError = {
  __typename?: 'ProductSalableQuantityError';
  /** The type of the error. */
  code?: Maybe<Scalars['String']['output']>;
  /** The message of the error. */
  message?: Maybe<Scalars['String']['output']>;
};

export type ProductSalableQuantityInput = {
  /** The quantity requested for this product. */
  request_qty: Scalars['Int']['input'];
  /** The SKU of the product. */
  sku: Scalars['String']['input'];
};

/** This enumeration states whether a product stock status is in stock or out of stock */
export enum ProductStockStatus {
  /** @deprecated  */
  InStock = 'IN_STOCK',
  /** @deprecated  */
  OutOfStock = 'OUT_OF_STOCK'
}

export type ProductSuggestedHashTags = {
  __typename?: 'ProductSuggestedHashTags';
  /** Tag items for category. */
  hash_tags?: Maybe<Scalars['String']['output']>;
};

export type ProductTags = {
  __typename?: 'ProductTags';
  /** An array of tags */
  items?: Maybe<Array<Maybe<Tag>>>;
};

/** ProductTierPrices is deprecated and has been replaced by TierPrice. The ProductTierPrices object defines a tier price, which is a quantity discount offered to a specific customer group. */
export type ProductTierPrices = {
  __typename?: 'ProductTierPrices';
  /**
   * The ID of the customer group.
   * @deprecated customer_group_id is not relevant for storefront.
   */
  customer_group_id?: Maybe<Scalars['String']['output']>;
  /**
   * The percentage discount of the item.
   * @deprecated ProductTierPrices is deprecated. Use TierPrice.discount.
   */
  percentage_value?: Maybe<Scalars['Float']['output']>;
  /**
   * The number of items that must be purchased to qualify for tier pricing.
   * @deprecated ProductTierPrices is deprecated, use TierPrice.quantity.
   */
  qty?: Maybe<Scalars['Float']['output']>;
  /**
   * The price of the fixed price item.
   * @deprecated ProductTierPrices is deprecated. Use TierPrice.final_price
   */
  value?: Maybe<Scalars['Float']['output']>;
  /**
   * The ID assigned to the website.
   * @deprecated website_id is not relevant for storefront.
   */
  website_id?: Maybe<Scalars['Float']['output']>;
};

export type ProductToWishlistOutput = {
  __typename?: 'ProductToWishlistOutput';
  /** Is added to wishlist. */
  is_added_to_wishlist?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the product. */
  product_id?: Maybe<Scalars['Int']['output']>;
  /** The number wishlist of product. */
  wishlist_count?: Maybe<Scalars['Int']['output']>;
};

/** Contains information about a product video. */
export type ProductVideo = MediaGalleryInterface & {
  __typename?: 'ProductVideo';
  /** Whether the image is hidden from view. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the product image or video. */
  label?: Maybe<Scalars['String']['output']>;
  /** The media item's position after it has been sorted. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The URL of the product image or video. */
  url?: Maybe<Scalars['String']['output']>;
  /** Contains a ProductMediaGalleryEntriesVideoContent object. */
  video_content?: Maybe<ProductMediaGalleryEntriesVideoContent>;
};

/** The Products object is the top-level object returned in a product search. */
export type Products = {
  __typename?: 'Products';
  /** Layered navigation aggregations. */
  aggregations?: Maybe<Array<Maybe<Aggregation>>>;
  /**
   * Layered navigation filters array.
   * @deprecated Use aggregations instead
   */
  filters?: Maybe<Array<Maybe<LayerFilter>>>;
  /** An array of products that match the specified search criteria. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
  /** An object that includes the page_info and currentPage values specified in the query. */
  page_info?: Maybe<SearchResultPageInfo>;
  /** An object that includes the default sort field and all available sort fields. */
  sort_fields?: Maybe<SortFields>;
  /** The number of products returned. */
  total_count?: Maybe<Scalars['Int']['output']>;
};

export enum ProviderEnum {
  Fptsms = 'FPTSMS',
  Vsms = 'VSMS',
  Zalooa = 'ZALOOA'
}

export type PurchaseContentInput = {
  item_price?: InputMaybe<Scalars['Int']['input']>;
  product_id: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
};

export type PurchaseEventInput = {
  purchase_info?: InputMaybe<PurchaseInfoInput>;
  user: UserDataInput;
};

export type PurchaseInfoInput = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  contents?: InputMaybe<Array<PurchaseContentInput>>;
  currency: Scalars['String']['input'];
  order_id?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Int']['input'];
};

export type PurchaseTrackingEventInput = {
  context?: InputMaybe<EventContextInput>;
  data?: InputMaybe<PurchaseEventInput>;
};

export type PurchasedProductStatus = {
  __typename?: 'PurchasedProductStatus';
  is_purchased: Scalars['Boolean']['output'];
};

/** Query type for fetching data */
export type Query = {
  __typename?: 'Query';
  /** Returns an array available rules. */
  availableCartPriceRules?: Maybe<AvailableRules>;
  /** Returns information about available coupons */
  availableCoupons?: Maybe<Array<Maybe<SalesRule>>>;
  /** Returns list gifts that can applied to cart. */
  availableGiftsCart?: Maybe<AvailableGiftsCart>;
  bannerConfig?: Maybe<BannerConfig>;
  /** Returns best seller products on homepage blocks */
  bestsellerProducts?: Maybe<BlockProducts>;
  /** Returns brands for category */
  brands?: Maybe<Brands>;
  /** Returns popups for pages. */
  bssPopups?: Maybe<BssPopups>;
  cancelOrderReason?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cancellableOrderStatuses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Returns information about shopping cart */
  cart?: Maybe<Cart>;
  /** Return items which are out of stock or lack of quantity */
  cartItemsStatus: Array<Maybe<ItemStatus>>;
  /** Returns information about raw data of cart. */
  cartMeta?: Maybe<CartMeta>;
  /**
   * The category query searches for categories that match the criteria specified in the search and filter attributes.
   * @deprecated Use 'categoryList' query instead of 'category' query
   */
  category?: Maybe<CategoryTree>;
  /** Returns banners for category page. */
  categoryBanners?: Maybe<CategoryBanners>;
  /** Returns highlight products by category */
  categoryHighlightProducts?: Maybe<CategoryHighlightProducts>;
  /** Returns an array of categories based on the specified filters. */
  categoryList?: Maybe<Array<Maybe<CategoryTree>>>;
  /** Return useful posts for category. */
  categoryPosts?: Maybe<CategoryPosts>;
  /** Returns tags for category page. */
  categoryTags?: Maybe<CategoryTags>;
  /** Fetch referral code entity */
  checkEventReferralCodeExist: Scalars['Boolean']['output'];
  /** The Checkout Agreements information */
  checkoutAgreements?: Maybe<Array<Maybe<CheckoutAgreement>>>;
  /** The CMS block query returns information about CMS blocks */
  cmsBlocks?: Maybe<CmsBlocks>;
  /** The CMS page query returns information about a CMS page */
  cmsPage?: Maybe<CmsPage>;
  /** Query return information of cms page from magento with json schema of content */
  cmsPageByIdentifier?: Maybe<GetCmsPageSchemaByIdentifierResponse>;
  /** Query return information of cms page from magento with additional content_fragment field */
  cmsPageWidget?: Maybe<CmsPageResponse>;
  coreConfig?: Maybe<CoreConfig>;
  /** The countries query provides information for all countries. */
  countries?: Maybe<Array<Maybe<Country>>>;
  /** The countries query provides information for a single country. */
  country?: Maybe<Country>;
  couponWidgetContent?: Maybe<Array<Maybe<CouponContentResponse>>>;
  /** The currency query returns information about store currency. */
  currency?: Maybe<Currency>;
  /** The customAttributeMetadata query returns the attribute type, given an attribute code and entity type */
  customAttributeMetadata?: Maybe<CustomAttributeMetadata>;
  /** The customer query returns information about a customer account */
  customer?: Maybe<Customer>;
  /** Returns an array active carts for customer. */
  customerActiveCarts?: Maybe<Array<Maybe<Cart>>>;
  /** Returns information about the customer shopping cart */
  customerCart: Cart;
  customerCouponWallet?: Maybe<Array<Maybe<CouponContentResponse>>>;
  /** The query returns the contents of a customer's downloadable products */
  customerDownloadableProducts?: Maybe<CustomerDownloadableProducts>;
  /** Returns information about customer kicoin */
  customerKicoin?: Maybe<CustomerKicoin>;
  /** List of customer orders */
  customerOrders?: Maybe<CustomerOrders>;
  /** List of customer orders */
  customerOrdersV2?: Maybe<CustomerOrdersV2>;
  /** Return a list of customer payment tokens */
  customerPaymentTokens?: Maybe<CustomerPaymentTokens>;
  customerProfile?: Maybe<CustomerInformation>;
  districts?: Maybe<Array<Maybe<District>>>;
  /** Fetch activities for a specific event by event ID */
  eventActivities: Array<EventActivity>;
  /** Fetch grouped activities for a specific event by event ID */
  eventActivityGroups: Array<Maybe<EventActivityGroup>>;
  /** Fetch all event attributes */
  eventAttributes: Array<EventAttribute>;
  /** A list of FAQ articles */
  faqArticles?: Maybe<FaqArticles>;
  /** Get FAQ Category */
  faqCategories?: Maybe<FaqCategories>;
  /** Search Questions Guest By Search Term */
  faqGuest?: Maybe<FaqListBySku>;
  faqReactionByProduct?: Maybe<Array<Maybe<FaqReaction>>>;
  faqSuggestionTags: Array<FaqSuggestionTag>;
  /** Returns cart totals quickly without full price calculation */
  fastCartTotals?: Maybe<FastCartTotals>;
  /** Returns flash sale information of a product */
  flashSaleProduct?: Maybe<FlashSaleProduct>;
  /** Returns flash sale products on homepage blocks */
  flashSaleProducts?: Maybe<FlashSaleProducts>;
  /**
   * Returns flash sale products.
   * @deprecated Use the `flashSaleProductsV3` query instead.
   */
  flashSaleProductsV2?: Maybe<FlashSaleProductsV2>;
  /** Returns flash sale products. */
  flashSaleProductsV3?: Maybe<FlashSaleProductsV2>;
  /** Returns an array Flash Sale session. */
  flashSaleSessions?: Maybe<Array<Maybe<FlashSale>>>;
  formConfig?: Maybe<FormConfigData>;
  /**
   * Returns information about free gifts on cart.
   * @deprecated Use freeGiftsInCart instead.
   */
  freeGiftCart?: Maybe<FreeGiftCart>;
  /** Returns free gifts content of a product */
  freeGifts?: Maybe<FreeGifts>;
  /** Returns an array free gifts for cart */
  freeGiftsForCart?: Maybe<Array<Maybe<FreeGiftsData>>>;
  /** Returns free gifts for product */
  freeGiftsForProduct?: Maybe<Array<Maybe<FreeGiftsData>>>;
  /** Returns information about free gifts in cart. */
  freeGiftsInCart?: Maybe<Array<Maybe<GiftCartItem>>>;
  /** Fetch all events */
  getAllEvents: Array<EventEntity>;
  /** Fetch event registrations by User */
  getEventRegistrationsByUser?: Maybe<Array<EventRegistration>>;
  /** Fetch user entity by id and signature */
  getEventUserById: EventUser;
  /** Get FAQ list by SKU */
  getFaqListBySku?: Maybe<GetFaqListBySkuResponse>;
  /** Get questions by product ID */
  getQuestions: Array<Maybe<Question>>;
  hasPurchasedProduct: PurchasedProductStatus;
  hasReviewedProduct: Scalars['Boolean']['output'];
  helloCatalogService?: Maybe<Scalars['String']['output']>;
  helloCheckoutService?: Maybe<Scalars['String']['output']>;
  helloCmsService?: Maybe<Scalars['String']['output']>;
  helloCoreService?: Maybe<Scalars['String']['output']>;
  helloSynchronizeService?: Maybe<Scalars['String']['output']>;
  helloUrlService?: Maybe<Scalars['String']['output']>;
  /** Returns highlight brands for homepage */
  highlightBrands?: Maybe<HighlightBrands>;
  /** Returns highlight categories for homepage */
  highlightCategories?: Maybe<HighlightCategories>;
  /** An array highlight product attributes of category */
  highlightProductAttributes?: Maybe<Array<Maybe<Aggregation>>>;
  /** Returns highlight products for best seller tab on homepage */
  highlightProductBlocks?: Maybe<HighlightProductBlocks>;
  /** Returns highlight products on homepage block */
  highlightProducts?: Maybe<HighlightProducts>;
  /** An array of products that match the specified query data. */
  highlightProductsPage?: Maybe<CategoryProducts>;
  /** Returns featured blocks data for Homepage. */
  homepageFeaturedBlock?: Maybe<Array<Maybe<HomepageFeaturedBlock>>>;
  /** Returns float banners on Homepage. */
  homepageFloatBanner?: Maybe<HomePageFloatBanner>;
  /** Popular keyword for homepage */
  homepagePopularSearchKeywords?: Maybe<HomepagePopularSearchKeywords>;
  /** Return useful posts for homepage */
  homepagePosts?: Maybe<HomepagePosts>;
  /** Returns interested products on homepage blocks */
  interestedProducts?: Maybe<InterestedProducts>;
  isEmailAvailable?: Maybe<IsEmailAvailableOutput>;
  lookupCustomer: LookupCustomerResponse;
  /** Fetch user entity by search string */
  lookupEventUser?: Maybe<EventUser>;
  /** Check if referral code is exist */
  lookupReferralCode?: Maybe<CustomerReferralCodeSignature>;
  /** Get user coupon of current session */
  myCoupons: Array<Maybe<IssuedCoupon>>;
  /** Get customer favorite brands */
  myFavoriteBrands?: Maybe<MyFavoriteBrands>;
  myNotificationHistory?: Maybe<Notifications>;
  myNotificationMessage?: Maybe<NotificationCustomer>;
  myQuestion?: Maybe<MyQuestions>;
  /** Returns new arrival products on homepage blocks */
  newArrivalProducts?: Maybe<NewArrivalProducts>;
  /** Returns Kredivo payment url */
  paymentInformation?: Maybe<PaymentInformation>;
  /** Query the payment methods. */
  paymentMethodSettings?: Maybe<PaymentMethodSettings>;
  paymentOrderInformation?: Maybe<PaymentOrderInformation>;
  /** Query the payment order link for a given payment method. */
  paymentOrderLink?: Maybe<PaymentOrderLinkResponse>;
  /** Query the payment order transaction status for a given payment method. */
  paymentOrderTransactionStatus?: Maybe<PaymentOrderTransactionStatusResponse>;
  /** Get popular search keyword */
  popularSearchKeywords: Array<PopularSearchKeyword>;
  /** Returns product by sku. */
  productBySku?: Maybe<ProductInterface>;
  /** Returns product by product id */
  productByUuid?: Maybe<ProductInterface>;
  productCartPriceRules?: Maybe<Array<Maybe<ProductCartPriceRule>>>;
  /** Returns an array product FAQs. */
  productFAQs?: Maybe<ProductFaQs>;
  /** Return useful posts for product. */
  productPosts?: Maybe<ProductPosts>;
  /** Get product reviews by filter */
  productReviews?: Maybe<ProductReviewsResponse>;
  /** Get product review aggregation */
  productReviewsAggregation?: Maybe<ProductReviewsAggregationResponse>;
  /** Get product review aggregation */
  productReviewsAggregationV2?: Maybe<ProductReviewsAggregationV2Response>;
  /** Get all review images by product id */
  productReviewsImagesGallery?: Maybe<Array<Maybe<ReviewMedia>>>;
  /** Returns information about salable quantity of product. */
  productSalableQuantity?: Maybe<ProductSalableQuantity>;
  /** Returns hashtags suggested for product detail page. */
  productSuggestedHashTags?: Maybe<ProductSuggestedHashTags>;
  /** Returns information for tag. */
  productTag?: Maybe<Tag>;
  /** Returns tags for product detail page. */
  productTags?: Maybe<ProductTags>;
  /** The wishlist query returns the contents of a customer's wish list */
  productWishlist?: Maybe<ProductToWishlistOutput>;
  /** The products query searches for products that match the criteria specified in the search and filter attributes. */
  products?: Maybe<Products>;
  /** Returns information about salable quantity of list products. */
  productsSalableQuantity?: Maybe<Array<Maybe<ProductSalableQuantity>>>;
  /** Returns an array products have gift or discount. */
  promotionProducts?: Maybe<Products>;
  regions?: Maybe<Array<Maybe<Region>>>;
  regionsV2: Array<Maybe<Region>>;
  /** Returns custom related products. */
  relatedProducts?: Maybe<RelatedProducts>;
  reviewTags?: Maybe<Array<Maybe<ReviewTag>>>;
  /** A list of order status */
  salesOrderStatuses: Array<SalesOrderStatus>;
  settings: Settings;
  /** Returns banners base on position provided. */
  sliderBanners?: Maybe<BannerItems>;
  /** Get slider's banners V2 */
  sliderBannersV2?: Maybe<BannerItems>;
  /** The store config query */
  storeConfig?: Maybe<StoreConfig>;
  /** Returns list regions that have KidsPlaza stores. */
  storeRegions?: Maybe<StoreRegions>;
  /** Returns list store locator. */
  storesLocator?: Maybe<StoresLocator>;
  /** Get suggest search */
  suggestionSearch?: Maybe<SuggestionSearchResponse>;
  supportMenuItems: Array<SupportMenuItem>;
  termsOfService?: Maybe<Array<Maybe<TermsOfService>>>;
  /** The urlResolver query returns the relative URL for a specified product, category or CMS page, using as input a url_key appended by the url_suffix, if one exists */
  urlResolver?: Maybe<EntityUrl>;
  /** Return the relative URL for a specified product, category or CMS page. Get from url redirects first then look up in url rewrites */
  urlResolverTwo?: Maybe<EntityUrl>;
  /** Verify update secret */
  verifyEventUserUpdateSecret: Scalars['Boolean']['output'];
  wards?: Maybe<Array<Maybe<Ward>>>;
  wardsV2: Array<Maybe<Ward>>;
  /** Returns information about current shopping cart on the web */
  webCart?: Maybe<Cart>;
  /** Returns an array banners. */
  widgetBanners?: Maybe<Array<Maybe<Banner>>>;
  /** Retrieves widget shortcut links based on a provided shortcutLinks string. */
  widgetShortcutLinks: WidgetShortcutLink;
  /** Retrieves widget shortcut links based on a provided shortcutLinks string. */
  widgetShortcutLinksV2: WidgetShortcutLinkV2;
  /** Return an array wordpress posts. */
  wpPosts?: Maybe<Posts>;
};


/** Query type for fetching data */
export type QueryAvailableGiftsCartArgs = {
  cart_id: Scalars['String']['input'];
  cart_item_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryBannerConfigArgs = {
  page_type?: InputMaybe<BannerPageType>;
};


/** Query type for fetching data */
export type QueryBrandsArgs = {
  brand_ids: Array<InputMaybe<Scalars['Int']['input']>>;
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryCartArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryCartItemsStatusArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryCartMetaArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryCategoryArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryCategoryBannersArgs = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryCategoryHighlightProductsArgs = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryCategoryListArgs = {
  filters?: InputMaybe<CategoryFilterInput>;
};


/** Query type for fetching data */
export type QueryCategoryPostsArgs = {
  category_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryCategoryTagsArgs = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryCheckEventReferralCodeExistArgs = {
  code: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryCmsBlocksArgs = {
  identifiers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Query type for fetching data */
export type QueryCmsPageArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryCmsPageByIdentifierArgs = {
  identifier?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryCmsPageWidgetArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryCountryArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryCouponWidgetContentArgs = {
  filter?: InputMaybe<CouponWidgetFilterInput>;
};


/** Query type for fetching data */
export type QueryCustomAttributeMetadataArgs = {
  attributes: Array<AttributeInput>;
};


/** Query type for fetching data */
export type QueryCustomerOrdersV2Args = {
  filter?: InputMaybe<CustomerOrderFilterV2>;
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryDistrictsArgs = {
  regionCode: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryEventActivitiesArgs = {
  eventId: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryEventActivityGroupsArgs = {
  eventId: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryFaqArticlesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  search_term?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<SortOptions>;
};


/** Query type for fetching data */
export type QueryFaqCategoriesArgs = {
  current_page: Scalars['Int']['input'];
  filters?: InputMaybe<FaqCategoryFilters>;
  page_size: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryFaqGuestArgs = {
  current_page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
  search_term: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryFaqReactionByProductArgs = {
  product_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryFaqSuggestionTagsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryFastCartTotalsArgs = {
  cart_id?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryFlashSaleProductArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryFlashSaleProductsV3Args = {
  flashsale_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryFormConfigArgs = {
  id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryFreeGiftCartArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryFreeGiftsArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryFreeGiftsForProductArgs = {
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryFreeGiftsInCartArgs = {
  cart_id: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryGetAllEventsArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryGetEventRegistrationsByUserArgs = {
  input: GetEventUserEntityInput;
};


/** Query type for fetching data */
export type QueryGetEventUserByIdArgs = {
  input: GetEventUserEntityInput;
};


/** Query type for fetching data */
export type QueryGetFaqListBySkuArgs = {
  currentPage: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryGetQuestionsArgs = {
  productId: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryHasPurchasedProductArgs = {
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryHasReviewedProductArgs = {
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryHighlightProductAttributesArgs = {
  category_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryHighlightProductBlocksArgs = {
  block_types?: InputMaybe<Array<InputMaybe<BlockTypeEnum>>>;
};


/** Query type for fetching data */
export type QueryHighlightProductsPageArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  type: ProductPageType;
};


/** Query type for fetching data */
export type QueryIsEmailAvailableArgs = {
  email: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryLookupCustomerArgs = {
  phone_number: Scalars['String']['input'];
  sign: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryLookupEventUserArgs = {
  input: LookUpEventUserInput;
};


/** Query type for fetching data */
export type QueryLookupReferralCodeArgs = {
  code: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryMyCouponsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryMyFavoriteBrandsArgs = {
  filter?: InputMaybe<FavoriteBrandFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryMyNotificationHistoryArgs = {
  filter: NotificationHistoryFilterInput;
  page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryMyNotificationMessageArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryMyQuestionArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryPaymentInformationArgs = {
  order_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryPaymentOrderInformationArgs = {
  orderId: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryPaymentOrderLinkArgs = {
  orderNumber: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryPaymentOrderTransactionStatusArgs = {
  checksum: Scalars['String']['input'];
  orderNumber: Scalars['String']['input'];
  paymentMethod: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductBySkuArgs = {
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductByUuidArgs = {
  uuid: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductCartPriceRulesArgs = {
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductFaQsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filters?: InputMaybe<FaqFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryProductPostsArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryProductReviewsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ReviewAttributeFilterInput>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryProductReviewsAggregationArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryProductReviewsAggregationV2Args = {
  product_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryProductReviewsImagesGalleryArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryProductSalableQuantityArgs = {
  request_qty: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductSuggestedHashTagsArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryProductTagArgs = {
  identifier: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryProductTagsArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryProductWishlistArgs = {
  product_id?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryProductsArgs = {
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
};


/** Query type for fetching data */
export type QueryProductsSalableQuantityArgs = {
  items?: InputMaybe<Array<ProductSalableQuantityInput>>;
};


/** Query type for fetching data */
export type QueryPromotionProductsArgs = {
  category_id: Scalars['Int']['input'];
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
};


/** Query type for fetching data */
export type QueryRelatedProductsArgs = {
  product_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QuerySettingsArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QuerySliderBannersArgs = {
  location?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QuerySliderBannersV2Args = {
  location: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QuerySuggestionSearchArgs = {
  query: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QuerySupportMenuItemsArgs = {
  location: Location;
};


/** Query type for fetching data */
export type QueryUrlResolverArgs = {
  url: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryUrlResolverTwoArgs = {
  url: Scalars['String']['input'];
};


/** Query type for fetching data */
export type QueryVerifyEventUserUpdateSecretArgs = {
  input: VerifyEventUserUpdateSecretInput;
};


/** Query type for fetching data */
export type QueryWardsArgs = {
  districtId: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryWardsV2Args = {
  region_id: Scalars['Int']['input'];
};


/** Query type for fetching data */
export type QueryWidgetBannersArgs = {
  encrypted_banner_ids?: InputMaybe<Scalars['String']['input']>;
};


/** Query type for fetching data */
export type QueryWidgetShortcutLinksArgs = {
  location?: InputMaybe<ShortcutLinkLocation>;
};


/** Query type for fetching data */
export type QueryWidgetShortcutLinksV2Args = {
  location?: InputMaybe<ShortcutLinkLocation>;
};


/** Query type for fetching data */
export type QueryWpPostsArgs = {
  current_page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  post_ids: Array<InputMaybe<Scalars['Int']['input']>>;
};

export type Question = {
  __typename?: 'Question';
  answers?: Maybe<Array<Maybe<Answer>>>;
  customerId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productId: Scalars['Int']['output'];
  question: Scalars['String']['output'];
  source: Scalars['String']['output'];
  sourceId?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionRequest = {
  captchaResponseToken: Scalars['String']['input'];
  content: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sku: Scalars['String']['input'];
};

export enum QuotaLevelEnum {
  All = 'ALL',
  Day = 'DAY'
}

export type ReferralCodeResponse = {
  __typename?: 'ReferralCodeResponse';
  /** Referral Code */
  referral_code: Scalars['String']['output'];
};

export type Region = {
  __typename?: 'Region';
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type RegisterAccountInfo = {
  /** Email */
  email: Scalars['String']['input'];
  /** First Name */
  first_name: Scalars['String']['input'];
  /** Last Name */
  last_name: Scalars['String']['input'];
  /** Password */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Website ID from the device */
  website_id: Scalars['Int']['input'];
};

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  customer_token?: Maybe<CustomerToken>;
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RelatedProducts = {
  __typename?: 'RelatedProducts';
  /** An array of products that match the specified query data. */
  items?: Maybe<Array<Maybe<ProductInterface>>>;
};

export type RemoveCouponFromCartInput = {
  cart_id: Scalars['String']['input'];
};

export type RemoveCouponFromCartOutput = {
  __typename?: 'RemoveCouponFromCartOutput';
  cart?: Maybe<Cart>;
};

export type RemoveItemFromCartInput = {
  cart_id: Scalars['String']['input'];
  cart_item_id: Scalars['Int']['input'];
};

export type RemoveItemFromCartOutput = {
  __typename?: 'RemoveItemFromCartOutput';
  cart: Cart;
};

export type RemoveKicoinsInput = {
  cart_id: Scalars['String']['input'];
};

export type RemoveKicoinsOutput = {
  __typename?: 'RemoveKicoinsOutput';
  cart: Cart;
};

export type RequestValidatePhoneResponse = {
  __typename?: 'RequestValidatePhoneResponse';
  /** Error Code if any */
  error_code?: Maybe<Scalars['String']['output']>;
  /** Message */
  message?: Maybe<Scalars['String']['output']>;
  /** Secret to verify Phone number with OTP */
  secret?: Maybe<Scalars['String']['output']>;
  /** Success */
  success: Scalars['Boolean']['output'];
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  /** Message */
  message: Scalars['String']['output'];
  /** Success */
  success: Scalars['Boolean']['output'];
};

export type Result = {
  __typename?: 'Result';
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Review = {
  __typename?: 'Review';
  /**
   * Created At
   * @deprecated use created_at instead
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Created At */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Detail */
  detail?: Maybe<Scalars['String']['output']>;
  /** Array of files */
  files?: Maybe<Array<Maybe<ReviewMedia>>>;
  /** Id */
  id?: Maybe<Scalars['String']['output']>;
  /**
   * Array of files
   * @deprecated use files instead
   */
  images?: Maybe<Array<Maybe<ReviewMedia>>>;
  /**
   * Is Liked
   * @deprecated use liked instead
   */
  is_liked?: Maybe<Scalars['Boolean']['output']>;
  /** Did Customer order the product */
  is_ordered_customer?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate if the user has liked this review yet */
  liked?: Maybe<Scalars['Boolean']['output']>;
  /** Nick name */
  nickname?: Maybe<Scalars['String']['output']>;
  order_id?: Maybe<Scalars['Int']['output']>;
  /**
   * Order number
   * @deprecated No longer supported
   */
  order_number?: Maybe<Scalars['String']['output']>;
  /** Percent */
  percent?: Maybe<Scalars['Int']['output']>;
  /** The product owns the review */
  product?: Maybe<ProductInterface>;
  /** Id of product */
  product_id?: Maybe<Scalars['String']['output']>;
  /** Rating code */
  rating_code?: Maybe<Scalars['String']['output']>;
  /** Reply */
  reply?: Maybe<Array<Maybe<ReviewOption>>>;
  /** Source */
  source?: Maybe<Scalars['String']['output']>;
  /** Status */
  status_code?: Maybe<Scalars['String']['output']>;
  /** Title */
  title?: Maybe<Scalars['String']['output']>;
  /** Total likes */
  total_likes?: Maybe<Scalars['Int']['output']>;
  /** Value */
  value?: Maybe<Scalars['Float']['output']>;
};

/** // TODO: duplicate from catalog service */
export type ReviewAggregation = {
  __typename?: 'ReviewAggregation';
  /** Attribute code of the aggregation group. */
  attribute_code: Scalars['String']['output'];
  /** The number of options in the aggregation group. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Array of options for the aggregation. */
  options?: Maybe<Array<Maybe<ReviewAggregationOption>>>;
};

export type ReviewAggregationOption = {
  __typename?: 'ReviewAggregationOption';
  /** The number of items that match the aggregation option. */
  count?: Maybe<Scalars['Int']['output']>;
  /** Aggregation option display label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The internal ID that represents the value of the option. */
  value: Scalars['String']['output'];
};

export type ReviewAttributeFilterInput = {
  brand_id?: InputMaybe<Scalars['Int']['input']>;
  /** review has image or not */
  has_image?: InputMaybe<Scalars['Boolean']['input']>;
  /** review has video or not */
  has_video?: InputMaybe<Scalars['Boolean']['input']>;
  /** product id of review */
  product_id?: InputMaybe<Scalars['Int']['input']>;
  /** rating summary of review */
  rating_value?: InputMaybe<Scalars['Float']['input']>;
};

export type ReviewMedia = {
  __typename?: 'ReviewMedia';
  /** alt of media */
  alt: Scalars['String']['output'];
  /**
   * Created At
   * @deprecated use created_at instead
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Created At */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** id of media */
  id: Scalars['String']['output'];
  /** key path of media */
  key: Scalars['String']['output'];
  /** Mine type of media */
  mime_type?: Maybe<Scalars['String']['output']>;
  /** review that has the media */
  review_id?: Maybe<Scalars['String']['output']>;
  /** Source of media */
  source?: Maybe<Scalars['String']['output']>;
  /** url of media */
  url?: Maybe<Scalars['String']['output']>;
};

export type ReviewOption = {
  __typename?: 'ReviewOption';
  /** Content */
  content?: Maybe<Scalars['String']['output']>;
  /**
   * Created At
   * @deprecated use created_at instead
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Created At */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** Id */
  id?: Maybe<Scalars['String']['output']>;
  /** Indicate if the user has liked this review yet */
  liked?: Maybe<Scalars['Boolean']['output']>;
  /** Post by */
  post_by?: Maybe<Scalars['String']['output']>;
  /** Status */
  status?: Maybe<Scalars['Int']['output']>;
  /** Total likes */
  total_likes?: Maybe<Scalars['Int']['output']>;
  /** Type */
  type?: Maybe<Scalars['String']['output']>;
};

export type ReviewReactionRequest = {
  /** like or unlike */
  reaction_type: Scalars['String']['input'];
  review_id: Scalars['String']['input'];
  /** comment or reply */
  type: Scalars['String']['input'];
};

export type ReviewReactionResponse = {
  __typename?: 'ReviewReactionResponse';
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ReviewTag = {
  __typename?: 'ReviewTag';
  content: Scalars['String']['output'];
  id: Scalars['String']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
};

export type RevokeCustomerTokenOutput = {
  __typename?: 'RevokeCustomerTokenOutput';
  result: Scalars['Boolean']['output'];
};

/** The available rule is applied for the product. */
export type Rule = {
  __typename?: 'Rule';
  /** Returns an array conditions deserialized. */
  conditions?: Maybe<Array<Maybe<Condition>>>;
  /** The description of rule. */
  description?: Maybe<Scalars['String']['output']>;
  /** The discount amount (Get Y). */
  discount_amount?: Maybe<Scalars['Int']['output']>;
  /** Maximum Qty Discount is Applied To */
  discount_qty?: Maybe<Scalars['Int']['output']>;
  /** The discount qty step (Buy X). */
  discount_step?: Maybe<Scalars['Int']['output']>;
  /** The end date of rule. */
  end_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date of rule. */
  from_date?: Maybe<Scalars['String']['output']>;
  /** The label of rule. */
  label?: Maybe<Scalars['String']['output']>;
  /** The name of rule. */
  name?: Maybe<Scalars['String']['output']>;
  /** The ID of rule. */
  rule_id?: Maybe<Scalars['Int']['output']>;
  /** The action of rule. */
  simple_action?: Maybe<Scalars['String']['output']>;
  /** The sort order of rule. */
  sort_order?: Maybe<Scalars['Int']['output']>;
  /** The discard subsequent rules. */
  stop_rules_processing?: Maybe<Scalars['Int']['output']>;
  /** The url of rule. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Contains details about a comment. */
export type SalesCommentItem = {
  __typename?: 'SalesCommentItem';
  /** The text of the message. */
  message: Scalars['String']['output'];
  /** The timestamp of the comment. */
  timestamp: Scalars['String']['output'];
};

export type SalesOrderStatus = {
  __typename?: 'SalesOrderStatus';
  /** icon url */
  icon?: Maybe<Scalars['String']['output']>;
  /** label for status */
  label: Scalars['String']['output'];
  /** key for status */
  status: Scalars['String']['output'];
};

export type SalesRule = {
  __typename?: 'SalesRule';
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  from_date?: Maybe<Scalars['String']['output']>;
  is_active?: Maybe<Scalars['Boolean']['output']>;
  is_valid?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  to_date?: Maybe<Scalars['String']['output']>;
};

export type Salesrule = {
  __typename?: 'Salesrule';
  code?: Maybe<Scalars['String']['output']>;
  coupon_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount_amount?: Maybe<Scalars['Int']['output']>;
  discount_qty?: Maybe<Scalars['Int']['output']>;
  discount_step?: Maybe<Scalars['Int']['output']>;
  expiration_date?: Maybe<Scalars['DateTime']['output']>;
  from_date?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  salesrule_id: Scalars['String']['output'];
  sort_order?: Maybe<Scalars['Int']['output']>;
  times_used?: Maybe<Scalars['Int']['output']>;
  to_date?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  usage_limit?: Maybe<Scalars['Int']['output']>;
  usage_per_customer?: Maybe<Scalars['Int']['output']>;
};

/** This enumeration defines the scope type for customer orders. */
export enum ScopeTypeEnum {
  /** @deprecated  */
  Global = 'GLOBAL',
  /** @deprecated  */
  Store = 'STORE',
  /** @deprecated  */
  Website = 'WEBSITE'
}

export type ScrollDepthInternalEventInput = {
  content_type?: InputMaybe<Scalars['String']['input']>;
  page_title?: InputMaybe<Scalars['String']['input']>;
  page_url?: InputMaybe<Scalars['String']['input']>;
  scroll_depth: Scalars['Int']['input'];
  scroll_percentage: Scalars['Float']['input'];
  session_id?: InputMaybe<Scalars['String']['input']>;
  time_on_page?: InputMaybe<Scalars['Int']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type ScrollDepthInternalEventRequest = {
  context?: InputMaybe<EventContextInput>;
  data?: InputMaybe<ScrollDepthInternalEventInput>;
};

export type SearchKeywordHistory = {
  __typename?: 'SearchKeywordHistory';
  /** Keyword that user have searched before */
  keyword: Scalars['String']['output'];
  /** The number of times the user searches this keyword */
  total: Scalars['Int']['output'];
};

/** SearchResultPageInfo provides navigation for the query response */
export type SearchResultPageInfo = {
  __typename?: 'SearchResultPageInfo';
  /** Specifies which page of results to return */
  current_page?: Maybe<Scalars['Int']['output']>;
  /** Specifies the maximum number of items to return */
  page_size?: Maybe<Scalars['Int']['output']>;
  /** Total pages */
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type SelectedBundleOption = {
  __typename?: 'SelectedBundleOption';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
  values: Array<Maybe<SelectedBundleOptionValue>>;
};

export type SelectedBundleOptionValue = {
  __typename?: 'SelectedBundleOptionValue';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
};

export type SelectedConfigurableOption = {
  __typename?: 'SelectedConfigurableOption';
  id: Scalars['Int']['output'];
  option_label: Scalars['String']['output'];
  value_id: Scalars['Int']['output'];
  value_label: Scalars['String']['output'];
};

export type SelectedCustomizableOption = {
  __typename?: 'SelectedCustomizableOption';
  id: Scalars['Int']['output'];
  is_required: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  sort_order: Scalars['Int']['output'];
  values: Array<Maybe<SelectedCustomizableOptionValue>>;
};

export type SelectedCustomizableOptionValue = {
  __typename?: 'SelectedCustomizableOptionValue';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  price: CartItemSelectedOptionValuePrice;
  value: Scalars['String']['output'];
};

export type SelectedPaymentMethod = {
  __typename?: 'SelectedPaymentMethod';
  /** The payment method code */
  code: Scalars['String']['output'];
  /** The purchase order number. */
  purchase_order_number?: Maybe<Scalars['String']['output']>;
  /** The payment method title. */
  title: Scalars['String']['output'];
};

export type SelectedShippingMethod = {
  __typename?: 'SelectedShippingMethod';
  amount: Money;
  /** @deprecated The field should not be used on the storefront */
  base_amount?: Maybe<Money>;
  carrier_code: Scalars['String']['output'];
  carrier_title: Scalars['String']['output'];
  method_code: Scalars['String']['output'];
  method_title: Scalars['String']['output'];
};

export type SeoData = {
  __typename?: 'SeoData';
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTags?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogDescription?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<Scalars['String']['output']>;
  ogTitle?: Maybe<Scalars['String']['output']>;
  twitterCardType?: Maybe<Scalars['String']['output']>;
  twitterHandle?: Maybe<Scalars['String']['output']>;
};

export type SetBillingAddressOnCartInput = {
  billing_address: BillingAddressInput;
  cart_id: Scalars['String']['input'];
};

export type SetBillingAddressOnCartOutput = {
  __typename?: 'SetBillingAddressOnCartOutput';
  cart: Cart;
};

export type SetGuestEmailOnCartInput = {
  cart_id: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type SetGuestEmailOnCartOutput = {
  __typename?: 'SetGuestEmailOnCartOutput';
  cart: Cart;
};

export type SetPaymentMethodAndPlaceOrderInput = {
  cart_id: Scalars['String']['input'];
  payment_method: PaymentMethodInput;
};

export type SetPaymentMethodOnCartInput = {
  cart_id: Scalars['String']['input'];
  payment_method: PaymentMethodInput;
};

export type SetPaymentMethodOnCartOutput = {
  __typename?: 'SetPaymentMethodOnCartOutput';
  cart: Cart;
};

export type SetShippingAddressesOnCartInput = {
  cart_id: Scalars['String']['input'];
  shipping_addresses: Array<InputMaybe<ShippingAddressInput>>;
};

export type SetShippingAddressesOnCartOutput = {
  __typename?: 'SetShippingAddressesOnCartOutput';
  cart: Cart;
};

export type SetShippingMethodsOnCartInput = {
  cart_id: Scalars['String']['input'];
  shipping_methods: Array<InputMaybe<ShippingMethodInput>>;
};

export type SetShippingMethodsOnCartOutput = {
  __typename?: 'SetShippingMethodsOnCartOutput';
  cart: Cart;
};

export type Settings = {
  __typename?: 'Settings';
  created_at: Scalars['DateTime']['output'];
  /** id of setting */
  id: Scalars['ID']['output'];
  language: Scalars['String']['output'];
  /** setting data */
  options?: Maybe<SettingsOptions>;
  /** Config data get from magento */
  storeConfig?: Maybe<StoreConfiguration>;
  /** Config data get from magento */
  store_config_v2?: Maybe<StoreConfigurationV2>;
  translated_languages: Array<Scalars['String']['output']>;
  updated_at: Scalars['DateTime']['output'];
  url_config?: Maybe<UrlConfigData>;
};

export type SettingsOptions = {
  __typename?: 'SettingsOptions';
  /** Contact details */
  contactDetails?: Maybe<ContactDetails>;
  currency?: Maybe<Scalars['String']['output']>;
  currencyToWalletRatio?: Maybe<Scalars['Int']['output']>;
  /** Delivery information */
  deliveryTime?: Maybe<Array<Maybe<DeliveryTime>>>;
  freeShipping?: Maybe<Scalars['Boolean']['output']>;
  freeShippingAmount?: Maybe<Scalars['Float']['output']>;
  /** Logo of application */
  logo?: Maybe<LogoData>;
  maximumQuestionLimit?: Maybe<Scalars['Float']['output']>;
  minimumOrderAmount?: Maybe<Scalars['Float']['output']>;
  paymentGateway?: Maybe<Scalars['String']['output']>;
  /** Default SEO data */
  seo?: Maybe<SeoData>;
  shippingClass?: Maybe<Scalars['String']['output']>;
  signupPoints?: Maybe<Scalars['Int']['output']>;
  /** Sub title of application */
  siteSubtitle?: Maybe<Scalars['String']['output']>;
  /** Title of application */
  siteTitle?: Maybe<Scalars['String']['output']>;
  taxClass?: Maybe<Scalars['String']['output']>;
  useCashOnDelivery?: Maybe<Scalars['Boolean']['output']>;
  useOtp?: Maybe<Scalars['Boolean']['output']>;
};

export type ShareChannelGroupResponse = {
  __typename?: 'ShareChannelGroupResponse';
  social_channels?: Maybe<Array<Maybe<ShareChannelItem>>>;
  utility_channels?: Maybe<Array<Maybe<ShareChannelItem>>>;
};

export type ShareChannelItem = {
  __typename?: 'ShareChannelItem';
  icon: Scalars['String']['output'];
  label: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/** This enumeration defines whether bundle items must be shipped together. */
export enum ShipBundleItemsEnum {
  /** @deprecated  */
  Separately = 'SEPARATELY',
  /** @deprecated  */
  Together = 'TOGETHER'
}

/** Order shipment item details. */
export type ShipmentItemInterface = {
  /** The unique ID for a `ShipmentItemInterface` object. */
  id: Scalars['ID']['output'];
  /** The order item associated with the shipment item. */
  order_item?: Maybe<OrderItemInterface>;
  /** The name of the base product. */
  product_name?: Maybe<Scalars['String']['output']>;
  /** The sale price for the base product. */
  product_sale_price: Money;
  /** The SKU of the base product. */
  product_sku: Scalars['String']['output'];
  /** The number of shipped items. */
  quantity_shipped: Scalars['Float']['output'];
};

/** Contains order shipment tracking details. */
export type ShipmentTracking = {
  __typename?: 'ShipmentTracking';
  /** The shipping carrier for the order delivery. */
  carrier: Scalars['String']['output'];
  /** The tracking number of the order shipment. */
  number?: Maybe<Scalars['String']['output']>;
  /** The shipment tracking title. */
  title: Scalars['String']['output'];
};

export type ShippingAddressInput = {
  address?: InputMaybe<CartAddressInput>;
  customer_address_id?: InputMaybe<Scalars['Int']['input']>;
  customer_notes?: InputMaybe<Scalars['String']['input']>;
};

export type ShippingCartAddress = CartAddressInterface & {
  __typename?: 'ShippingCartAddress';
  available_shipping_methods?: Maybe<Array<Maybe<AvailableShippingMethod>>>;
  /** @deprecated `cart_items_v2` should be used instead */
  cart_items?: Maybe<Array<Maybe<CartItemQuantity>>>;
  cart_items_v2?: Maybe<Array<Maybe<CartItemInterface>>>;
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  country: CartAddressCountry;
  customer_notes?: Maybe<Scalars['String']['output']>;
  district?: Maybe<Scalars['String']['output']>;
  district_id?: Maybe<Scalars['Int']['output']>;
  firstname: Scalars['String']['output'];
  /** @deprecated This information shoud not be exposed on frontend */
  items_weight?: Maybe<Scalars['Float']['output']>;
  lastname: Scalars['String']['output'];
  postcode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<CartAddressRegion>;
  selected_shipping_method?: Maybe<SelectedShippingMethod>;
  street: Array<Maybe<Scalars['String']['output']>>;
  telephone: Scalars['String']['output'];
  ward?: Maybe<Scalars['String']['output']>;
  ward_id?: Maybe<Scalars['Int']['output']>;
};

/** Defines an individual shipping discount. This discount can be applied to shipping. */
export type ShippingDiscount = {
  __typename?: 'ShippingDiscount';
  /** The amount of the discount. */
  amount: Money;
};

/** Contains details about shipping and handling costs. */
export type ShippingHandling = {
  __typename?: 'ShippingHandling';
  /** The shipping amount, excluding tax. */
  amount_excluding_tax?: Maybe<Money>;
  /** The shipping amount, including tax. */
  amount_including_tax?: Maybe<Money>;
  /** The applied discounts to the shipping. */
  discounts?: Maybe<Array<Maybe<ShippingDiscount>>>;
  /** Details about taxes applied for shipping. */
  taxes?: Maybe<Array<Maybe<TaxItem>>>;
  /** The total amount for shipping. */
  total_amount: Money;
};

export type ShippingMethodInput = {
  carrier_code: Scalars['String']['input'];
  method_code: Scalars['String']['input'];
};

/** Represents a shortcut link entity with its unique properties and identifiers. */
export type ShortcutLink = {
  __typename?: 'ShortcutLink';
  /** Icon associated with the shortcut link. */
  icon?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the shortcut link. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The status of shortcut link. */
  is_active?: Maybe<Scalars['Int']['output']>;
  /** The list of location to show shortcut link. */
  location?: Maybe<Scalars['String']['output']>;
  /** Name of the shortcut link. */
  name?: Maybe<Scalars['String']['output']>;
  /** Position of the shortcut link, used for ordering. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The store ids to show shortcut link. */
  store_ids?: Maybe<Scalars['String']['output']>;
  /** URL for the shortcut link. */
  url?: Maybe<Scalars['String']['output']>;
};

export enum ShortcutLinkLocation {
  CatalogPage = 'CATALOG_PAGE',
  CmsPage = 'CMS_PAGE',
  FlashSale = 'FLASH_SALE',
  Homepage = 'HOMEPAGE',
  MyAccount = 'MY_ACCOUNT',
  ProductPage = 'PRODUCT_PAGE'
}

/** Represents a shortcut link entity with its unique properties and identifiers. */
export type ShortcutLinkV2 = {
  __typename?: 'ShortcutLinkV2';
  /** Icon associated with the shortcut link. */
  icon: Scalars['String']['output'];
  /** Unique identifier for the shortcut link. */
  id: Scalars['ID']['output'];
  /** The status of shortcut link. */
  is_active: Scalars['Int']['output'];
  /** The list of location to show shortcut link. */
  location?: Maybe<Scalars['String']['output']>;
  /** Name of the shortcut link. */
  name: Scalars['String']['output'];
  /** Position of the shortcut link, used for ordering. */
  position: Scalars['Int']['output'];
  /** The corresponding shortcut link identifier in Magento. */
  shortcut_link_id: Scalars['Int']['output'];
  /** The store ids to show shortcut link. */
  store_ids: Scalars['String']['output'];
  /** URL for the shortcut link. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Simple Cart Item */
export type SimpleCartItem = CartItemInterface & {
  __typename?: 'SimpleCartItem';
  customizable_options?: Maybe<Array<Maybe<SelectedCustomizableOption>>>;
  id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

/** A simple product is tangible and are usually sold as single units or in fixed quantities. */
export type SimpleProduct = CustomizableProductInterface & PhysicalProductInterface & ProductInterface & {
  __typename?: 'SimpleProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  sold_quantity?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  /** The weight of the item, in units defined by the store. */
  weight?: Maybe<Scalars['Float']['output']>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

export type SimpleProductCartItemInput = {
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  data: CartItemInput;
};

export type SocialChannel = {
  __typename?: 'SocialChannel';
  icon?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Defines sorting direction. */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** This enumeration indicates whether to return results in ascending or descending order */
export enum SortEnum {
  /** @deprecated  */
  Asc = 'ASC',
  /** @deprecated  */
  Desc = 'DESC'
}

export type SortField = {
  __typename?: 'SortField';
  /** Label of sort field. */
  label?: Maybe<Scalars['String']['output']>;
  /** Attribute code of sort field. */
  value?: Maybe<Scalars['String']['output']>;
};

/** SortFields contains a default value for sort fields and all available sort fields. */
export type SortFields = {
  __typename?: 'SortFields';
  /** Default value of sort fields. */
  default?: Maybe<Scalars['String']['output']>;
  /** Available sort fields. */
  options?: Maybe<Array<Maybe<SortField>>>;
};

export type SortOptions = {
  direction?: InputMaybe<SortDirection>;
  field?: InputMaybe<Scalars['String']['input']>;
};

export type StaticWidget = ContentFragmentDataInterface & {
  __typename?: 'StaticWidget';
  /** Html of widget */
  html?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the widget uses lazy loading for its content */
  is_lazy_loading?: Maybe<Scalars['Boolean']['output']>;
  /** Widget type */
  type?: Maybe<Scalars['String']['output']>;
};

export type StatusMessageResponse = {
  __typename?: 'StatusMessageResponse';
  /** Describe the outcome of the delete action */
  message?: Maybe<Scalars['String']['output']>;
  /** Indicate if the delete action was successful */
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type StockStatus = {
  __typename?: 'StockStatus';
  /** error code: 102 - out of stock, 103 - lack of quantity */
  code: Scalars['Int']['output'];
  /** available product quantity */
  current_available: Scalars['Int']['output'];
  /** stock status error message */
  message: Scalars['String']['output'];
};

/** The type contains information about a store config */
export type StoreConfig = {
  __typename?: 'StoreConfig';
  /** Footer Miscellaneous HTML */
  absolute_footer?: Maybe<Scalars['String']['output']>;
  /** Base currency code */
  base_currency_code?: Maybe<Scalars['String']['output']>;
  /** Base link URL for the store */
  base_link_url?: Maybe<Scalars['String']['output']>;
  /** Base media URL for the store */
  base_media_url?: Maybe<Scalars['String']['output']>;
  /** Base static URL for the store */
  base_static_url?: Maybe<Scalars['String']['output']>;
  /** Base URL for the store */
  base_url?: Maybe<Scalars['String']['output']>;
  /** Default Sort By. */
  catalog_default_sort_by?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices In Product Lists' field. It indicates how FPT information is displayed on category pages */
  category_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Category URL Suffix. */
  category_url_suffix?: Maybe<Scalars['String']['output']>;
  /** CMS Home Page */
  cms_home_page?: Maybe<Scalars['String']['output']>;
  /** CMS No Cookies Page */
  cms_no_cookies?: Maybe<Scalars['String']['output']>;
  /** CMS No Route Page */
  cms_no_route?: Maybe<Scalars['String']['output']>;
  /** A code assigned to the store to identify it */
  code?: Maybe<Scalars['String']['output']>;
  /** Copyright */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Default Meta Description */
  default_description?: Maybe<Scalars['String']['output']>;
  /** Default display currency code */
  default_display_currency_code?: Maybe<Scalars['String']['output']>;
  /** Default Meta Keywords */
  default_keywords?: Maybe<Scalars['String']['output']>;
  /** Default Page Title */
  default_title?: Maybe<Scalars['String']['output']>;
  /** Display Demo Store Notice */
  demonotice?: Maybe<Scalars['Int']['output']>;
  /** Default Web URL */
  front?: Maybe<Scalars['String']['output']>;
  /** Products per Page on Grid Default Value. */
  grid_per_page?: Maybe<Scalars['Int']['output']>;
  /** Products per Page on Grid Allowed Values. */
  grid_per_page_values?: Maybe<Scalars['String']['output']>;
  /** Scripts and Style Sheets */
  head_includes?: Maybe<Scalars['String']['output']>;
  /** Favicon Icon */
  head_shortcut_icon?: Maybe<Scalars['String']['output']>;
  /** Logo Image */
  header_logo_src?: Maybe<Scalars['String']['output']>;
  /** The ID number assigned to the store */
  id?: Maybe<Scalars['Int']['output']>;
  /** List Mode. */
  list_mode?: Maybe<Scalars['String']['output']>;
  /** Products per Page on List Default Value. */
  list_per_page?: Maybe<Scalars['Int']['output']>;
  /** Products per Page on List Allowed Values. */
  list_per_page_values?: Maybe<Scalars['String']['output']>;
  /** Store locale */
  locale?: Maybe<Scalars['String']['output']>;
  /** Logo Image Alt */
  logo_alt?: Maybe<Scalars['String']['output']>;
  /** Logo Attribute Height */
  logo_height?: Maybe<Scalars['Int']['output']>;
  /** Logo Attribute Width */
  logo_width?: Maybe<Scalars['Int']['output']>;
  /** Default No-route URL */
  no_route?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices On Product View Page' field. It indicates how FPT information is displayed on product pages */
  product_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Product URL Suffix. */
  product_url_suffix?: Maybe<Scalars['String']['output']>;
  /** The ID of the root category */
  root_category_id?: Maybe<Scalars['Int']['output']>;
  /** Corresponds to the 'Display Prices In Sales Modules' field. It indicates how FPT information is displayed on cart, checkout, and order pages */
  sales_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySettings>;
  /** Secure base link URL for the store */
  secure_base_link_url?: Maybe<Scalars['String']['output']>;
  /** Secure base media URL for the store */
  secure_base_media_url?: Maybe<Scalars['String']['output']>;
  /** Secure base static URL for the store */
  secure_base_static_url?: Maybe<Scalars['String']['output']>;
  /** Secure base URL for the store */
  secure_base_url?: Maybe<Scalars['String']['output']>;
  /** Show Breadcrumbs for CMS Pages */
  show_cms_breadcrumbs?: Maybe<Scalars['Int']['output']>;
  /** Name of the store */
  store_name?: Maybe<Scalars['String']['output']>;
  /** Timezone of the store */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Page Title Prefix */
  title_prefix?: Maybe<Scalars['String']['output']>;
  /** Page Title Separator. */
  title_separator?: Maybe<Scalars['String']['output']>;
  /** Page Title Suffix */
  title_suffix?: Maybe<Scalars['String']['output']>;
  /** The ID number assigned to the website store belongs */
  website_id?: Maybe<Scalars['Int']['output']>;
  /** The unit of weight */
  weight_unit?: Maybe<Scalars['String']['output']>;
  /** Welcome Text */
  welcome?: Maybe<Scalars['String']['output']>;
};

/** The type contains information about a store config */
export type StoreConfiguration = {
  __typename?: 'StoreConfiguration';
  /** Footer Miscellaneous HTML */
  absolute_footer?: Maybe<Scalars['String']['output']>;
  /** Base currency code */
  base_currency_code?: Maybe<Scalars['String']['output']>;
  /** Base link URL for the store */
  base_link_url?: Maybe<Scalars['String']['output']>;
  /** Base media URL for the store */
  base_media_url?: Maybe<Scalars['String']['output']>;
  /** Base static URL for the store */
  base_static_url?: Maybe<Scalars['String']['output']>;
  /** Base URL for the store */
  base_url?: Maybe<Scalars['String']['output']>;
  /** Max quantity per item in the cart. */
  cart_max_qty_per_item?: Maybe<Scalars['Int']['output']>;
  /** Min quantity per item in the cart. */
  cart_min_qty_per_item?: Maybe<Scalars['Int']['output']>;
  /** Default Sort By. */
  catalog_default_sort_by?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices In Product Lists' field. It indicates how FPT information is displayed on category pages */
  category_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySetting>;
  /** Category URL Suffix. */
  category_url_suffix?: Maybe<Scalars['String']['output']>;
  /** CMS Home Page */
  cms_home_page?: Maybe<Scalars['String']['output']>;
  /** CMS No Cookies Page */
  cms_no_cookies?: Maybe<Scalars['String']['output']>;
  /** CMS No Route Page */
  cms_no_route?: Maybe<Scalars['String']['output']>;
  /** CMS Promotion Page */
  cms_promotion_page?: Maybe<Scalars['String']['output']>;
  /** A code assigned to the store to identify it */
  code?: Maybe<Scalars['String']['output']>;
  /** Copyright */
  copyright?: Maybe<Scalars['String']['output']>;
  /** Default Meta Description */
  default_description?: Maybe<Scalars['String']['output']>;
  /** Default display currency code */
  default_display_currency_code?: Maybe<Scalars['String']['output']>;
  /** Default Meta Keywords */
  default_keywords?: Maybe<Scalars['String']['output']>;
  /** Default Page Title */
  default_title?: Maybe<Scalars['String']['output']>;
  /** Display Demo Store Notice */
  demonotice?: Maybe<Scalars['Int']['output']>;
  /** Default Web URL */
  front?: Maybe<Scalars['String']['output']>;
  /** Products per Page on Grid Default Value. */
  grid_per_page?: Maybe<Scalars['Int']['output']>;
  /** Products per Page on Grid Allowed Values. */
  grid_per_page_values?: Maybe<Scalars['String']['output']>;
  /** Scripts and Style Sheets */
  head_includes?: Maybe<Scalars['String']['output']>;
  /** Favicon Icon */
  head_shortcut_icon?: Maybe<Scalars['String']['output']>;
  /** Logo Image */
  header_logo_src?: Maybe<Scalars['String']['output']>;
  /** The ID number assigned to the store */
  id?: Maybe<Scalars['Int']['output']>;
  /** List Mode. */
  list_mode?: Maybe<Scalars['String']['output']>;
  /** Products per Page on List Default Value. */
  list_per_page?: Maybe<Scalars['Int']['output']>;
  /** Products per Page on List Allowed Values. */
  list_per_page_values?: Maybe<Scalars['String']['output']>;
  /** Store locale */
  locale?: Maybe<Scalars['String']['output']>;
  /** Logo Image Alt */
  logo_alt?: Maybe<Scalars['String']['output']>;
  /** Logo Attribute Height */
  logo_height?: Maybe<Scalars['Int']['output']>;
  /** Logo Attribute Width */
  logo_width?: Maybe<Scalars['Int']['output']>;
  /** Default No-route URL */
  no_route?: Maybe<Scalars['String']['output']>;
  /** Corresponds to the 'Display Prices On Product View Page' field. It indicates how FPT information is displayed on product pages */
  product_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySetting>;
  /** Product URL Suffix. */
  product_url_suffix?: Maybe<Scalars['String']['output']>;
  /** The ID of the root category */
  root_category_id?: Maybe<Scalars['Int']['output']>;
  /** Corresponds to the 'Display Prices In Sales Modules' field. It indicates how FPT information is displayed on cart, checkout, and order pages */
  sales_fixed_product_tax_display_setting?: Maybe<FixedProductTaxDisplaySetting>;
  /** Returns the placeholder text shown in the search input field. */
  search_placeholder?: Maybe<Scalars['String']['output']>;
  /** Secure base link URL for the store */
  secure_base_link_url?: Maybe<Scalars['String']['output']>;
  /** Secure base media URL for the store */
  secure_base_media_url?: Maybe<Scalars['String']['output']>;
  /** Secure base static URL for the store */
  secure_base_static_url?: Maybe<Scalars['String']['output']>;
  /** Secure base URL for the store */
  secure_base_url?: Maybe<Scalars['String']['output']>;
  /** Show Breadcrumbs for CMS Pages */
  show_cms_breadcrumbs?: Maybe<Scalars['Int']['output']>;
  /** Name of the store */
  store_name?: Maybe<Scalars['String']['output']>;
  /** Timezone of the store */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Page Title Prefix */
  title_prefix?: Maybe<Scalars['String']['output']>;
  /** Page Title Separator. */
  title_separator?: Maybe<Scalars['String']['output']>;
  /** Page Title Suffix */
  title_suffix?: Maybe<Scalars['String']['output']>;
  /** The ID number assigned to the website store belongs */
  website_id?: Maybe<Scalars['Int']['output']>;
  /** The unit of weight */
  weight_unit?: Maybe<Scalars['String']['output']>;
  /** Welcome Text */
  welcome?: Maybe<Scalars['String']['output']>;
};

export type StoreConfigurationV2 = {
  __typename?: 'StoreConfigurationV2';
  app_config?: Maybe<AppConfiguration>;
  magento_graphql_url?: Maybe<Scalars['String']['output']>;
  review_service_graphql_url?: Maybe<Scalars['String']['output']>;
};

export type StoreLocator = {
  __typename?: 'StoreLocator';
  /** The description of store. */
  description?: Maybe<Scalars['String']['output']>;
  /** The district id of store. */
  district_id?: Maybe<Scalars['Int']['output']>;
  /** The is coming soon of store. */
  is_coming_soon?: Maybe<Scalars['Boolean']['output']>;
  /** The is new of store. */
  is_new?: Maybe<Scalars['Boolean']['output']>;
  /** The latitude of store. */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** The longitude of store. */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The name of store. */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone of store. */
  phone?: Maybe<Scalars['String']['output']>;
  /** The district id of store. */
  region_id?: Maybe<Scalars['Int']['output']>;
  /** The store image of store. */
  store_image?: Maybe<Scalars['String']['output']>;
  /** The street of store. */
  street?: Maybe<Scalars['String']['output']>;
};

export type StoreRegion = {
  __typename?: 'StoreRegion';
  /** The code of region. */
  code?: Maybe<Scalars['String']['output']>;
  /** The id of region. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The name of region. */
  name?: Maybe<Scalars['String']['output']>;
  /** The number of stores in region. */
  num_of_stores?: Maybe<Scalars['Int']['output']>;
};

export type StoreRegions = {
  __typename?: 'StoreRegions';
  /** The identifier for cache. */
  id?: Maybe<Scalars['String']['output']>;
  /** An array regions that have Kids Plaza stores. */
  items?: Maybe<Array<Maybe<StoreRegion>>>;
};

export type StoresLocator = {
  __typename?: 'StoresLocator';
  /** The identifier for cache. */
  id?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<StoreLocator>>>;
};

export type SuggestionSearchCategory = {
  __typename?: 'SuggestionSearchCategory';
  breadcrumb?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SuggestionSearchProduct = {
  __typename?: 'SuggestionSearchProduct';
  final_price?: Maybe<Money>;
  image?: Maybe<Scalars['String']['output']>;
  product_id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** suggestSearch input and response */
export type SuggestionSearchResponse = {
  __typename?: 'SuggestionSearchResponse';
  categories: Array<SuggestionSearchCategory>;
  products: Array<SuggestionSearchProduct>;
  terms: Array<SuggestionSearchTerm>;
};

export type SuggestionSearchTerm = {
  __typename?: 'SuggestionSearchTerm';
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SupportMenuAction = {
  __typename?: 'SupportMenuAction';
  type: SupportMenuActionType;
  value?: Maybe<Scalars['String']['output']>;
};

export enum SupportMenuActionType {
  Call = 'CALL',
  Navigate = 'NAVIGATE',
  OpenBottomSheet = 'OPEN_BOTTOM_SHEET',
  RequestCancel = 'REQUEST_CANCEL'
}

export type SupportMenuItem = {
  __typename?: 'SupportMenuItem';
  id: Scalars['ID']['output'];
  left_icon?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  menu_label?: Maybe<Scalars['String']['output']>;
  right_icon?: Maybe<Scalars['String']['output']>;
  sort_order?: Maybe<Scalars['Int']['output']>;
  support_menu_action?: Maybe<SupportMenuAction>;
  value?: Maybe<Scalars['String']['output']>;
};

export type SwatchData = {
  __typename?: 'SwatchData';
  /** Type of swatch filter item: 1 - text, 2 - image */
  type?: Maybe<Scalars['String']['output']>;
  /** Value for swatch item (text or image link) */
  value?: Maybe<Scalars['String']['output']>;
};

export type SwatchDataInterface = {
  /** Value of swatch item (HEX color code, image link or textual value) */
  value?: Maybe<Scalars['String']['output']>;
};

export type SwatchLayerFilterItem = LayerFilterItemInterface & SwatchLayerFilterItemInterface & {
  __typename?: 'SwatchLayerFilterItem';
  /**
   * Count of items by filter.
   * @deprecated Use AggregationOption.count instead.
   */
  items_count?: Maybe<Scalars['Int']['output']>;
  /**
   * Filter label.
   * @deprecated Use AggregationOption.label instead.
   */
  label?: Maybe<Scalars['String']['output']>;
  /** Data required to render swatch filter item */
  swatch_data?: Maybe<SwatchData>;
  /**
   * Value for filter request variable to be used in query.
   * @deprecated Use AggregationOption.value instead.
   */
  value_string?: Maybe<Scalars['String']['output']>;
};

export type SwatchLayerFilterItemInterface = {
  /** Data required to render swatch filter item */
  swatch_data?: Maybe<SwatchData>;
};

/** Tag information. */
export type Tag = {
  __typename?: 'Tag';
  /** The created at of tag. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** The identifier of tag. */
  identifier?: Maybe<Scalars['String']['output']>;
  /** The meta description at of tag. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** The updated at of tag. */
  modified_at?: Maybe<Scalars['String']['output']>;
  /** The number products of tag. */
  number_products?: Maybe<Scalars['Int']['output']>;
  /** The products are assigned for tag. */
  products?: Maybe<Array<Maybe<ProductInterface>>>;
  /** The status of tag. */
  status?: Maybe<Scalars['Int']['output']>;
  /** The description of tag. */
  tag_description?: Maybe<Scalars['String']['output']>;
  /** The ID of tag. */
  tag_id?: Maybe<Scalars['Int']['output']>;
  /** The title of tag. */
  tag_title?: Maybe<Scalars['String']['output']>;
  /** The url of tag. */
  tag_url?: Maybe<Scalars['String']['output']>;
};

/** Contains tax item details. */
export type TaxItem = {
  __typename?: 'TaxItem';
  /** The amount of tax applied to the item. */
  amount: Money;
  /** The rate used to calculate the tax. */
  rate: Scalars['Float']['output'];
  /** A title that describes the tax. */
  title: Scalars['String']['output'];
};

export type TermsOfService = {
  __typename?: 'TermsOfService';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type TextSwatchData = SwatchDataInterface & {
  __typename?: 'TextSwatchData';
  /** Value of swatch item (HEX color code, image link or textual value) */
  value?: Maybe<Scalars['String']['output']>;
};

/** A price based on the quantity purchased. */
export type TierPrice = {
  __typename?: 'TierPrice';
  /** The price discount that this tier represents. */
  discount?: Maybe<ProductDiscount>;
  final_price?: Maybe<Money>;
  /** The minimum number of items that must be purchased to qualify for this price tier. */
  quantity?: Maybe<Scalars['Float']['output']>;
};

export type TrackEventInput = {
  eventData: EventDataInput;
  /** type of event */
  eventName: EventTypeEnum;
};

export type TrackEventResult = {
  __typename?: 'TrackEventResult';
  /** Id of event tracking */
  id?: Maybe<Scalars['String']['output']>;
  /** Error message */
  message?: Maybe<Scalars['String']['output']>;
  /** Status of request */
  success: Scalars['Boolean']['output'];
};

export enum TypeNotificationEnum {
  Order = 'ORDER',
  Promotion = 'PROMOTION',
  System = 'SYSTEM'
}

export type UpdateCartItemsInput = {
  cart_id: Scalars['String']['input'];
  cart_items: Array<InputMaybe<CartItemUpdateInput>>;
};

export type UpdateCartItemsOutput = {
  __typename?: 'UpdateCartItemsOutput';
  cart: Cart;
};

export type UrlConfigData = {
  __typename?: 'UrlConfigData';
  magento_graphql_url?: Maybe<Scalars['String']['output']>;
  review_service_graphql_url?: Maybe<Scalars['String']['output']>;
};

/** The object contains URL rewrite details */
export type UrlRewrite = {
  __typename?: 'UrlRewrite';
  /** Request parameters */
  parameters?: Maybe<Array<Maybe<HttpQueryParameter>>>;
  /** Request URL */
  url?: Maybe<Scalars['String']['output']>;
};

/** This enumeration defines the entity type. */
export enum UrlRewriteEntityTypeEnum {
  /** @deprecated  */
  Category = 'CATEGORY',
  /** @deprecated  */
  CmsPage = 'CMS_PAGE',
  /** @deprecated  */
  CustomPage = 'CUSTOM_PAGE',
  /** @deprecated  */
  Product = 'PRODUCT'
}

export type UserDataInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type ValidateCouponsInput = {
  /** The mask id of cart. */
  cart_id: Scalars['String']['input'];
  /** An array of coupon codes. */
  coupon_code: Array<InputMaybe<Scalars['String']['input']>>;
};

export type ValidatePhoneAndOtpResponse = {
  __typename?: 'ValidatePhoneAndOtpResponse';
  /** Message */
  message: Scalars['String']['output'];
  /** Success */
  success: Scalars['Boolean']['output'];
};

export enum ValidatePhoneType {
  /** Validate phone number for login */
  Login = 'LOGIN',
  /** Validate phone number for signup */
  Register = 'REGISTER'
}

/** Input type to get look up user */
export type VerifyEventUserUpdateSecretInput = {
  /** Event id */
  event_id: Scalars['ID']['input'];
  /** Phone number of user */
  phone_number: Scalars['String']['input'];
  /** Event id */
  secret: Scalars['String']['input'];
};

/** Virtual Cart Item */
export type VirtualCartItem = CartItemInterface & {
  __typename?: 'VirtualCartItem';
  customizable_options?: Maybe<Array<Maybe<SelectedCustomizableOption>>>;
  id: Scalars['String']['output'];
  prices?: Maybe<CartItemPrices>;
  product: ProductInterface;
  quantity: Scalars['Float']['output'];
};

/** A virtual product is non-tangible product that does not require shipping and is not kept in inventory. */
export type VirtualProduct = CustomizableProductInterface & ProductInterface & {
  __typename?: 'VirtualProduct';
  /** Achievement information of the Product */
  achievement?: Maybe<Achievement>;
  /** The attribute values that are available on front-end. */
  additional_data_attributes?: Maybe<Array<Maybe<AdditionalDataAttribute>>>;
  age?: Maybe<Scalars['Int']['output']>;
  am_offer_item_condition?: Maybe<Scalars['Int']['output']>;
  /** Stock status label */
  appboxo_qty?: Maybe<Scalars['String']['output']>;
  /** The attribute set assigned to the product. */
  attribute_set_id?: Maybe<Scalars['Int']['output']>;
  avatars?: Maybe<Scalars['Int']['output']>;
  bao_hanh?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['Int']['output']>;
  /** Breadcrumbs, parent categories info. */
  breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
  /** Relative canonical URL. This value is returned only if the system setting 'Use Canonical Link Meta Tag For Products' is enabled */
  canonical_url?: Maybe<Scalars['String']['output']>;
  /** The categories assigned to a product. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  chat_lieu?: Maybe<Scalars['String']['output']>;
  chat_lieu_go?: Maybe<Scalars['Int']['output']>;
  chat_lieu_vai?: Maybe<Scalars['Int']['output']>;
  chon_so?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['Int']['output']>;
  combo_enable?: Maybe<Scalars['Int']['output']>;
  /** The product's country of origin. */
  country_of_manufacture?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was created. */
  created_at?: Maybe<Scalars['String']['output']>;
  /** Crosssell Products */
  crosssell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  denomination?: Maybe<Scalars['Int']['output']>;
  /** Detailed information about the product. The value can include simple HTML tags. */
  description?: Maybe<ComplexTextValue>;
  dungtich?: Maybe<Scalars['Int']['output']>;
  /** Return flash sale data of product. */
  flash_sale?: Maybe<FlashSaleProductData>;
  gift_indexed_info?: Maybe<Array<Maybe<GiftIndexedInfo>>>;
  /** Indicates whether a gift message is available. */
  gift_message_available?: Maybe<Scalars['String']['output']>;
  gram?: Maybe<Scalars['Int']['output']>;
  groupon_bought?: Maybe<Scalars['Int']['output']>;
  groupon_enable?: Maybe<Scalars['Int']['output']>;
  groupon_from?: Maybe<Scalars['String']['output']>;
  groupon_qty?: Maybe<Scalars['Int']['output']>;
  groupon_to?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  /** The attribute to check product has a gift cart. */
  has_gift?: Maybe<Scalars['Boolean']['output']>;
  /** Hot product attribute. */
  hot_product?: Maybe<Scalars['Boolean']['output']>;
  /** The ID number assigned to the product. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The relative path to the main image on the product page. */
  image?: Maybe<ProductImage>;
  /** The is discount attribute. */
  is_discount?: Maybe<Scalars['Boolean']['output']>;
  is_kids_gift?: Maybe<Scalars['Int']['output']>;
  is_online_only?: Maybe<Scalars['Int']['output']>;
  kich_thuoc?: Maybe<Scalars['String']['output']>;
  kids_gift_end?: Maybe<Scalars['String']['output']>;
  kids_gift_start?: Maybe<Scalars['String']['output']>;
  kids_gift_value?: Maybe<Scalars['Float']['output']>;
  made_in?: Maybe<Scalars['Int']['output']>;
  /** A number representing the product's manufacturer. */
  manufacturer?: Maybe<Scalars['Int']['output']>;
  market_price?: Maybe<Scalars['Float']['output']>;
  /** An array of Media Gallery objects. */
  media_gallery?: Maybe<Array<Maybe<MediaGalleryInterface>>>;
  /**
   * An array of MediaGalleryEntry objects.
   * @deprecated Use product's `media_gallery` instead
   */
  media_gallery_entries?: Maybe<Array<Maybe<MediaGalleryEntry>>>;
  /** A brief overview of the product for search results listings, maximum 255 characters. */
  meta_description?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of keywords that are visible only to search engines. */
  meta_keyword?: Maybe<Scalars['String']['output']>;
  /** A string that is displayed in the title bar and tab of the browser and in search results lists. */
  meta_title?: Maybe<Scalars['String']['output']>;
  muivi?: Maybe<Scalars['Int']['output']>;
  /** The product name. Customers use this name to identify the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** The beginning date for new product listings, and determines if the product is featured as a new product. */
  new_from_date?: Maybe<Scalars['String']['output']>;
  /** New product attribute. */
  new_product?: Maybe<Scalars['Boolean']['output']>;
  /** The end date for new product listings. */
  new_to_date?: Maybe<Scalars['String']['output']>;
  /** The beginning date that a product is a new product. */
  news_from_date?: Maybe<Scalars['String']['output']>;
  /** The end date that a product is new product. */
  news_to_date?: Maybe<Scalars['String']['output']>;
  nipple_size?: Maybe<Scalars['Int']['output']>;
  /** The notifications of the product. */
  notifications?: Maybe<Array<Maybe<ProductNotification>>>;
  /** Product stock only x left count */
  only_x_left_in_stock?: Maybe<Scalars['Float']['output']>;
  /** An array of options for a customizable product. */
  options?: Maybe<Array<Maybe<CustomizableOptionInterface>>>;
  /** If the product has multiple options, determines where they appear on the product page. */
  options_container?: Maybe<Scalars['String']['output']>;
  /** An array popular search keywords for category page. */
  popular_search_keywords?: Maybe<Array<Maybe<Keywords>>>;
  /**
   * A ProductPrices object, indicating the price of an item.
   * @deprecated Use price_range for product price information.
   */
  price?: Maybe<ProductPrices>;
  /** A PriceRange object, indicating the range of prices for the product */
  price_range: PriceRange;
  /** An array of TierPrice objects. */
  price_tiers?: Maybe<Array<Maybe<TierPrice>>>;
  /** An array product achievements of each product. */
  product_achievements?: Maybe<Array<Maybe<ProductAchievement>>>;
  /** An array product badges of each product. */
  product_badges?: Maybe<Array<Maybe<ProductBadge>>>;
  /** An array of ProductLinks objects. */
  product_links?: Maybe<Array<Maybe<ProductLinksInterface>>>;
  product_notes?: Maybe<Scalars['String']['output']>;
  products_combo?: Maybe<Scalars['String']['output']>;
  promotion_info_time_from?: Maybe<Scalars['String']['output']>;
  promotion_info_time_to?: Maybe<Scalars['String']['output']>;
  /** Rating counts of product */
  ratings_count?: Maybe<Scalars['Int']['output']>;
  /** atings summary of product. */
  ratings_summary?: Maybe<Scalars['Int']['output']>;
  /** Related Products */
  related_products?: Maybe<Array<Maybe<ProductInterface>>>;
  related_products_two?: Maybe<Array<Maybe<ProductInterface>>>;
  sex?: Maybe<Scalars['Int']['output']>;
  /** A short description of the product. Its use depends on the theme. */
  short_description?: Maybe<ComplexTextValue>;
  size?: Maybe<Scalars['Int']['output']>;
  size_bim?: Maybe<Scalars['Int']['output']>;
  /** A number or code assigned to a product to identify the product, options, price, and manufacturer. */
  sku?: Maybe<Scalars['String']['output']>;
  /** The relative path to the small image, which is used on catalog pages. */
  small_image?: Maybe<ProductImage>;
  so_tang?: Maybe<Scalars['Int']['output']>;
  soluong?: Maybe<Scalars['Int']['output']>;
  /** The beginning date that a product has a special price. */
  special_from_date?: Maybe<Scalars['String']['output']>;
  /** The discounted price of the product. */
  special_price?: Maybe<Scalars['Float']['output']>;
  /** The end date that a product has a special price. */
  special_to_date?: Maybe<Scalars['String']['output']>;
  /** Stock status of the product */
  stock_status?: Maybe<ProductStockStatus>;
  /** The file name of a swatch image */
  swatch_image?: Maybe<Scalars['String']['output']>;
  /** The relative path to the product's thumbnail image. */
  thumbnail?: Maybe<ProductImage>;
  /**
   * The price when tier pricing is in effect and the items purchased threshold has been reached.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_price?: Maybe<Scalars['Float']['output']>;
  /**
   * An array of ProductTierPrices objects.
   * @deprecated Use price_tiers for product tier price information.
   */
  tier_prices?: Maybe<Array<Maybe<ProductTierPrices>>>;
  /**
   * One of simple, virtual, bundle, downloadable, grouped, or configurable.
   * @deprecated Use __typename instead.
   */
  type_id?: Maybe<Scalars['String']['output']>;
  /** Timestamp indicating when the product was updated. */
  updated_at?: Maybe<Scalars['String']['output']>;
  /** Upsell Products */
  upsell_products?: Maybe<Array<Maybe<ProductInterface>>>;
  upsell_type?: Maybe<Scalars['String']['output']>;
  /** The part of the URL that identifies the product */
  url_key?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use product's `canonical_url` or url rewrites instead */
  url_path?: Maybe<Scalars['String']['output']>;
  /** URL rewrites list */
  url_rewrites?: Maybe<Array<Maybe<UrlRewrite>>>;
  /** The part of the product URL that is appended after the url key */
  url_suffix?: Maybe<Scalars['String']['output']>;
  use_cc?: Maybe<Scalars['Int']['output']>;
  use_custom_image?: Maybe<Scalars['String']['output']>;
  user_guide?: Maybe<Scalars['String']['output']>;
  /**
   * An array of websites in which the product is available.
   * @deprecated The field should not be used on the storefront.
   */
  websites?: Maybe<Array<Maybe<Website>>>;
  weight_bim?: Maybe<Scalars['Int']['output']>;
};

export type VirtualProductCartItemInput = {
  customizable_options?: InputMaybe<Array<InputMaybe<CustomizableOptionInput>>>;
  data: CartItemInput;
};

export type Ward = {
  __typename?: 'Ward';
  district_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region_id?: Maybe<Scalars['Int']['output']>;
};

/** Website is deprecated because it is should not be used on storefront. The type contains information about a website */
export type Website = {
  __typename?: 'Website';
  /**
   * A code assigned to the website to identify it
   * @deprecated The field should not be used on the storefront.
   */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * The default group ID that the website has
   * @deprecated The field should not be used on the storefront.
   */
  default_group_id?: Maybe<Scalars['String']['output']>;
  /**
   * The ID number assigned to the website
   * @deprecated The field should not be used on the storefront.
   */
  id?: Maybe<Scalars['Int']['output']>;
  /**
   * Specifies if this is the default website
   * @deprecated The field should not be used on the storefront.
   */
  is_default?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The website name. Websites use this name to identify it easier.
   * @deprecated The field should not be used on the storefront.
   */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * The attribute to use for sorting websites
   * @deprecated The field should not be used on the storefront.
   */
  sort_order?: Maybe<Scalars['Int']['output']>;
};

/** Represents a widget containing a collection of shortcut links. */
export type WidgetShortcutLink = {
  __typename?: 'WidgetShortcutLink';
  /** A list of shortcut links. */
  items?: Maybe<Array<Maybe<ShortcutLink>>>;
};

/** Represents a widget containing a collection of shortcut links. */
export type WidgetShortcutLinkV2 = {
  __typename?: 'WidgetShortcutLinkV2';
  /** A list of shortcut links. */
  items?: Maybe<Array<ShortcutLinkV2>>;
};

export type Wishlist = {
  __typename?: 'Wishlist';
  /** Wishlist unique identifier */
  id?: Maybe<Scalars['ID']['output']>;
  /** An array of items in the customer's wish list */
  items?: Maybe<Array<Maybe<WishlistItem>>>;
  /** The number of items in the wish list */
  items_count?: Maybe<Scalars['Int']['output']>;
  /** An encrypted code that Magento uses to link to the wish list */
  sharing_code?: Maybe<Scalars['String']['output']>;
  /** The time of the last modification to the wish list */
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type WishlistItem = {
  __typename?: 'WishlistItem';
  /** The time when the customer added the item to the wish list */
  added_at?: Maybe<Scalars['String']['output']>;
  /** The customer's comment about this item */
  description?: Maybe<Scalars['String']['output']>;
  /** The wish list item ID */
  id?: Maybe<Scalars['Int']['output']>;
  product?: Maybe<ProductInterface>;
  /** The quantity of this wish list item */
  qty?: Maybe<Scalars['Float']['output']>;
};

export type ProductAchievementFragment = { __typename?: 'ProductAchievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, border_color?: string | null };

export type SimpleProductAchievementFragment = { __typename?: 'SimpleProduct', brand?: number | null, product_achievements?: Array<{ __typename?: 'ProductAchievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, border_color?: string | null } | null> | null };

export type ConfigurableProductAchievementFragment = { __typename?: 'ConfigurableProduct', brand?: number | null, product_achievements?: Array<{ __typename?: 'ProductAchievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, border_color?: string | null } | null> | null };

export type HighlightBrandAchievementFragment = { __typename?: 'HighlightBrand', achievement?: { __typename?: 'Achievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, label?: string | null, border_color?: string | null } | null };

export type AttributeOptionsQueryVariables = Exact<{
  attributes: Array<AttributeInput> | AttributeInput;
}>;


export type AttributeOptionsQuery = { __typename?: 'Query', customAttributeMetadata?: { __typename?: 'CustomAttributeMetadata', items?: Array<{ __typename?: 'Attribute', attribute_code?: string | null, attribute_type?: string | null, entity_type?: string | null, input_type?: string | null, attribute_options?: Array<{ __typename?: 'AttributeOption', label?: string | null, value?: string | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', value?: string | null, thumbnail?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null } | null };

export type ProductPaginationInfoFragment = { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null };

export type ProductBadgeFieldsFragment = { __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null };

type ProductMediaGallery_BundleProduct_Fragment = { __typename?: 'BundleProduct', media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null };

type ProductMediaGallery_ConfigurableProduct_Fragment = { __typename?: 'ConfigurableProduct', media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null };

type ProductMediaGallery_DownloadableProduct_Fragment = { __typename?: 'DownloadableProduct', media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null };

type ProductMediaGallery_GroupedProduct_Fragment = { __typename?: 'GroupedProduct', media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null };

type ProductMediaGallery_SimpleProduct_Fragment = { __typename?: 'SimpleProduct', media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null };

type ProductMediaGallery_VirtualProduct_Fragment = { __typename?: 'VirtualProduct', media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null };

export type ProductMediaGalleryFragment = ProductMediaGallery_BundleProduct_Fragment | ProductMediaGallery_ConfigurableProduct_Fragment | ProductMediaGallery_DownloadableProduct_Fragment | ProductMediaGallery_GroupedProduct_Fragment | ProductMediaGallery_SimpleProduct_Fragment | ProductMediaGallery_VirtualProduct_Fragment;

export type ConfigurableProductMediaGalleryFragment = { __typename?: 'ConfigurableProduct', media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null };

export type SimpleProductMediaGalleryFragment = { __typename?: 'SimpleProduct', media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null };

export type ProductAttributeBasicFragment = { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null };

export type ConfigurableProductImageFragment = { __typename?: 'ConfigurableProduct', thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null };

export type ConfigurableProductPriceFragment = { __typename?: 'ConfigurableProduct', price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } };

export type ConfigurableProductBasicFragment = { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null };

export type SimpleProductImageFragment = { __typename?: 'SimpleProduct', thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null };

export type SimpleProductPriceFragment = { __typename?: 'SimpleProduct', price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } };

export type SimpleProductBasicFragment = { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null };

type ProductSpecialPrice_BundleProduct_Fragment = { __typename?: 'BundleProduct', special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null };

type ProductSpecialPrice_ConfigurableProduct_Fragment = { __typename?: 'ConfigurableProduct', special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null };

type ProductSpecialPrice_DownloadableProduct_Fragment = { __typename?: 'DownloadableProduct', special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null };

type ProductSpecialPrice_GroupedProduct_Fragment = { __typename?: 'GroupedProduct', special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null };

type ProductSpecialPrice_SimpleProduct_Fragment = { __typename?: 'SimpleProduct', special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null };

type ProductSpecialPrice_VirtualProduct_Fragment = { __typename?: 'VirtualProduct', special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null };

export type ProductSpecialPriceFragment = ProductSpecialPrice_BundleProduct_Fragment | ProductSpecialPrice_ConfigurableProduct_Fragment | ProductSpecialPrice_DownloadableProduct_Fragment | ProductSpecialPrice_GroupedProduct_Fragment | ProductSpecialPrice_SimpleProduct_Fragment | ProductSpecialPrice_VirtualProduct_Fragment;

type ProductDescription_BundleProduct_Fragment = { __typename?: 'BundleProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null };

type ProductDescription_ConfigurableProduct_Fragment = { __typename?: 'ConfigurableProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null };

type ProductDescription_DownloadableProduct_Fragment = { __typename?: 'DownloadableProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null };

type ProductDescription_GroupedProduct_Fragment = { __typename?: 'GroupedProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null };

type ProductDescription_SimpleProduct_Fragment = { __typename?: 'SimpleProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null };

type ProductDescription_VirtualProduct_Fragment = { __typename?: 'VirtualProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null };

export type ProductDescriptionFragment = ProductDescription_BundleProduct_Fragment | ProductDescription_ConfigurableProduct_Fragment | ProductDescription_DownloadableProduct_Fragment | ProductDescription_GroupedProduct_Fragment | ProductDescription_SimpleProduct_Fragment | ProductDescription_VirtualProduct_Fragment;

export type ConfigurableProductVariantsFragment = { __typename?: 'ConfigurableProduct', variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null };

export type ConfigurableProductOptionsFragment = { __typename?: 'ConfigurableProduct', configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null };

export type ProductListAggregationsFragment = { __typename?: 'Aggregation', attribute_code: string, count?: number | null, label?: string | null, options?: Array<{ __typename?: 'AggregationOption', count?: number | null, label?: string | null, value: string } | null> | null };

export type ProductListSortFieldsFragment = { __typename?: 'SortFields', default?: string | null, options?: Array<{ __typename?: 'SortField', label?: string | null, value?: string | null } | null> | null };

export type ConfigurableProductDescriptionFragment = { __typename?: 'ConfigurableProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null };

export type SimpleProductDescriptionFragment = { __typename?: 'SimpleProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null };

export type ConfigurableProductParametersFragment = { __typename?: 'ConfigurableProduct', made_in?: number | null, age?: number | null, kich_thuoc?: string | null, chon_so?: number | null, gram?: number | null, ratings_count?: number | null, ratings_summary?: number | null, sold_quantity?: number | null };

export type SimpleProductParametersFragment = { __typename?: 'SimpleProduct', made_in?: number | null, age?: number | null, kich_thuoc?: string | null, chon_so?: number | null, gram?: number | null, ratings_count?: number | null, ratings_summary?: number | null, sold_quantity?: number | null };

export type SimpleProductSpecialPriceFragment = { __typename?: 'SimpleProduct', special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null };

export type ConfigurableProductSpecialPriceFragment = { __typename?: 'ConfigurableProduct', special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null };

export type SimpleProductBadgesFragment = { __typename?: 'SimpleProduct', product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null };

export type ConfigurableProductBadgesFragment = { __typename?: 'ConfigurableProduct', product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null };

export type SimpleProductPriceTiersFragment = { __typename?: 'SimpleProduct', price_tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null };

export type ConfigurableProductPriceTiersFragment = { __typename?: 'ConfigurableProduct', price_tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null };

export type ConfigurableProductOptionsValuesSwatchDataFragment = { __typename?: 'ConfigurableProductOptionsValues', swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null };

export type UsefulInformationItemFragment = { __typename?: 'Post', comment_status?: string | null, guid?: string | null, id?: string | null, post_content?: string | null, post_date?: string | null, post_excerpt?: string | null, post_modified?: string | null, post_modified_gmt?: string | null, post_name?: string | null, post_status?: string | null, post_title?: string | null, post_type?: string | null, post_url?: string | null, thumb_img?: string | null, author?: string | null, views_count?: number | null };

export type CategoryListQueryVariables = Exact<{
  filters?: InputMaybe<CategoryFilterInput>;
}>;


export type CategoryListQuery = { __typename?: 'Query', categoryList?: Array<{ __typename?: 'CategoryTree', id?: number | null, children?: Array<{ __typename?: 'CategoryTree', name?: string | null, id?: number | null, position?: number | null, featured_app_icon?: string | null, background_app_icon?: string | null, is_featured?: boolean | null, include_in_menu?: number | null } | null> | null } | null> | null };

export type CategoryBannersQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type CategoryBannersQuery = { __typename?: 'Query', categoryBanners?: { __typename?: 'CategoryBanners', items?: Array<{ __typename?: 'Banner', app_image_url?: string | null, background_color?: string | null, banner_id?: number | null, image_app?: string | null, name?: string | null, position?: string | null, url_banner?: string | null } | null> | null, layout?: { __typename?: 'BannerLayoutData', label?: string | null, value?: string | null } | null } | null };

export type CategoryHighlightAttributesQueryVariables = Exact<{
  filters?: InputMaybe<CategoryFilterInput>;
}>;


export type CategoryHighlightAttributesQuery = { __typename?: 'Query', categoryList?: Array<{ __typename?: 'CategoryTree', id?: number | null, highlight_product_attributes?: Array<{ __typename?: 'Attribute', attribute_code?: string | null, attribute_type?: string | null, entity_type?: string | null, input_type?: string | null, attribute_options?: Array<{ __typename?: 'AttributeOption', label?: string | null, value?: string | null } | null> | null } | null> | null } | null> | null };

export type HighlightProductAttributesQueryVariables = Exact<{
  categoryId: Scalars['Int']['input'];
}>;


export type HighlightProductAttributesQuery = { __typename?: 'Query', highlightProductAttributes?: Array<{ __typename?: 'Aggregation', attribute_code: string, count?: number | null, label?: string | null, options?: Array<{ __typename?: 'AggregationOption', count?: number | null, id?: number | null, label?: string | null, value: string } | null> | null } | null> | null };

export type HighlightBrandsQueryVariables = Exact<{ [key: string]: never; }>;


export type HighlightBrandsQuery = { __typename?: 'Query', highlightBrands?: { __typename?: 'HighlightBrands', id?: string | null, category_layout?: { __typename?: 'BrandLayout', banner_image?: string | null, banner_link?: string | null, border_type?: string | null, limit_qty?: number | null, row_qty?: number | null, layout?: { __typename?: 'LayoutData', label?: string | null, value?: number | null } | null } | null, homepage_layout?: { __typename?: 'BrandLayout', banner_image?: string | null, banner_link?: string | null, border_type?: string | null, limit_qty?: number | null, row_qty?: number | null, layout?: { __typename?: 'LayoutData', label?: string | null, value?: number | null } | null } | null, items?: Array<{ __typename?: 'HighlightBrand', alt?: string | null, img?: string | null, label?: string | null, position?: number | null, url?: string | null, description?: string | null, id?: number | null, meta_description?: string | null, meta_title?: string | null } | null> | null } | null };

export type HighlightBrandsForCategoryQueryVariables = Exact<{ [key: string]: never; }>;


export type HighlightBrandsForCategoryQuery = { __typename?: 'Query', highlightBrands?: { __typename?: 'HighlightBrands', items?: Array<{ __typename?: 'HighlightBrand', alt?: string | null, img?: string | null, label?: string | null, id?: number | null, meta_description?: string | null, review_count?: number | null, sold_count?: number | null, like_count?: number | null, title_description?: string | null } | null> | null } | null };

export type CheckIsBrandLikedQueryVariables = Exact<{
  filter?: InputMaybe<FavoriteBrandFilter>;
}>;


export type CheckIsBrandLikedQuery = { __typename?: 'Query', myFavoriteBrands?: { __typename?: 'MyFavoriteBrands', brands?: Array<{ __typename?: 'HighlightBrand', id?: number | null } | null> | null } | null };

export type MyFavoriteBrandsQueryVariables = Exact<{
  filter?: InputMaybe<FavoriteBrandFilter>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MyFavoriteBrandsQuery = { __typename?: 'Query', myFavoriteBrands?: { __typename?: 'MyFavoriteBrands', brands?: Array<{ __typename?: 'HighlightBrand', id?: number | null } | null> | null, pagination?: { __typename?: 'PageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null, total_count?: number | null } | null } | null };

export type LikeBrandMutationVariables = Exact<{
  brandId: Scalars['Int']['input'];
  action: FollowerActionEnum;
}>;


export type LikeBrandMutation = { __typename?: 'Mutation', likeBrand: { __typename?: 'CatalogStatusMessageResponse', status: boolean, message?: string | null } };

export type BrandsQueryVariables = Exact<{
  brandIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BrandsQuery = { __typename?: 'Query', brands?: { __typename?: 'Brands', total_count?: number | null, page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } | null, items?: Array<{ __typename?: 'HighlightBrand', alt?: string | null, img?: string | null, label?: string | null, id?: number | null, meta_description?: string | null, review_count?: number | null, sold_count?: number | null, like_count?: number | null, title_description?: string | null, url?: string | null, banner_image?: string | null, achievement?: { __typename?: 'Achievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, label?: string | null, border_color?: string | null } | null } | null> | null } | null };

export type ProductQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type ProductQuery = { __typename?: 'Query', productBySku?: { __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, made_in?: number | null, age?: number | null, kich_thuoc?: string | null, chon_so?: number | null, gram?: number | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null, product_achievements?: Array<{ __typename?: 'ProductAchievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, border_color?: string | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, made_in?: number | null, age?: number | null, kich_thuoc?: string | null, chon_so?: number | null, gram?: number | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null, product_achievements?: Array<{ __typename?: 'ProductAchievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, border_color?: string | null } | null> | null } | { __typename?: 'VirtualProduct' } | null };

export type ProductMediaGalleryBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type ProductMediaGalleryBySkuQuery = { __typename?: 'Query', productBySku?: { __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null } | { __typename?: 'VirtualProduct' } | null };

export type ProductPriceTiersBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type ProductPriceTiersBySkuQuery = { __typename?: 'Query', productBySku?: { __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', price_tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', price_tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null } | { __typename?: 'VirtualProduct' } | null };

export type ProductPriceTiersByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ProductPriceTiersByUuidQuery = { __typename?: 'Query', productByUuid?: { __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', price_tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', price_tiers?: Array<{ __typename?: 'TierPrice', quantity?: number | null, discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null } | { __typename?: 'VirtualProduct' } | null };

export type RelatedProductsOfProductQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type RelatedProductsOfProductQuery = { __typename?: 'Query', productBySku?: { __typename?: 'BundleProduct', id?: number | null, related_products_two?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'ConfigurableProduct', id?: number | null, related_products_two?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'DownloadableProduct', id?: number | null, related_products_two?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'GroupedProduct', id?: number | null, related_products_two?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'SimpleProduct', id?: number | null, related_products_two?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'VirtualProduct', id?: number | null, related_products_two?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | null };

export type ProductListTotalCountQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
}>;


export type ProductListTotalCountQuery = { __typename?: 'Query', products?: { __typename?: 'Products', total_count?: number | null } | null };

export type ProductListPageInfoQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
}>;


export type ProductListPageInfoQuery = { __typename?: 'Query', products?: { __typename?: 'Products', page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } | null } | null };

export type ProductListAggregationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
}>;


export type ProductListAggregationsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', aggregations?: Array<{ __typename?: 'Aggregation', attribute_code: string, count?: number | null, label?: string | null, options?: Array<{ __typename?: 'AggregationOption', count?: number | null, label?: string | null, value: string } | null> | null } | null> | null } | null };

export type ProductListSortFieldsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
}>;


export type ProductListSortFieldsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', sort_fields?: { __typename?: 'SortFields', default?: string | null, options?: Array<{ __typename?: 'SortField', label?: string | null, value?: string | null } | null> | null } | null } | null };

export type ProductListItemsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ProductAttributeSortInput>;
}>;


export type ProductListItemsQuery = { __typename?: 'Query', products?: { __typename?: 'Products', total_count?: number | null, page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } | null, aggregations?: Array<{ __typename?: 'Aggregation', attribute_code: string, count?: number | null, label?: string | null, options?: Array<{ __typename?: 'AggregationOption', count?: number | null, label?: string | null, value: string } | null> | null } | null> | null, sort_fields?: { __typename?: 'SortFields', default?: string | null, options?: Array<{ __typename?: 'SortField', label?: string | null, value?: string | null } | null> | null } | null, items?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | null };

export type ProductDetailQueryVariables = Exact<{
  filter?: InputMaybe<ProductAttributeFilterInput>;
}>;


export type ProductDetailQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, product_achievements?: Array<{ __typename?: 'ProductAchievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, border_color?: string | null } | null> | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null } | { __typename?: 'DownloadableProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null } | { __typename?: 'GroupedProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, product_achievements?: Array<{ __typename?: 'ProductAchievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, border_color?: string | null } | null> | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null } | { __typename?: 'VirtualProduct', description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null } | null> | null } | null };

export type InterestedProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type InterestedProductsQuery = { __typename?: 'Query', interestedProducts?: { __typename?: 'InterestedProducts', items?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | null };

export type ProductByUrlKeyQueryVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type ProductByUrlKeyQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, made_in?: number | null, age?: number | null, kich_thuoc?: string | null, chon_so?: number | null, gram?: number | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null, product_achievements?: Array<{ __typename?: 'ProductAchievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, border_color?: string | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, made_in?: number | null, age?: number | null, kich_thuoc?: string | null, chon_so?: number | null, gram?: number | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null, product_achievements?: Array<{ __typename?: 'ProductAchievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, border_color?: string | null } | null> | null } | { __typename?: 'VirtualProduct' } | null> | null } | null };

export type CrossSellProductBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type CrossSellProductBySkuQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct', crosssell_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, crosssell_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | { __typename?: 'DownloadableProduct', crosssell_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'GroupedProduct', crosssell_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, crosssell_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | { __typename?: 'VirtualProduct', crosssell_products?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | null> | null } | null };

export type ProductListBySkusQueryVariables = Exact<{
  filter?: InputMaybe<ProductAttributeFilterInput>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductListBySkusQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null, page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } | null } | null };

export type ProductByUuidQueryVariables = Exact<{
  uuid: Scalars['String']['input'];
}>;


export type ProductByUuidQuery = { __typename?: 'Query', productByUuid?: { __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, made_in?: number | null, age?: number | null, kich_thuoc?: string | null, chon_so?: number | null, gram?: number | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, variants?: Array<{ __typename?: 'ConfigurableVariant', attributes?: Array<{ __typename?: 'ConfigurableAttributeOption', code?: string | null, label?: string | null, value_index?: number | null } | null> | null, product?: { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } } } | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null, product_achievements?: Array<{ __typename?: 'ProductAchievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, border_color?: string | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, made_in?: number | null, age?: number | null, kich_thuoc?: string | null, chon_so?: number | null, gram?: number | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, description?: { __typename?: 'ComplexTextValue', html: string } | null, short_description?: { __typename?: 'ComplexTextValue', html: string } | null, product_achievements?: Array<{ __typename?: 'ProductAchievement', name?: string | null, description?: string | null, image?: string | null, target_link?: string | null, background_color?: string | null, text_color?: string | null, border_color?: string | null } | null> | null } | { __typename?: 'VirtualProduct' } | null };

export type AdditionalDataAttributeProductQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type AdditionalDataAttributeProductQuery = { __typename?: 'Query', productBySku?: { __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, additional_data_attributes?: Array<{ __typename?: 'AdditionalDataAttribute', value?: string | null, label?: string | null, code?: string | null } | null> | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, additional_data_attributes?: Array<{ __typename?: 'AdditionalDataAttribute', value?: string | null, label?: string | null, code?: string | null } | null> | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | { __typename?: 'VirtualProduct' } | null };

export type NotificationsProductBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type NotificationsProductBySkuQuery = { __typename?: 'Query', products?: { __typename?: 'Products', items?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, notifications?: Array<{ __typename?: 'ProductNotification', content?: string | null, notification_id?: number | null, notification_type?: string | null, status?: number | null, title?: string | null } | null> | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, notifications?: Array<{ __typename?: 'ProductNotification', content?: string | null, notification_id?: number | null, notification_type?: string | null, status?: number | null, title?: string | null } | null> | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | { __typename?: 'VirtualProduct' } | null> | null } | null };

export type HighlightCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type HighlightCategoriesQuery = { __typename?: 'Query', highlightCategories?: { __typename?: 'HighlightCategories', items?: Array<{ __typename?: 'HighlightCategory', background_app_icon?: string | null, featured_app_icon?: string | null, featured_icon?: string | null, featured_icon_solid?: string | null, name?: string | null, priority?: string | null, url?: string | null, id?: number | null } | null> | null } | null };

export type ProductBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type ProductBySkuQuery = { __typename?: 'Query', productBySku?: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null, media_gallery?: Array<{ __typename?: 'ProductImage', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null } | { __typename?: 'ProductVideo', disabled?: boolean | null, label?: string | null, position?: number | null, url?: string | null, video_content?: { __typename?: 'ProductMediaGalleryEntriesVideoContent', media_type?: string | null, video_description?: string | null, video_metadata?: string | null, video_provider?: string | null, video_title?: string | null, video_url?: string | null } | null } | null> | null } | null };

export type HighlightProductBlocksQueryVariables = Exact<{
  blockTypes?: InputMaybe<Array<InputMaybe<BlockTypeEnum>> | InputMaybe<BlockTypeEnum>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HighlightProductBlocksQuery = { __typename?: 'Query', highlightProductBlocks?: { __typename?: 'HighlightProductBlocks', items?: Array<{ __typename?: 'ProductBlock', name?: string | null, block_type?: string | null, limit_products_for_app?: number | null, app_layout_type?: { __typename?: 'LayoutData', label?: string | null, value?: number | null } | null, products?: { __typename?: 'Products', total_count?: number | null, items?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null, page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } | null } | null } | null> | null } | null };

export type CategoryHighlightProductsQueryVariables = Exact<{
  categoryId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CategoryHighlightProductsQuery = { __typename?: 'Query', categoryHighlightProducts?: { __typename?: 'CategoryHighlightProducts', items?: Array<{ __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename?: 'VirtualProduct' } | null> | null } | null };

export type UserGuideProductBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type UserGuideProductBySkuQuery = { __typename?: 'Query', productBySku?: { __typename?: 'BundleProduct', user_guide?: string | null, id?: number | null, sku?: string | null } | { __typename?: 'ConfigurableProduct', user_guide?: string | null, id?: number | null, sku?: string | null } | { __typename?: 'DownloadableProduct', user_guide?: string | null, id?: number | null, sku?: string | null } | { __typename?: 'GroupedProduct', user_guide?: string | null, id?: number | null, sku?: string | null } | { __typename?: 'SimpleProduct', user_guide?: string | null, id?: number | null, sku?: string | null } | { __typename?: 'VirtualProduct', user_guide?: string | null, id?: number | null, sku?: string | null } | null };

export type ProductBadgesBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type ProductBadgesBySkuQuery = { __typename?: 'Query', productBySku?: { __typename?: 'BundleProduct', id?: number | null, sku?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | { __typename?: 'ConfigurableProduct', id?: number | null, sku?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | { __typename?: 'DownloadableProduct', id?: number | null, sku?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | { __typename?: 'GroupedProduct', id?: number | null, sku?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | { __typename?: 'SimpleProduct', id?: number | null, sku?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | { __typename?: 'VirtualProduct', id?: number | null, sku?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null } | null };

export type BrandHighlightProductsQueryVariables = Exact<{
  brandIds: Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  currentPage?: InputMaybe<Scalars['Int']['input']>;
  highlightProductsPageSize?: InputMaybe<Scalars['Int']['input']>;
  highlightProductsCurrentPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BrandHighlightProductsQuery = { __typename?: 'Query', brands?: { __typename?: 'Brands', items?: Array<{ __typename?: 'HighlightBrand', id?: number | null, highlight_products?: { __typename?: 'Products', total_count?: number | null, page_info?: { __typename?: 'SearchResultPageInfo', current_page?: number | null, page_size?: number | null, total_pages?: number | null } | null, items?: Array<{ __typename: 'BundleProduct' } | { __typename: 'ConfigurableProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, configurable_options?: Array<{ __typename?: 'ConfigurableProductOptions', attribute_code?: string | null, attribute_id?: string | null, product_id?: number | null, id?: number | null, label?: string | null, position?: number | null, use_default?: boolean | null, values?: Array<{ __typename?: 'ConfigurableProductOptionsValues', default_label?: string | null, label?: string | null, store_label?: string | null, use_default_value?: boolean | null, value_index?: number | null, swatch_data?: { __typename?: 'ColorSwatchData', value?: string | null } | { __typename?: 'ImageSwatchData', thumbnail?: string | null, value?: string | null } | { __typename?: 'TextSwatchData', value?: string | null } | null } | null> | null } | null> | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename: 'DownloadableProduct' } | { __typename: 'GroupedProduct' } | { __typename: 'SimpleProduct', id?: number | null, sku?: string | null, name?: string | null, url_key?: string | null, url_suffix?: string | null, stock_status?: ProductStockStatus | null, brand?: number | null, ratings_count?: number | null, ratings_summary?: number | null, has_gift?: boolean | null, new_product?: boolean | null, news_from_date?: string | null, news_to_date?: string | null, meta_title?: string | null, meta_description?: string | null, meta_keyword?: string | null, canonical_url?: string | null, sold_quantity?: number | null, special_from_date?: string | null, special_price?: number | null, special_to_date?: string | null, price_range: { __typename?: 'PriceRange', maximum_price?: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } | null, minimum_price: { __typename?: 'ProductPrice', discount?: { __typename?: 'ProductDiscount', amount_off?: number | null, percent_off?: number | null } | null, final_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null }, fixed_product_taxes?: Array<{ __typename?: 'FixedProductTax', label?: string | null, amount?: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } | null } | null> | null, regular_price: { __typename?: 'Money', currency?: CurrencyEnum | null, value?: number | null } } }, product_badges?: Array<{ __typename?: 'ProductBadge', description?: string | null, end_date?: string | null, id?: number | null, image?: string | null, is_active?: boolean | null, name?: string | null, position?: number | null, start_date?: string | null } | null> | null, thumbnail?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null, small_image?: { __typename?: 'ProductImage', label?: string | null, position?: number | null, url?: string | null } | null } | { __typename: 'VirtualProduct' } | null> | null } | null } | null> | null } | null };

export type ProductFlashSaleDataQueryVariables = Exact<{
  productId?: InputMaybe<Scalars['Int']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductFlashSaleDataQuery = { __typename?: 'Query', flashSaleProduct?: { __typename?: 'FlashSaleProduct', sales_data?: { __typename?: 'FlashSaleProductData', deal_qty?: number | null, flashsale_id?: number | null, sale_qty?: number | null } | null } | null };

export type ProductSoldQuantityQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type ProductSoldQuantityQuery = { __typename?: 'Query', productBySku?: { __typename: 'BundleProduct' } | { __typename: 'ConfigurableProduct', id?: number | null, sku?: string | null, sold_quantity?: number | null } | { __typename: 'DownloadableProduct' } | { __typename: 'GroupedProduct' } | { __typename: 'SimpleProduct', id?: number | null, sku?: string | null, sold_quantity?: number | null } | { __typename: 'VirtualProduct' } | null };

export type ProductSalableQuantityQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  requestQty: Scalars['Int']['input'];
}>;


export type ProductSalableQuantityQuery = { __typename?: 'Query', productSalableQuantity?: { __typename?: 'ProductSalableQuantity', is_salable?: boolean | null } | null };

export type ProductsSalableQuantityQueryVariables = Exact<{
  items?: InputMaybe<Array<ProductSalableQuantityInput> | ProductSalableQuantityInput>;
}>;


export type ProductsSalableQuantityQuery = { __typename?: 'Query', productsSalableQuantity?: Array<{ __typename?: 'ProductSalableQuantity', is_salable?: boolean | null, available_quantity?: number | null, sku?: string | null, errors?: Array<{ __typename?: 'ProductSalableQuantityError', code?: string | null, message?: string | null } | null> | null } | null> | null };

export type ProductCategoriesQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type ProductCategoriesQuery = { __typename?: 'Query', productBySku?: { __typename?: 'BundleProduct' } | { __typename?: 'ConfigurableProduct', categories?: Array<{ __typename?: 'CategoryTree', id?: number | null, name?: string | null, url_key?: number | null, url_suffix?: string | null } | null> | null } | { __typename?: 'DownloadableProduct' } | { __typename?: 'GroupedProduct' } | { __typename?: 'SimpleProduct', categories?: Array<{ __typename?: 'CategoryTree', id?: number | null, name?: string | null, url_key?: number | null, url_suffix?: string | null } | null> | null } | { __typename?: 'VirtualProduct' } | null };

export type SliderBannersQueryVariables = Exact<{
  location?: InputMaybe<Scalars['String']['input']>;
}>;


export type SliderBannersQuery = { __typename?: 'Query', sliderBanners?: { __typename?: 'BannerItems', items?: Array<{ __typename?: 'Banner', app_image_url?: string | null, background_color?: string | null, banner_id?: number | null, image_app?: string | null, name?: string | null, position?: string | null, url_banner?: string | null } | null> | null, layout?: { __typename?: 'BannerLayoutData', label?: string | null, value?: string | null } | null } | null };

export const ProductAchievementFragmentDoc = gql`
    fragment ProductAchievement on ProductAchievement {
  name
  description
  image
  target_link
  background_color
  text_color
  border_color
}
    `;
export const SimpleProductAchievementFragmentDoc = gql`
    fragment SimpleProductAchievement on SimpleProduct {
  brand
  product_achievements {
    ...ProductAchievement
  }
}
    ${ProductAchievementFragmentDoc}`;
export const ConfigurableProductAchievementFragmentDoc = gql`
    fragment ConfigurableProductAchievement on ConfigurableProduct {
  brand
  product_achievements {
    ...ProductAchievement
  }
}
    ${ProductAchievementFragmentDoc}`;
export const HighlightBrandAchievementFragmentDoc = gql`
    fragment HighlightBrandAchievement on HighlightBrand {
  achievement {
    name
    description
    image
    target_link
    background_color
    text_color
    label
    border_color
  }
}
    `;
export const ProductPaginationInfoFragmentDoc = gql`
    fragment ProductPaginationInfo on SearchResultPageInfo {
  current_page
  page_size
  total_pages
}
    `;
export const ProductMediaGalleryFragmentDoc = gql`
    fragment ProductMediaGallery on ProductInterface {
  media_gallery {
    ... on ProductImage {
      disabled
      label
      position
      url
    }
    ... on ProductVideo {
      disabled
      label
      position
      url
      video_content {
        media_type
        video_description
        video_metadata
        video_provider
        video_title
        video_url
      }
    }
    url
  }
}
    `;
export const ConfigurableProductMediaGalleryFragmentDoc = gql`
    fragment ConfigurableProductMediaGallery on ConfigurableProduct {
  media_gallery {
    ... on ProductImage {
      disabled
      label
      position
      url
    }
    ... on ProductVideo {
      disabled
      label
      position
      url
      video_content {
        media_type
        video_description
        video_metadata
        video_provider
        video_title
        video_url
      }
    }
    url
  }
}
    `;
export const SimpleProductMediaGalleryFragmentDoc = gql`
    fragment SimpleProductMediaGallery on SimpleProduct {
  media_gallery {
    ... on ProductImage {
      disabled
      label
      position
      url
    }
    ... on ProductVideo {
      disabled
      label
      position
      url
      video_content {
        media_type
        video_description
        video_metadata
        video_provider
        video_title
        video_url
      }
    }
    url
  }
}
    `;
export const ProductAttributeBasicFragmentDoc = gql`
    fragment ProductAttributeBasic on ConfigurableProduct {
  id
  sku
  name
}
    `;
export const ConfigurableProductImageFragmentDoc = gql`
    fragment ConfigurableProductImage on ConfigurableProduct {
  thumbnail {
    label
    position
    url
  }
  small_image {
    label
    position
    url
  }
}
    `;
export const ConfigurableProductPriceFragmentDoc = gql`
    fragment ConfigurableProductPrice on ConfigurableProduct {
  price_range {
    maximum_price {
      discount {
        amount_off
        percent_off
      }
      final_price {
        currency
        value
      }
      fixed_product_taxes {
        amount {
          currency
          value
        }
        label
      }
      regular_price {
        currency
        value
      }
    }
    minimum_price {
      discount {
        amount_off
        percent_off
      }
      final_price {
        currency
        value
      }
      fixed_product_taxes {
        amount {
          currency
          value
        }
        label
      }
      regular_price {
        currency
        value
      }
    }
  }
}
    `;
export const ProductBadgeFieldsFragmentDoc = gql`
    fragment ProductBadgeFields on ProductBadge {
  description
  end_date
  id
  image
  is_active
  name
  position
  start_date
}
    `;
export const ConfigurableProductBasicFragmentDoc = gql`
    fragment ConfigurableProductBasic on ConfigurableProduct {
  id
  sku
  name
  url_key
  url_suffix
  stock_status
  brand
  ratings_count
  ratings_summary
  has_gift
  new_product
  news_from_date
  news_to_date
  meta_title
  meta_description
  meta_keyword
  canonical_url
  product_badges {
    ...ProductBadgeFields
  }
  sold_quantity
}
    ${ProductBadgeFieldsFragmentDoc}`;
export const SimpleProductImageFragmentDoc = gql`
    fragment SimpleProductImage on SimpleProduct {
  thumbnail {
    label
    position
    url
  }
  small_image {
    label
    position
    url
  }
}
    `;
export const SimpleProductPriceFragmentDoc = gql`
    fragment SimpleProductPrice on SimpleProduct {
  price_range {
    maximum_price {
      discount {
        amount_off
        percent_off
      }
      final_price {
        currency
        value
      }
      fixed_product_taxes {
        amount {
          currency
          value
        }
        label
      }
      regular_price {
        currency
        value
      }
    }
    minimum_price {
      discount {
        amount_off
        percent_off
      }
      final_price {
        currency
        value
      }
      fixed_product_taxes {
        amount {
          currency
          value
        }
        label
      }
      regular_price {
        currency
        value
      }
    }
  }
}
    `;
export const SimpleProductBasicFragmentDoc = gql`
    fragment SimpleProductBasic on SimpleProduct {
  id
  sku
  name
  url_key
  url_suffix
  stock_status
  brand
  ratings_count
  ratings_summary
  has_gift
  new_product
  news_from_date
  news_to_date
  meta_title
  meta_description
  meta_keyword
  canonical_url
  product_badges {
    ...ProductBadgeFields
  }
  sold_quantity
}
    ${ProductBadgeFieldsFragmentDoc}`;
export const ProductSpecialPriceFragmentDoc = gql`
    fragment ProductSpecialPrice on ProductInterface {
  special_from_date
  special_price
  special_to_date
}
    `;
export const ProductDescriptionFragmentDoc = gql`
    fragment ProductDescription on ProductInterface {
  description {
    html
  }
  short_description {
    html
  }
}
    `;
export const ConfigurableProductVariantsFragmentDoc = gql`
    fragment ConfigurableProductVariants on ConfigurableProduct {
  variants {
    attributes {
      code
      label
      value_index
    }
    product {
      id
      sku
      name
      url_key
      url_suffix
      stock_status
      brand
      ratings_count
      ratings_summary
      media_gallery {
        disabled
        label
        position
        url
      }
      thumbnail {
        disabled
        label
        position
        url
      }
      small_image {
        disabled
        label
        position
        url
      }
      price_range {
        maximum_price {
          discount {
            amount_off
            percent_off
          }
          final_price {
            currency
            value
          }
          fixed_product_taxes {
            amount {
              currency
              value
            }
            label
          }
          regular_price {
            currency
            value
          }
        }
        minimum_price {
          discount {
            amount_off
            percent_off
          }
          final_price {
            currency
            value
          }
          fixed_product_taxes {
            amount {
              currency
              value
            }
            label
          }
          regular_price {
            currency
            value
          }
        }
      }
      special_from_date
      special_price
      special_to_date
    }
  }
}
    `;
export const ConfigurableProductOptionsValuesSwatchDataFragmentDoc = gql`
    fragment ConfigurableProductOptionsValuesSwatchData on ConfigurableProductOptionsValues {
  swatch_data {
    ... on ColorSwatchData {
      value
    }
    ... on ImageSwatchData {
      thumbnail
      value
    }
    ... on TextSwatchData {
      value
    }
  }
}
    `;
export const ConfigurableProductOptionsFragmentDoc = gql`
    fragment ConfigurableProductOptions on ConfigurableProduct {
  configurable_options {
    attribute_code
    attribute_id
    product_id
    id
    label
    position
    use_default
    values {
      default_label
      label
      store_label
      use_default_value
      value_index
      ...ConfigurableProductOptionsValuesSwatchData
    }
  }
}
    ${ConfigurableProductOptionsValuesSwatchDataFragmentDoc}`;
export const ProductListAggregationsFragmentDoc = gql`
    fragment ProductListAggregations on Aggregation {
  attribute_code
  count
  label
  options {
    count
    label
    value
  }
}
    `;
export const ProductListSortFieldsFragmentDoc = gql`
    fragment ProductListSortFields on SortFields {
  default
  options {
    label
    value
  }
}
    `;
export const ConfigurableProductDescriptionFragmentDoc = gql`
    fragment ConfigurableProductDescription on ConfigurableProduct {
  description {
    html
  }
  short_description {
    html
  }
}
    `;
export const SimpleProductDescriptionFragmentDoc = gql`
    fragment SimpleProductDescription on SimpleProduct {
  description {
    html
  }
  short_description {
    html
  }
}
    `;
export const ConfigurableProductParametersFragmentDoc = gql`
    fragment ConfigurableProductParameters on ConfigurableProduct {
  made_in
  age
  kich_thuoc
  chon_so
  gram
  ratings_count
  ratings_summary
  sold_quantity
}
    `;
export const SimpleProductParametersFragmentDoc = gql`
    fragment SimpleProductParameters on SimpleProduct {
  made_in
  age
  kich_thuoc
  chon_so
  gram
  ratings_count
  ratings_summary
  sold_quantity
}
    `;
export const SimpleProductSpecialPriceFragmentDoc = gql`
    fragment SimpleProductSpecialPrice on SimpleProduct {
  special_from_date
  special_price
  special_to_date
}
    `;
export const ConfigurableProductSpecialPriceFragmentDoc = gql`
    fragment ConfigurableProductSpecialPrice on ConfigurableProduct {
  special_from_date
  special_price
  special_to_date
}
    `;
export const SimpleProductBadgesFragmentDoc = gql`
    fragment SimpleProductBadges on SimpleProduct {
  product_badges {
    description
    end_date
    id
    image
    is_active
    name
    position
    start_date
  }
}
    `;
export const ConfigurableProductBadgesFragmentDoc = gql`
    fragment ConfigurableProductBadges on ConfigurableProduct {
  product_badges {
    description
    end_date
    id
    image
    is_active
    name
    position
    start_date
  }
}
    `;
export const SimpleProductPriceTiersFragmentDoc = gql`
    fragment SimpleProductPriceTiers on SimpleProduct {
  price_tiers {
    discount {
      amount_off
      percent_off
    }
    final_price {
      currency
      value
    }
    quantity
  }
}
    `;
export const ConfigurableProductPriceTiersFragmentDoc = gql`
    fragment ConfigurableProductPriceTiers on ConfigurableProduct {
  price_tiers {
    discount {
      amount_off
      percent_off
    }
    final_price {
      currency
      value
    }
    quantity
  }
}
    `;
export const UsefulInformationItemFragmentDoc = gql`
    fragment UsefulInformationItem on Post {
  comment_status
  guid
  id
  post_content
  post_date
  post_excerpt
  post_modified
  post_modified_gmt
  post_name
  post_status
  post_title
  post_type
  post_url
  thumb_img
  author
  views_count
}
    `;
export const AttributeOptionsDocument = gql`
    query AttributeOptions($attributes: [AttributeInput!]!) {
  customAttributeMetadata(attributes: $attributes) {
    items {
      attribute_options {
        label
        value
        swatch_data {
          ... on ColorSwatchData {
            value
          }
          ... on TextSwatchData {
            value
          }
          ... on ImageSwatchData {
            value
            thumbnail
          }
        }
      }
      attribute_code
      attribute_type
      entity_type
      input_type
    }
  }
}
    `;

/**
 * __useAttributeOptionsQuery__
 *
 * To run a query within a React component, call `useAttributeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAttributeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAttributeOptionsQuery({
 *   variables: {
 *      attributes: // value for 'attributes'
 *   },
 * });
 */
export function useAttributeOptionsQuery(baseOptions: Apollo.QueryHookOptions<AttributeOptionsQuery, AttributeOptionsQueryVariables> & ({ variables: AttributeOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AttributeOptionsQuery, AttributeOptionsQueryVariables>(AttributeOptionsDocument, options);
      }
export function useAttributeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AttributeOptionsQuery, AttributeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AttributeOptionsQuery, AttributeOptionsQueryVariables>(AttributeOptionsDocument, options);
        }
export function useAttributeOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AttributeOptionsQuery, AttributeOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AttributeOptionsQuery, AttributeOptionsQueryVariables>(AttributeOptionsDocument, options);
        }
export type AttributeOptionsQueryHookResult = ReturnType<typeof useAttributeOptionsQuery>;
export type AttributeOptionsLazyQueryHookResult = ReturnType<typeof useAttributeOptionsLazyQuery>;
export type AttributeOptionsSuspenseQueryHookResult = ReturnType<typeof useAttributeOptionsSuspenseQuery>;
export type AttributeOptionsQueryResult = Apollo.QueryResult<AttributeOptionsQuery, AttributeOptionsQueryVariables>;
export const CategoryListDocument = gql`
    query CategoryList($filters: CategoryFilterInput) {
  categoryList(filters: $filters) {
    id
    children {
      name
      id
      position
      featured_app_icon
      background_app_icon
      is_featured
      include_in_menu
    }
  }
}
    `;

/**
 * __useCategoryListQuery__
 *
 * To run a query within a React component, call `useCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCategoryListQuery(baseOptions?: Apollo.QueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
      }
export function useCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
        }
export function useCategoryListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoryListQuery, CategoryListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryListQuery, CategoryListQueryVariables>(CategoryListDocument, options);
        }
export type CategoryListQueryHookResult = ReturnType<typeof useCategoryListQuery>;
export type CategoryListLazyQueryHookResult = ReturnType<typeof useCategoryListLazyQuery>;
export type CategoryListSuspenseQueryHookResult = ReturnType<typeof useCategoryListSuspenseQuery>;
export type CategoryListQueryResult = Apollo.QueryResult<CategoryListQuery, CategoryListQueryVariables>;
export const CategoryBannersDocument = gql`
    query CategoryBanners($categoryId: Int, $type: String) {
  categoryBanners(category_id: $categoryId, type: $type) {
    items {
      app_image_url
      background_color
      banner_id
      image_app
      name
      position
      url_banner
    }
    layout {
      label
      value
    }
  }
}
    `;

/**
 * __useCategoryBannersQuery__
 *
 * To run a query within a React component, call `useCategoryBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryBannersQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCategoryBannersQuery(baseOptions?: Apollo.QueryHookOptions<CategoryBannersQuery, CategoryBannersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryBannersQuery, CategoryBannersQueryVariables>(CategoryBannersDocument, options);
      }
export function useCategoryBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryBannersQuery, CategoryBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryBannersQuery, CategoryBannersQueryVariables>(CategoryBannersDocument, options);
        }
export function useCategoryBannersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoryBannersQuery, CategoryBannersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryBannersQuery, CategoryBannersQueryVariables>(CategoryBannersDocument, options);
        }
export type CategoryBannersQueryHookResult = ReturnType<typeof useCategoryBannersQuery>;
export type CategoryBannersLazyQueryHookResult = ReturnType<typeof useCategoryBannersLazyQuery>;
export type CategoryBannersSuspenseQueryHookResult = ReturnType<typeof useCategoryBannersSuspenseQuery>;
export type CategoryBannersQueryResult = Apollo.QueryResult<CategoryBannersQuery, CategoryBannersQueryVariables>;
export const CategoryHighlightAttributesDocument = gql`
    query CategoryHighlightAttributes($filters: CategoryFilterInput) {
  categoryList(filters: $filters) {
    id
    highlight_product_attributes {
      attribute_code
      attribute_options {
        label
        value
      }
      attribute_type
      entity_type
      input_type
    }
  }
}
    `;

/**
 * __useCategoryHighlightAttributesQuery__
 *
 * To run a query within a React component, call `useCategoryHighlightAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryHighlightAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryHighlightAttributesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCategoryHighlightAttributesQuery(baseOptions?: Apollo.QueryHookOptions<CategoryHighlightAttributesQuery, CategoryHighlightAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryHighlightAttributesQuery, CategoryHighlightAttributesQueryVariables>(CategoryHighlightAttributesDocument, options);
      }
export function useCategoryHighlightAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryHighlightAttributesQuery, CategoryHighlightAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryHighlightAttributesQuery, CategoryHighlightAttributesQueryVariables>(CategoryHighlightAttributesDocument, options);
        }
export function useCategoryHighlightAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoryHighlightAttributesQuery, CategoryHighlightAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryHighlightAttributesQuery, CategoryHighlightAttributesQueryVariables>(CategoryHighlightAttributesDocument, options);
        }
export type CategoryHighlightAttributesQueryHookResult = ReturnType<typeof useCategoryHighlightAttributesQuery>;
export type CategoryHighlightAttributesLazyQueryHookResult = ReturnType<typeof useCategoryHighlightAttributesLazyQuery>;
export type CategoryHighlightAttributesSuspenseQueryHookResult = ReturnType<typeof useCategoryHighlightAttributesSuspenseQuery>;
export type CategoryHighlightAttributesQueryResult = Apollo.QueryResult<CategoryHighlightAttributesQuery, CategoryHighlightAttributesQueryVariables>;
export const HighlightProductAttributesDocument = gql`
    query HighlightProductAttributes($categoryId: Int!) {
  highlightProductAttributes(category_id: $categoryId) {
    attribute_code
    count
    label
    options {
      count
      id
      label
      value
    }
  }
}
    `;

/**
 * __useHighlightProductAttributesQuery__
 *
 * To run a query within a React component, call `useHighlightProductAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighlightProductAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighlightProductAttributesQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useHighlightProductAttributesQuery(baseOptions: Apollo.QueryHookOptions<HighlightProductAttributesQuery, HighlightProductAttributesQueryVariables> & ({ variables: HighlightProductAttributesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightProductAttributesQuery, HighlightProductAttributesQueryVariables>(HighlightProductAttributesDocument, options);
      }
export function useHighlightProductAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightProductAttributesQuery, HighlightProductAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightProductAttributesQuery, HighlightProductAttributesQueryVariables>(HighlightProductAttributesDocument, options);
        }
export function useHighlightProductAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HighlightProductAttributesQuery, HighlightProductAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HighlightProductAttributesQuery, HighlightProductAttributesQueryVariables>(HighlightProductAttributesDocument, options);
        }
export type HighlightProductAttributesQueryHookResult = ReturnType<typeof useHighlightProductAttributesQuery>;
export type HighlightProductAttributesLazyQueryHookResult = ReturnType<typeof useHighlightProductAttributesLazyQuery>;
export type HighlightProductAttributesSuspenseQueryHookResult = ReturnType<typeof useHighlightProductAttributesSuspenseQuery>;
export type HighlightProductAttributesQueryResult = Apollo.QueryResult<HighlightProductAttributesQuery, HighlightProductAttributesQueryVariables>;
export const HighlightBrandsDocument = gql`
    query HighlightBrands {
  highlightBrands {
    category_layout {
      banner_image
      banner_link
      border_type
      layout {
        label
        value
      }
      limit_qty
      row_qty
    }
    homepage_layout {
      banner_image
      banner_link
      border_type
      layout {
        label
        value
      }
      limit_qty
      row_qty
    }
    id
    items {
      alt
      img
      label
      position
      url
      description
      id
      meta_description
      meta_title
    }
  }
}
    `;

/**
 * __useHighlightBrandsQuery__
 *
 * To run a query within a React component, call `useHighlightBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighlightBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighlightBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHighlightBrandsQuery(baseOptions?: Apollo.QueryHookOptions<HighlightBrandsQuery, HighlightBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightBrandsQuery, HighlightBrandsQueryVariables>(HighlightBrandsDocument, options);
      }
export function useHighlightBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightBrandsQuery, HighlightBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightBrandsQuery, HighlightBrandsQueryVariables>(HighlightBrandsDocument, options);
        }
export function useHighlightBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HighlightBrandsQuery, HighlightBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HighlightBrandsQuery, HighlightBrandsQueryVariables>(HighlightBrandsDocument, options);
        }
export type HighlightBrandsQueryHookResult = ReturnType<typeof useHighlightBrandsQuery>;
export type HighlightBrandsLazyQueryHookResult = ReturnType<typeof useHighlightBrandsLazyQuery>;
export type HighlightBrandsSuspenseQueryHookResult = ReturnType<typeof useHighlightBrandsSuspenseQuery>;
export type HighlightBrandsQueryResult = Apollo.QueryResult<HighlightBrandsQuery, HighlightBrandsQueryVariables>;
export const HighlightBrandsForCategoryDocument = gql`
    query HighlightBrandsForCategory {
  highlightBrands {
    items {
      alt
      img
      label
      id
      meta_description
      review_count
      sold_count
      like_count
      title_description
    }
  }
}
    `;

/**
 * __useHighlightBrandsForCategoryQuery__
 *
 * To run a query within a React component, call `useHighlightBrandsForCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighlightBrandsForCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighlightBrandsForCategoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useHighlightBrandsForCategoryQuery(baseOptions?: Apollo.QueryHookOptions<HighlightBrandsForCategoryQuery, HighlightBrandsForCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightBrandsForCategoryQuery, HighlightBrandsForCategoryQueryVariables>(HighlightBrandsForCategoryDocument, options);
      }
export function useHighlightBrandsForCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightBrandsForCategoryQuery, HighlightBrandsForCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightBrandsForCategoryQuery, HighlightBrandsForCategoryQueryVariables>(HighlightBrandsForCategoryDocument, options);
        }
export function useHighlightBrandsForCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HighlightBrandsForCategoryQuery, HighlightBrandsForCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HighlightBrandsForCategoryQuery, HighlightBrandsForCategoryQueryVariables>(HighlightBrandsForCategoryDocument, options);
        }
export type HighlightBrandsForCategoryQueryHookResult = ReturnType<typeof useHighlightBrandsForCategoryQuery>;
export type HighlightBrandsForCategoryLazyQueryHookResult = ReturnType<typeof useHighlightBrandsForCategoryLazyQuery>;
export type HighlightBrandsForCategorySuspenseQueryHookResult = ReturnType<typeof useHighlightBrandsForCategorySuspenseQuery>;
export type HighlightBrandsForCategoryQueryResult = Apollo.QueryResult<HighlightBrandsForCategoryQuery, HighlightBrandsForCategoryQueryVariables>;
export const CheckIsBrandLikedDocument = gql`
    query CheckIsBrandLiked($filter: FavoriteBrandFilter) {
  myFavoriteBrands(filter: $filter) {
    brands {
      id
    }
  }
}
    `;

/**
 * __useCheckIsBrandLikedQuery__
 *
 * To run a query within a React component, call `useCheckIsBrandLikedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckIsBrandLikedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckIsBrandLikedQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCheckIsBrandLikedQuery(baseOptions?: Apollo.QueryHookOptions<CheckIsBrandLikedQuery, CheckIsBrandLikedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckIsBrandLikedQuery, CheckIsBrandLikedQueryVariables>(CheckIsBrandLikedDocument, options);
      }
export function useCheckIsBrandLikedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckIsBrandLikedQuery, CheckIsBrandLikedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckIsBrandLikedQuery, CheckIsBrandLikedQueryVariables>(CheckIsBrandLikedDocument, options);
        }
export function useCheckIsBrandLikedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckIsBrandLikedQuery, CheckIsBrandLikedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckIsBrandLikedQuery, CheckIsBrandLikedQueryVariables>(CheckIsBrandLikedDocument, options);
        }
export type CheckIsBrandLikedQueryHookResult = ReturnType<typeof useCheckIsBrandLikedQuery>;
export type CheckIsBrandLikedLazyQueryHookResult = ReturnType<typeof useCheckIsBrandLikedLazyQuery>;
export type CheckIsBrandLikedSuspenseQueryHookResult = ReturnType<typeof useCheckIsBrandLikedSuspenseQuery>;
export type CheckIsBrandLikedQueryResult = Apollo.QueryResult<CheckIsBrandLikedQuery, CheckIsBrandLikedQueryVariables>;
export const MyFavoriteBrandsDocument = gql`
    query MyFavoriteBrands($filter: FavoriteBrandFilter, $page: Int, $pageSize: Int) {
  myFavoriteBrands(filter: $filter, page: $page, page_size: $pageSize) {
    brands {
      id
    }
    pagination {
      current_page
      page_size
      total_pages
      total_count
    }
  }
}
    `;

/**
 * __useMyFavoriteBrandsQuery__
 *
 * To run a query within a React component, call `useMyFavoriteBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyFavoriteBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyFavoriteBrandsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useMyFavoriteBrandsQuery(baseOptions?: Apollo.QueryHookOptions<MyFavoriteBrandsQuery, MyFavoriteBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyFavoriteBrandsQuery, MyFavoriteBrandsQueryVariables>(MyFavoriteBrandsDocument, options);
      }
export function useMyFavoriteBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyFavoriteBrandsQuery, MyFavoriteBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyFavoriteBrandsQuery, MyFavoriteBrandsQueryVariables>(MyFavoriteBrandsDocument, options);
        }
export function useMyFavoriteBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MyFavoriteBrandsQuery, MyFavoriteBrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MyFavoriteBrandsQuery, MyFavoriteBrandsQueryVariables>(MyFavoriteBrandsDocument, options);
        }
export type MyFavoriteBrandsQueryHookResult = ReturnType<typeof useMyFavoriteBrandsQuery>;
export type MyFavoriteBrandsLazyQueryHookResult = ReturnType<typeof useMyFavoriteBrandsLazyQuery>;
export type MyFavoriteBrandsSuspenseQueryHookResult = ReturnType<typeof useMyFavoriteBrandsSuspenseQuery>;
export type MyFavoriteBrandsQueryResult = Apollo.QueryResult<MyFavoriteBrandsQuery, MyFavoriteBrandsQueryVariables>;
export const LikeBrandDocument = gql`
    mutation LikeBrand($brandId: Int!, $action: FollowerActionEnum!) {
  likeBrand(brand_id: $brandId, action: $action) {
    status
    message
  }
}
    `;
export type LikeBrandMutationFn = Apollo.MutationFunction<LikeBrandMutation, LikeBrandMutationVariables>;

/**
 * __useLikeBrandMutation__
 *
 * To run a mutation, you first call `useLikeBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeBrandMutation, { data, loading, error }] = useLikeBrandMutation({
 *   variables: {
 *      brandId: // value for 'brandId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useLikeBrandMutation(baseOptions?: Apollo.MutationHookOptions<LikeBrandMutation, LikeBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeBrandMutation, LikeBrandMutationVariables>(LikeBrandDocument, options);
      }
export type LikeBrandMutationHookResult = ReturnType<typeof useLikeBrandMutation>;
export type LikeBrandMutationResult = Apollo.MutationResult<LikeBrandMutation>;
export type LikeBrandMutationOptions = Apollo.BaseMutationOptions<LikeBrandMutation, LikeBrandMutationVariables>;
export const BrandsDocument = gql`
    query Brands($brandIds: [Int]!, $pageSize: Int, $currentPage: Int) {
  brands(brand_ids: $brandIds, page_size: $pageSize, current_page: $currentPage) {
    total_count
    page_info {
      current_page
      page_size
      total_pages
    }
    items {
      alt
      img
      label
      id
      meta_description
      review_count
      sold_count
      like_count
      title_description
      url
      banner_image
      ...HighlightBrandAchievement
    }
  }
}
    ${HighlightBrandAchievementFragmentDoc}`;

/**
 * __useBrandsQuery__
 *
 * To run a query within a React component, call `useBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsQuery({
 *   variables: {
 *      brandIds: // value for 'brandIds'
 *      pageSize: // value for 'pageSize'
 *      currentPage: // value for 'currentPage'
 *   },
 * });
 */
export function useBrandsQuery(baseOptions: Apollo.QueryHookOptions<BrandsQuery, BrandsQueryVariables> & ({ variables: BrandsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandsQuery, BrandsQueryVariables>(BrandsDocument, options);
      }
export function useBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandsQuery, BrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandsQuery, BrandsQueryVariables>(BrandsDocument, options);
        }
export function useBrandsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandsQuery, BrandsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandsQuery, BrandsQueryVariables>(BrandsDocument, options);
        }
export type BrandsQueryHookResult = ReturnType<typeof useBrandsQuery>;
export type BrandsLazyQueryHookResult = ReturnType<typeof useBrandsLazyQuery>;
export type BrandsSuspenseQueryHookResult = ReturnType<typeof useBrandsSuspenseQuery>;
export type BrandsQueryResult = Apollo.QueryResult<BrandsQuery, BrandsQueryVariables>;
export const ProductDocument = gql`
    query Product($sku: String!) {
  productBySku(sku: $sku) {
    ... on ConfigurableProduct {
      ...ConfigurableProductBasic
      ...ConfigurableProductOptions
      ...ConfigurableProductVariants
      ...ConfigurableProductPrice
      ...ConfigurableProductImage
      ...ConfigurableProductSpecialPrice
      ...ConfigurableProductDescription
      ...ConfigurableProductParameters
      ...ConfigurableProductAchievement
    }
    ... on SimpleProduct {
      ...SimpleProductPrice
      ...SimpleProductBasic
      ...SimpleProductImage
      ...SimpleProductSpecialPrice
      ...SimpleProductDescription
      ...SimpleProductParameters
      ...SimpleProductAchievement
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductVariantsFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductSpecialPriceFragmentDoc}
${ConfigurableProductDescriptionFragmentDoc}
${ConfigurableProductParametersFragmentDoc}
${ConfigurableProductAchievementFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductSpecialPriceFragmentDoc}
${SimpleProductDescriptionFragmentDoc}
${SimpleProductParametersFragmentDoc}
${SimpleProductAchievementFragmentDoc}`;

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useProductQuery(baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables> & ({ variables: ProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export function useProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductSuspenseQueryHookResult = ReturnType<typeof useProductSuspenseQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const ProductMediaGalleryBySkuDocument = gql`
    query ProductMediaGalleryBySku($sku: String!) {
  productBySku(sku: $sku) {
    ... on ConfigurableProduct {
      ...ConfigurableProductBasic
      ...ConfigurableProductMediaGallery
    }
    ... on SimpleProduct {
      ...SimpleProductBasic
      ...SimpleProductMediaGallery
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductMediaGalleryFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductMediaGalleryFragmentDoc}`;

/**
 * __useProductMediaGalleryBySkuQuery__
 *
 * To run a query within a React component, call `useProductMediaGalleryBySkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMediaGalleryBySkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMediaGalleryBySkuQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useProductMediaGalleryBySkuQuery(baseOptions: Apollo.QueryHookOptions<ProductMediaGalleryBySkuQuery, ProductMediaGalleryBySkuQueryVariables> & ({ variables: ProductMediaGalleryBySkuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductMediaGalleryBySkuQuery, ProductMediaGalleryBySkuQueryVariables>(ProductMediaGalleryBySkuDocument, options);
      }
export function useProductMediaGalleryBySkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductMediaGalleryBySkuQuery, ProductMediaGalleryBySkuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductMediaGalleryBySkuQuery, ProductMediaGalleryBySkuQueryVariables>(ProductMediaGalleryBySkuDocument, options);
        }
export function useProductMediaGalleryBySkuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductMediaGalleryBySkuQuery, ProductMediaGalleryBySkuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductMediaGalleryBySkuQuery, ProductMediaGalleryBySkuQueryVariables>(ProductMediaGalleryBySkuDocument, options);
        }
export type ProductMediaGalleryBySkuQueryHookResult = ReturnType<typeof useProductMediaGalleryBySkuQuery>;
export type ProductMediaGalleryBySkuLazyQueryHookResult = ReturnType<typeof useProductMediaGalleryBySkuLazyQuery>;
export type ProductMediaGalleryBySkuSuspenseQueryHookResult = ReturnType<typeof useProductMediaGalleryBySkuSuspenseQuery>;
export type ProductMediaGalleryBySkuQueryResult = Apollo.QueryResult<ProductMediaGalleryBySkuQuery, ProductMediaGalleryBySkuQueryVariables>;
export const ProductPriceTiersBySkuDocument = gql`
    query ProductPriceTiersBySku($sku: String!) {
  productBySku(sku: $sku) {
    ... on ConfigurableProduct {
      ...ConfigurableProductPriceTiers
    }
    ... on SimpleProduct {
      ...SimpleProductPriceTiers
    }
  }
}
    ${ConfigurableProductPriceTiersFragmentDoc}
${SimpleProductPriceTiersFragmentDoc}`;

/**
 * __useProductPriceTiersBySkuQuery__
 *
 * To run a query within a React component, call `useProductPriceTiersBySkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPriceTiersBySkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPriceTiersBySkuQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useProductPriceTiersBySkuQuery(baseOptions: Apollo.QueryHookOptions<ProductPriceTiersBySkuQuery, ProductPriceTiersBySkuQueryVariables> & ({ variables: ProductPriceTiersBySkuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPriceTiersBySkuQuery, ProductPriceTiersBySkuQueryVariables>(ProductPriceTiersBySkuDocument, options);
      }
export function useProductPriceTiersBySkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPriceTiersBySkuQuery, ProductPriceTiersBySkuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPriceTiersBySkuQuery, ProductPriceTiersBySkuQueryVariables>(ProductPriceTiersBySkuDocument, options);
        }
export function useProductPriceTiersBySkuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPriceTiersBySkuQuery, ProductPriceTiersBySkuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPriceTiersBySkuQuery, ProductPriceTiersBySkuQueryVariables>(ProductPriceTiersBySkuDocument, options);
        }
export type ProductPriceTiersBySkuQueryHookResult = ReturnType<typeof useProductPriceTiersBySkuQuery>;
export type ProductPriceTiersBySkuLazyQueryHookResult = ReturnType<typeof useProductPriceTiersBySkuLazyQuery>;
export type ProductPriceTiersBySkuSuspenseQueryHookResult = ReturnType<typeof useProductPriceTiersBySkuSuspenseQuery>;
export type ProductPriceTiersBySkuQueryResult = Apollo.QueryResult<ProductPriceTiersBySkuQuery, ProductPriceTiersBySkuQueryVariables>;
export const ProductPriceTiersByUuidDocument = gql`
    query ProductPriceTiersByUuid($uuid: String!) {
  productByUuid(uuid: $uuid) {
    ... on ConfigurableProduct {
      ...ConfigurableProductPriceTiers
    }
    ... on SimpleProduct {
      ...SimpleProductPriceTiers
    }
  }
}
    ${ConfigurableProductPriceTiersFragmentDoc}
${SimpleProductPriceTiersFragmentDoc}`;

/**
 * __useProductPriceTiersByUuidQuery__
 *
 * To run a query within a React component, call `useProductPriceTiersByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPriceTiersByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPriceTiersByUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useProductPriceTiersByUuidQuery(baseOptions: Apollo.QueryHookOptions<ProductPriceTiersByUuidQuery, ProductPriceTiersByUuidQueryVariables> & ({ variables: ProductPriceTiersByUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPriceTiersByUuidQuery, ProductPriceTiersByUuidQueryVariables>(ProductPriceTiersByUuidDocument, options);
      }
export function useProductPriceTiersByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPriceTiersByUuidQuery, ProductPriceTiersByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPriceTiersByUuidQuery, ProductPriceTiersByUuidQueryVariables>(ProductPriceTiersByUuidDocument, options);
        }
export function useProductPriceTiersByUuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPriceTiersByUuidQuery, ProductPriceTiersByUuidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPriceTiersByUuidQuery, ProductPriceTiersByUuidQueryVariables>(ProductPriceTiersByUuidDocument, options);
        }
export type ProductPriceTiersByUuidQueryHookResult = ReturnType<typeof useProductPriceTiersByUuidQuery>;
export type ProductPriceTiersByUuidLazyQueryHookResult = ReturnType<typeof useProductPriceTiersByUuidLazyQuery>;
export type ProductPriceTiersByUuidSuspenseQueryHookResult = ReturnType<typeof useProductPriceTiersByUuidSuspenseQuery>;
export type ProductPriceTiersByUuidQueryResult = Apollo.QueryResult<ProductPriceTiersByUuidQuery, ProductPriceTiersByUuidQueryVariables>;
export const RelatedProductsOfProductDocument = gql`
    query RelatedProductsOfProduct($sku: String!) {
  productBySku(sku: $sku) {
    id
    related_products_two {
      ... on ConfigurableProduct {
        ...ConfigurableProductBasic
        ...ConfigurableProductOptions
        ...ConfigurableProductVariants
        ...ConfigurableProductPrice
        ...ConfigurableProductImage
        ...ConfigurableProductSpecialPrice
      }
      ... on SimpleProduct {
        ...SimpleProductPrice
        ...SimpleProductBasic
        ...SimpleProductImage
        ...SimpleProductSpecialPrice
      }
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductVariantsFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductSpecialPriceFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductSpecialPriceFragmentDoc}`;

/**
 * __useRelatedProductsOfProductQuery__
 *
 * To run a query within a React component, call `useRelatedProductsOfProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedProductsOfProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedProductsOfProductQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useRelatedProductsOfProductQuery(baseOptions: Apollo.QueryHookOptions<RelatedProductsOfProductQuery, RelatedProductsOfProductQueryVariables> & ({ variables: RelatedProductsOfProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedProductsOfProductQuery, RelatedProductsOfProductQueryVariables>(RelatedProductsOfProductDocument, options);
      }
export function useRelatedProductsOfProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedProductsOfProductQuery, RelatedProductsOfProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedProductsOfProductQuery, RelatedProductsOfProductQueryVariables>(RelatedProductsOfProductDocument, options);
        }
export function useRelatedProductsOfProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedProductsOfProductQuery, RelatedProductsOfProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatedProductsOfProductQuery, RelatedProductsOfProductQueryVariables>(RelatedProductsOfProductDocument, options);
        }
export type RelatedProductsOfProductQueryHookResult = ReturnType<typeof useRelatedProductsOfProductQuery>;
export type RelatedProductsOfProductLazyQueryHookResult = ReturnType<typeof useRelatedProductsOfProductLazyQuery>;
export type RelatedProductsOfProductSuspenseQueryHookResult = ReturnType<typeof useRelatedProductsOfProductSuspenseQuery>;
export type RelatedProductsOfProductQueryResult = Apollo.QueryResult<RelatedProductsOfProductQuery, RelatedProductsOfProductQueryVariables>;
export const ProductListTotalCountDocument = gql`
    query ProductListTotalCount($search: String, $filter: ProductAttributeFilterInput, $pageSize: Int, $currentPage: Int, $sort: ProductAttributeSortInput) {
  products(
    search: $search
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    total_count
  }
}
    `;

/**
 * __useProductListTotalCountQuery__
 *
 * To run a query within a React component, call `useProductListTotalCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListTotalCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListTotalCountQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      currentPage: // value for 'currentPage'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductListTotalCountQuery(baseOptions?: Apollo.QueryHookOptions<ProductListTotalCountQuery, ProductListTotalCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListTotalCountQuery, ProductListTotalCountQueryVariables>(ProductListTotalCountDocument, options);
      }
export function useProductListTotalCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListTotalCountQuery, ProductListTotalCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListTotalCountQuery, ProductListTotalCountQueryVariables>(ProductListTotalCountDocument, options);
        }
export function useProductListTotalCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListTotalCountQuery, ProductListTotalCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListTotalCountQuery, ProductListTotalCountQueryVariables>(ProductListTotalCountDocument, options);
        }
export type ProductListTotalCountQueryHookResult = ReturnType<typeof useProductListTotalCountQuery>;
export type ProductListTotalCountLazyQueryHookResult = ReturnType<typeof useProductListTotalCountLazyQuery>;
export type ProductListTotalCountSuspenseQueryHookResult = ReturnType<typeof useProductListTotalCountSuspenseQuery>;
export type ProductListTotalCountQueryResult = Apollo.QueryResult<ProductListTotalCountQuery, ProductListTotalCountQueryVariables>;
export const ProductListPageInfoDocument = gql`
    query ProductListPageInfo($search: String, $filter: ProductAttributeFilterInput, $pageSize: Int, $currentPage: Int, $sort: ProductAttributeSortInput) {
  products(
    search: $search
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    page_info {
      ...ProductPaginationInfo
    }
  }
}
    ${ProductPaginationInfoFragmentDoc}`;

/**
 * __useProductListPageInfoQuery__
 *
 * To run a query within a React component, call `useProductListPageInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListPageInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListPageInfoQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      currentPage: // value for 'currentPage'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductListPageInfoQuery(baseOptions?: Apollo.QueryHookOptions<ProductListPageInfoQuery, ProductListPageInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListPageInfoQuery, ProductListPageInfoQueryVariables>(ProductListPageInfoDocument, options);
      }
export function useProductListPageInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListPageInfoQuery, ProductListPageInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListPageInfoQuery, ProductListPageInfoQueryVariables>(ProductListPageInfoDocument, options);
        }
export function useProductListPageInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListPageInfoQuery, ProductListPageInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListPageInfoQuery, ProductListPageInfoQueryVariables>(ProductListPageInfoDocument, options);
        }
export type ProductListPageInfoQueryHookResult = ReturnType<typeof useProductListPageInfoQuery>;
export type ProductListPageInfoLazyQueryHookResult = ReturnType<typeof useProductListPageInfoLazyQuery>;
export type ProductListPageInfoSuspenseQueryHookResult = ReturnType<typeof useProductListPageInfoSuspenseQuery>;
export type ProductListPageInfoQueryResult = Apollo.QueryResult<ProductListPageInfoQuery, ProductListPageInfoQueryVariables>;
export const ProductListAggregationsDocument = gql`
    query ProductListAggregations($search: String, $filter: ProductAttributeFilterInput, $pageSize: Int, $currentPage: Int, $sort: ProductAttributeSortInput) {
  products(
    search: $search
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    aggregations {
      attribute_code
      count
      label
      options {
        count
        label
        value
      }
    }
  }
}
    `;

/**
 * __useProductListAggregationsQuery__
 *
 * To run a query within a React component, call `useProductListAggregationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListAggregationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListAggregationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      currentPage: // value for 'currentPage'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductListAggregationsQuery(baseOptions?: Apollo.QueryHookOptions<ProductListAggregationsQuery, ProductListAggregationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListAggregationsQuery, ProductListAggregationsQueryVariables>(ProductListAggregationsDocument, options);
      }
export function useProductListAggregationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListAggregationsQuery, ProductListAggregationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListAggregationsQuery, ProductListAggregationsQueryVariables>(ProductListAggregationsDocument, options);
        }
export function useProductListAggregationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListAggregationsQuery, ProductListAggregationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListAggregationsQuery, ProductListAggregationsQueryVariables>(ProductListAggregationsDocument, options);
        }
export type ProductListAggregationsQueryHookResult = ReturnType<typeof useProductListAggregationsQuery>;
export type ProductListAggregationsLazyQueryHookResult = ReturnType<typeof useProductListAggregationsLazyQuery>;
export type ProductListAggregationsSuspenseQueryHookResult = ReturnType<typeof useProductListAggregationsSuspenseQuery>;
export type ProductListAggregationsQueryResult = Apollo.QueryResult<ProductListAggregationsQuery, ProductListAggregationsQueryVariables>;
export const ProductListSortFieldsDocument = gql`
    query ProductListSortFields($search: String, $filter: ProductAttributeFilterInput, $pageSize: Int, $currentPage: Int, $sort: ProductAttributeSortInput) {
  products(
    search: $search
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    sort_fields {
      default
      options {
        label
        value
      }
    }
  }
}
    `;

/**
 * __useProductListSortFieldsQuery__
 *
 * To run a query within a React component, call `useProductListSortFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListSortFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListSortFieldsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      currentPage: // value for 'currentPage'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductListSortFieldsQuery(baseOptions?: Apollo.QueryHookOptions<ProductListSortFieldsQuery, ProductListSortFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListSortFieldsQuery, ProductListSortFieldsQueryVariables>(ProductListSortFieldsDocument, options);
      }
export function useProductListSortFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListSortFieldsQuery, ProductListSortFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListSortFieldsQuery, ProductListSortFieldsQueryVariables>(ProductListSortFieldsDocument, options);
        }
export function useProductListSortFieldsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListSortFieldsQuery, ProductListSortFieldsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListSortFieldsQuery, ProductListSortFieldsQueryVariables>(ProductListSortFieldsDocument, options);
        }
export type ProductListSortFieldsQueryHookResult = ReturnType<typeof useProductListSortFieldsQuery>;
export type ProductListSortFieldsLazyQueryHookResult = ReturnType<typeof useProductListSortFieldsLazyQuery>;
export type ProductListSortFieldsSuspenseQueryHookResult = ReturnType<typeof useProductListSortFieldsSuspenseQuery>;
export type ProductListSortFieldsQueryResult = Apollo.QueryResult<ProductListSortFieldsQuery, ProductListSortFieldsQueryVariables>;
export const ProductListItemsDocument = gql`
    query ProductListItems($search: String, $filter: ProductAttributeFilterInput, $pageSize: Int, $currentPage: Int, $sort: ProductAttributeSortInput) {
  products(
    search: $search
    filter: $filter
    pageSize: $pageSize
    currentPage: $currentPage
    sort: $sort
  ) {
    page_info {
      ...ProductPaginationInfo
    }
    total_count
    aggregations {
      ...ProductListAggregations
    }
    sort_fields {
      ...ProductListSortFields
    }
    items {
      ... on ConfigurableProduct {
        ...ConfigurableProductBasic
        ...ConfigurableProductPrice
        ...ConfigurableProductImage
        ...ConfigurableProductOptions
        ...ConfigurableProductSpecialPrice
        ...ConfigurableProductBadges
      }
      ... on SimpleProduct {
        ...SimpleProductBasic
        ...SimpleProductPrice
        ...SimpleProductImage
        ...SimpleProductSpecialPrice
        ...SimpleProductBadges
      }
    }
  }
}
    ${ProductPaginationInfoFragmentDoc}
${ProductListAggregationsFragmentDoc}
${ProductListSortFieldsFragmentDoc}
${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductSpecialPriceFragmentDoc}
${ConfigurableProductBadgesFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductSpecialPriceFragmentDoc}
${SimpleProductBadgesFragmentDoc}`;

/**
 * __useProductListItemsQuery__
 *
 * To run a query within a React component, call `useProductListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListItemsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      currentPage: // value for 'currentPage'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useProductListItemsQuery(baseOptions?: Apollo.QueryHookOptions<ProductListItemsQuery, ProductListItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListItemsQuery, ProductListItemsQueryVariables>(ProductListItemsDocument, options);
      }
export function useProductListItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListItemsQuery, ProductListItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListItemsQuery, ProductListItemsQueryVariables>(ProductListItemsDocument, options);
        }
export function useProductListItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListItemsQuery, ProductListItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListItemsQuery, ProductListItemsQueryVariables>(ProductListItemsDocument, options);
        }
export type ProductListItemsQueryHookResult = ReturnType<typeof useProductListItemsQuery>;
export type ProductListItemsLazyQueryHookResult = ReturnType<typeof useProductListItemsLazyQuery>;
export type ProductListItemsSuspenseQueryHookResult = ReturnType<typeof useProductListItemsSuspenseQuery>;
export type ProductListItemsQueryResult = Apollo.QueryResult<ProductListItemsQuery, ProductListItemsQueryVariables>;
export const ProductDetailDocument = gql`
    query ProductDetail($filter: ProductAttributeFilterInput) {
  products(filter: $filter) {
    items {
      ...ProductDescription
      ... on ConfigurableProduct {
        ...ConfigurableProductBasic
        ...ConfigurableProductPrice
        ...ConfigurableProductImage
        ...ConfigurableProductOptions
        ...ConfigurableProductAchievement
      }
      ... on SimpleProduct {
        ...SimpleProductBasic
        ...SimpleProductPrice
        ...SimpleProductImage
        ...SimpleProductAchievement
      }
    }
  }
}
    ${ProductDescriptionFragmentDoc}
${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductAchievementFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductAchievementFragmentDoc}`;

/**
 * __useProductDetailQuery__
 *
 * To run a query within a React component, call `useProductDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDetailQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useProductDetailQuery(baseOptions?: Apollo.QueryHookOptions<ProductDetailQuery, ProductDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDetailQuery, ProductDetailQueryVariables>(ProductDetailDocument, options);
      }
export function useProductDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDetailQuery, ProductDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDetailQuery, ProductDetailQueryVariables>(ProductDetailDocument, options);
        }
export function useProductDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductDetailQuery, ProductDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductDetailQuery, ProductDetailQueryVariables>(ProductDetailDocument, options);
        }
export type ProductDetailQueryHookResult = ReturnType<typeof useProductDetailQuery>;
export type ProductDetailLazyQueryHookResult = ReturnType<typeof useProductDetailLazyQuery>;
export type ProductDetailSuspenseQueryHookResult = ReturnType<typeof useProductDetailSuspenseQuery>;
export type ProductDetailQueryResult = Apollo.QueryResult<ProductDetailQuery, ProductDetailQueryVariables>;
export const InterestedProductsDocument = gql`
    query InterestedProducts {
  interestedProducts {
    items {
      ... on ConfigurableProduct {
        ...ConfigurableProductBasic
        ...ConfigurableProductOptions
        ...ConfigurableProductVariants
        ...ConfigurableProductPrice
        ...ConfigurableProductImage
        ...ConfigurableProductSpecialPrice
        ...ConfigurableProductBadges
      }
      ... on SimpleProduct {
        ...SimpleProductPrice
        ...SimpleProductBasic
        ...SimpleProductImage
        ...SimpleProductSpecialPrice
        ...SimpleProductBadges
      }
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductVariantsFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductSpecialPriceFragmentDoc}
${ConfigurableProductBadgesFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductSpecialPriceFragmentDoc}
${SimpleProductBadgesFragmentDoc}`;

/**
 * __useInterestedProductsQuery__
 *
 * To run a query within a React component, call `useInterestedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterestedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterestedProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterestedProductsQuery(baseOptions?: Apollo.QueryHookOptions<InterestedProductsQuery, InterestedProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterestedProductsQuery, InterestedProductsQueryVariables>(InterestedProductsDocument, options);
      }
export function useInterestedProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterestedProductsQuery, InterestedProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterestedProductsQuery, InterestedProductsQueryVariables>(InterestedProductsDocument, options);
        }
export function useInterestedProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterestedProductsQuery, InterestedProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterestedProductsQuery, InterestedProductsQueryVariables>(InterestedProductsDocument, options);
        }
export type InterestedProductsQueryHookResult = ReturnType<typeof useInterestedProductsQuery>;
export type InterestedProductsLazyQueryHookResult = ReturnType<typeof useInterestedProductsLazyQuery>;
export type InterestedProductsSuspenseQueryHookResult = ReturnType<typeof useInterestedProductsSuspenseQuery>;
export type InterestedProductsQueryResult = Apollo.QueryResult<InterestedProductsQuery, InterestedProductsQueryVariables>;
export const ProductByUrlKeyDocument = gql`
    query ProductByUrlKey($key: String!) {
  products(filter: {url_key: {match: $key}}) {
    items {
      ... on ConfigurableProduct {
        ...ConfigurableProductBasic
        ...ConfigurableProductOptions
        ...ConfigurableProductVariants
        ...ConfigurableProductPrice
        ...ConfigurableProductImage
        ...ConfigurableProductSpecialPrice
        ...ConfigurableProductDescription
        ...ConfigurableProductParameters
        ...ConfigurableProductAchievement
      }
      ... on SimpleProduct {
        ...SimpleProductPrice
        ...SimpleProductBasic
        ...SimpleProductImage
        ...SimpleProductSpecialPrice
        ...SimpleProductDescription
        ...SimpleProductParameters
        ...SimpleProductAchievement
      }
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductVariantsFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductSpecialPriceFragmentDoc}
${ConfigurableProductDescriptionFragmentDoc}
${ConfigurableProductParametersFragmentDoc}
${ConfigurableProductAchievementFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductSpecialPriceFragmentDoc}
${SimpleProductDescriptionFragmentDoc}
${SimpleProductParametersFragmentDoc}
${SimpleProductAchievementFragmentDoc}`;

/**
 * __useProductByUrlKeyQuery__
 *
 * To run a query within a React component, call `useProductByUrlKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByUrlKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByUrlKeyQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useProductByUrlKeyQuery(baseOptions: Apollo.QueryHookOptions<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables> & ({ variables: ProductByUrlKeyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>(ProductByUrlKeyDocument, options);
      }
export function useProductByUrlKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>(ProductByUrlKeyDocument, options);
        }
export function useProductByUrlKeySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>(ProductByUrlKeyDocument, options);
        }
export type ProductByUrlKeyQueryHookResult = ReturnType<typeof useProductByUrlKeyQuery>;
export type ProductByUrlKeyLazyQueryHookResult = ReturnType<typeof useProductByUrlKeyLazyQuery>;
export type ProductByUrlKeySuspenseQueryHookResult = ReturnType<typeof useProductByUrlKeySuspenseQuery>;
export type ProductByUrlKeyQueryResult = Apollo.QueryResult<ProductByUrlKeyQuery, ProductByUrlKeyQueryVariables>;
export const CrossSellProductBySkuDocument = gql`
    query CrossSellProductBySku($sku: String!) {
  products(filter: {sku: {eq: $sku}}, pageSize: 1) {
    items {
      ... on ConfigurableProduct {
        ...ConfigurableProductBasic
      }
      ... on SimpleProduct {
        ...SimpleProductBasic
      }
      crosssell_products {
        ... on SimpleProduct {
          ...SimpleProductPrice
          ...SimpleProductBasic
          ...SimpleProductImage
          ...SimpleProductSpecialPrice
        }
        ... on ConfigurableProduct {
          ...ConfigurableProductBasic
          ...ConfigurableProductOptions
          ...ConfigurableProductVariants
          ...ConfigurableProductPrice
          ...ConfigurableProductImage
          ...ConfigurableProductSpecialPrice
        }
      }
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductSpecialPriceFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductVariantsFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductSpecialPriceFragmentDoc}`;

/**
 * __useCrossSellProductBySkuQuery__
 *
 * To run a query within a React component, call `useCrossSellProductBySkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useCrossSellProductBySkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCrossSellProductBySkuQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useCrossSellProductBySkuQuery(baseOptions: Apollo.QueryHookOptions<CrossSellProductBySkuQuery, CrossSellProductBySkuQueryVariables> & ({ variables: CrossSellProductBySkuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CrossSellProductBySkuQuery, CrossSellProductBySkuQueryVariables>(CrossSellProductBySkuDocument, options);
      }
export function useCrossSellProductBySkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CrossSellProductBySkuQuery, CrossSellProductBySkuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CrossSellProductBySkuQuery, CrossSellProductBySkuQueryVariables>(CrossSellProductBySkuDocument, options);
        }
export function useCrossSellProductBySkuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CrossSellProductBySkuQuery, CrossSellProductBySkuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CrossSellProductBySkuQuery, CrossSellProductBySkuQueryVariables>(CrossSellProductBySkuDocument, options);
        }
export type CrossSellProductBySkuQueryHookResult = ReturnType<typeof useCrossSellProductBySkuQuery>;
export type CrossSellProductBySkuLazyQueryHookResult = ReturnType<typeof useCrossSellProductBySkuLazyQuery>;
export type CrossSellProductBySkuSuspenseQueryHookResult = ReturnType<typeof useCrossSellProductBySkuSuspenseQuery>;
export type CrossSellProductBySkuQueryResult = Apollo.QueryResult<CrossSellProductBySkuQuery, CrossSellProductBySkuQueryVariables>;
export const ProductListBySkusDocument = gql`
    query ProductListBySkus($filter: ProductAttributeFilterInput, $pageSize: Int, $currentPage: Int) {
  products(filter: $filter, pageSize: $pageSize, currentPage: $currentPage) {
    items {
      ... on ConfigurableProduct {
        ...ConfigurableProductBasic
        ...ConfigurableProductOptions
        ...ConfigurableProductVariants
        ...ConfigurableProductPrice
        ...ConfigurableProductImage
        ...ConfigurableProductSpecialPrice
      }
      ... on SimpleProduct {
        ...SimpleProductPrice
        ...SimpleProductBasic
        ...SimpleProductImage
        ...SimpleProductSpecialPrice
      }
    }
    page_info {
      current_page
      page_size
      total_pages
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductVariantsFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductSpecialPriceFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductSpecialPriceFragmentDoc}`;

/**
 * __useProductListBySkusQuery__
 *
 * To run a query within a React component, call `useProductListBySkusQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductListBySkusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductListBySkusQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pageSize: // value for 'pageSize'
 *      currentPage: // value for 'currentPage'
 *   },
 * });
 */
export function useProductListBySkusQuery(baseOptions?: Apollo.QueryHookOptions<ProductListBySkusQuery, ProductListBySkusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductListBySkusQuery, ProductListBySkusQueryVariables>(ProductListBySkusDocument, options);
      }
export function useProductListBySkusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductListBySkusQuery, ProductListBySkusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductListBySkusQuery, ProductListBySkusQueryVariables>(ProductListBySkusDocument, options);
        }
export function useProductListBySkusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductListBySkusQuery, ProductListBySkusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductListBySkusQuery, ProductListBySkusQueryVariables>(ProductListBySkusDocument, options);
        }
export type ProductListBySkusQueryHookResult = ReturnType<typeof useProductListBySkusQuery>;
export type ProductListBySkusLazyQueryHookResult = ReturnType<typeof useProductListBySkusLazyQuery>;
export type ProductListBySkusSuspenseQueryHookResult = ReturnType<typeof useProductListBySkusSuspenseQuery>;
export type ProductListBySkusQueryResult = Apollo.QueryResult<ProductListBySkusQuery, ProductListBySkusQueryVariables>;
export const ProductByUuidDocument = gql`
    query ProductByUuid($uuid: String!) {
  productByUuid(uuid: $uuid) {
    ... on ConfigurableProduct {
      ...ConfigurableProductBasic
      ...ConfigurableProductOptions
      ...ConfigurableProductVariants
      ...ConfigurableProductPrice
      ...ConfigurableProductImage
      ...ConfigurableProductSpecialPrice
      ...ConfigurableProductDescription
      ...ConfigurableProductParameters
      ...ConfigurableProductAchievement
    }
    ... on SimpleProduct {
      ...SimpleProductPrice
      ...SimpleProductBasic
      ...SimpleProductImage
      ...SimpleProductSpecialPrice
      ...SimpleProductDescription
      ...SimpleProductParameters
      ...SimpleProductAchievement
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductVariantsFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductSpecialPriceFragmentDoc}
${ConfigurableProductDescriptionFragmentDoc}
${ConfigurableProductParametersFragmentDoc}
${ConfigurableProductAchievementFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductSpecialPriceFragmentDoc}
${SimpleProductDescriptionFragmentDoc}
${SimpleProductParametersFragmentDoc}
${SimpleProductAchievementFragmentDoc}`;

/**
 * __useProductByUuidQuery__
 *
 * To run a query within a React component, call `useProductByUuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByUuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByUuidQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useProductByUuidQuery(baseOptions: Apollo.QueryHookOptions<ProductByUuidQuery, ProductByUuidQueryVariables> & ({ variables: ProductByUuidQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductByUuidQuery, ProductByUuidQueryVariables>(ProductByUuidDocument, options);
      }
export function useProductByUuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductByUuidQuery, ProductByUuidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductByUuidQuery, ProductByUuidQueryVariables>(ProductByUuidDocument, options);
        }
export function useProductByUuidSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductByUuidQuery, ProductByUuidQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductByUuidQuery, ProductByUuidQueryVariables>(ProductByUuidDocument, options);
        }
export type ProductByUuidQueryHookResult = ReturnType<typeof useProductByUuidQuery>;
export type ProductByUuidLazyQueryHookResult = ReturnType<typeof useProductByUuidLazyQuery>;
export type ProductByUuidSuspenseQueryHookResult = ReturnType<typeof useProductByUuidSuspenseQuery>;
export type ProductByUuidQueryResult = Apollo.QueryResult<ProductByUuidQuery, ProductByUuidQueryVariables>;
export const AdditionalDataAttributeProductDocument = gql`
    query AdditionalDataAttributeProduct($sku: String!) {
  productBySku(sku: $sku) {
    ... on ConfigurableProduct {
      ...ConfigurableProductBasic
      additional_data_attributes {
        value
        label
        code
      }
    }
    ... on SimpleProduct {
      ...SimpleProductBasic
      additional_data_attributes {
        value
        label
        code
      }
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${SimpleProductBasicFragmentDoc}`;

/**
 * __useAdditionalDataAttributeProductQuery__
 *
 * To run a query within a React component, call `useAdditionalDataAttributeProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdditionalDataAttributeProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdditionalDataAttributeProductQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useAdditionalDataAttributeProductQuery(baseOptions: Apollo.QueryHookOptions<AdditionalDataAttributeProductQuery, AdditionalDataAttributeProductQueryVariables> & ({ variables: AdditionalDataAttributeProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdditionalDataAttributeProductQuery, AdditionalDataAttributeProductQueryVariables>(AdditionalDataAttributeProductDocument, options);
      }
export function useAdditionalDataAttributeProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdditionalDataAttributeProductQuery, AdditionalDataAttributeProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdditionalDataAttributeProductQuery, AdditionalDataAttributeProductQueryVariables>(AdditionalDataAttributeProductDocument, options);
        }
export function useAdditionalDataAttributeProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdditionalDataAttributeProductQuery, AdditionalDataAttributeProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdditionalDataAttributeProductQuery, AdditionalDataAttributeProductQueryVariables>(AdditionalDataAttributeProductDocument, options);
        }
export type AdditionalDataAttributeProductQueryHookResult = ReturnType<typeof useAdditionalDataAttributeProductQuery>;
export type AdditionalDataAttributeProductLazyQueryHookResult = ReturnType<typeof useAdditionalDataAttributeProductLazyQuery>;
export type AdditionalDataAttributeProductSuspenseQueryHookResult = ReturnType<typeof useAdditionalDataAttributeProductSuspenseQuery>;
export type AdditionalDataAttributeProductQueryResult = Apollo.QueryResult<AdditionalDataAttributeProductQuery, AdditionalDataAttributeProductQueryVariables>;
export const NotificationsProductBySkuDocument = gql`
    query NotificationsProductBySku($sku: String!) {
  products(filter: {sku: {eq: $sku}}, pageSize: 1) {
    items {
      ... on ConfigurableProduct {
        ...ConfigurableProductBasic
        notifications {
          content
          notification_id
          notification_type
          status
          title
        }
      }
      ... on SimpleProduct {
        ...SimpleProductBasic
        notifications {
          content
          notification_id
          notification_type
          status
          title
        }
      }
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${SimpleProductBasicFragmentDoc}`;

/**
 * __useNotificationsProductBySkuQuery__
 *
 * To run a query within a React component, call `useNotificationsProductBySkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsProductBySkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsProductBySkuQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useNotificationsProductBySkuQuery(baseOptions: Apollo.QueryHookOptions<NotificationsProductBySkuQuery, NotificationsProductBySkuQueryVariables> & ({ variables: NotificationsProductBySkuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsProductBySkuQuery, NotificationsProductBySkuQueryVariables>(NotificationsProductBySkuDocument, options);
      }
export function useNotificationsProductBySkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsProductBySkuQuery, NotificationsProductBySkuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsProductBySkuQuery, NotificationsProductBySkuQueryVariables>(NotificationsProductBySkuDocument, options);
        }
export function useNotificationsProductBySkuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NotificationsProductBySkuQuery, NotificationsProductBySkuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NotificationsProductBySkuQuery, NotificationsProductBySkuQueryVariables>(NotificationsProductBySkuDocument, options);
        }
export type NotificationsProductBySkuQueryHookResult = ReturnType<typeof useNotificationsProductBySkuQuery>;
export type NotificationsProductBySkuLazyQueryHookResult = ReturnType<typeof useNotificationsProductBySkuLazyQuery>;
export type NotificationsProductBySkuSuspenseQueryHookResult = ReturnType<typeof useNotificationsProductBySkuSuspenseQuery>;
export type NotificationsProductBySkuQueryResult = Apollo.QueryResult<NotificationsProductBySkuQuery, NotificationsProductBySkuQueryVariables>;
export const HighlightCategoriesDocument = gql`
    query HighlightCategories {
  highlightCategories {
    items {
      background_app_icon
      featured_app_icon
      featured_icon
      featured_icon_solid
      name
      priority
      url
      id
    }
  }
}
    `;

/**
 * __useHighlightCategoriesQuery__
 *
 * To run a query within a React component, call `useHighlightCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighlightCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighlightCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useHighlightCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>(HighlightCategoriesDocument, options);
      }
export function useHighlightCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>(HighlightCategoriesDocument, options);
        }
export function useHighlightCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>(HighlightCategoriesDocument, options);
        }
export type HighlightCategoriesQueryHookResult = ReturnType<typeof useHighlightCategoriesQuery>;
export type HighlightCategoriesLazyQueryHookResult = ReturnType<typeof useHighlightCategoriesLazyQuery>;
export type HighlightCategoriesSuspenseQueryHookResult = ReturnType<typeof useHighlightCategoriesSuspenseQuery>;
export type HighlightCategoriesQueryResult = Apollo.QueryResult<HighlightCategoriesQuery, HighlightCategoriesQueryVariables>;
export const ProductBySkuDocument = gql`
    query ProductBySku($sku: String!) {
  productBySku(sku: $sku) {
    media_gallery {
      ... on ProductImage {
        disabled
        label
        position
        url
      }
      ... on ProductVideo {
        disabled
        label
        position
        url
        video_content {
          media_type
          video_description
          video_metadata
          video_provider
          video_title
          video_url
        }
      }
    }
    id
    sku
  }
}
    `;

/**
 * __useProductBySkuQuery__
 *
 * To run a query within a React component, call `useProductBySkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBySkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBySkuQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useProductBySkuQuery(baseOptions: Apollo.QueryHookOptions<ProductBySkuQuery, ProductBySkuQueryVariables> & ({ variables: ProductBySkuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductBySkuQuery, ProductBySkuQueryVariables>(ProductBySkuDocument, options);
      }
export function useProductBySkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductBySkuQuery, ProductBySkuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductBySkuQuery, ProductBySkuQueryVariables>(ProductBySkuDocument, options);
        }
export function useProductBySkuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductBySkuQuery, ProductBySkuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductBySkuQuery, ProductBySkuQueryVariables>(ProductBySkuDocument, options);
        }
export type ProductBySkuQueryHookResult = ReturnType<typeof useProductBySkuQuery>;
export type ProductBySkuLazyQueryHookResult = ReturnType<typeof useProductBySkuLazyQuery>;
export type ProductBySkuSuspenseQueryHookResult = ReturnType<typeof useProductBySkuSuspenseQuery>;
export type ProductBySkuQueryResult = Apollo.QueryResult<ProductBySkuQuery, ProductBySkuQueryVariables>;
export const HighlightProductBlocksDocument = gql`
    query HighlightProductBlocks($blockTypes: [BlockTypeEnum], $pageSize: Int, $currentPage: Int) {
  highlightProductBlocks(block_types: $blockTypes) {
    items {
      name
      block_type
      limit_products_for_app
      app_layout_type {
        label
        value
      }
      products(pageSize: $pageSize, currentPage: $currentPage) {
        items {
          ... on ConfigurableProduct {
            ...ConfigurableProductBasic
            ...ConfigurableProductOptions
            ...ConfigurableProductPrice
            ...ConfigurableProductImage
            ...ConfigurableProductSpecialPrice
            ...ConfigurableProductBadges
          }
          ... on SimpleProduct {
            ...SimpleProductPrice
            ...SimpleProductBasic
            ...SimpleProductImage
            ...SimpleProductSpecialPrice
            ...SimpleProductBadges
          }
        }
        page_info {
          current_page
          page_size
          total_pages
        }
        total_count
      }
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductSpecialPriceFragmentDoc}
${ConfigurableProductBadgesFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductSpecialPriceFragmentDoc}
${SimpleProductBadgesFragmentDoc}`;

/**
 * __useHighlightProductBlocksQuery__
 *
 * To run a query within a React component, call `useHighlightProductBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useHighlightProductBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighlightProductBlocksQuery({
 *   variables: {
 *      blockTypes: // value for 'blockTypes'
 *      pageSize: // value for 'pageSize'
 *      currentPage: // value for 'currentPage'
 *   },
 * });
 */
export function useHighlightProductBlocksQuery(baseOptions?: Apollo.QueryHookOptions<HighlightProductBlocksQuery, HighlightProductBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HighlightProductBlocksQuery, HighlightProductBlocksQueryVariables>(HighlightProductBlocksDocument, options);
      }
export function useHighlightProductBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HighlightProductBlocksQuery, HighlightProductBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HighlightProductBlocksQuery, HighlightProductBlocksQueryVariables>(HighlightProductBlocksDocument, options);
        }
export function useHighlightProductBlocksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HighlightProductBlocksQuery, HighlightProductBlocksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HighlightProductBlocksQuery, HighlightProductBlocksQueryVariables>(HighlightProductBlocksDocument, options);
        }
export type HighlightProductBlocksQueryHookResult = ReturnType<typeof useHighlightProductBlocksQuery>;
export type HighlightProductBlocksLazyQueryHookResult = ReturnType<typeof useHighlightProductBlocksLazyQuery>;
export type HighlightProductBlocksSuspenseQueryHookResult = ReturnType<typeof useHighlightProductBlocksSuspenseQuery>;
export type HighlightProductBlocksQueryResult = Apollo.QueryResult<HighlightProductBlocksQuery, HighlightProductBlocksQueryVariables>;
export const CategoryHighlightProductsDocument = gql`
    query CategoryHighlightProducts($categoryId: Int) {
  categoryHighlightProducts(category_id: $categoryId) {
    items {
      ... on ConfigurableProduct {
        ...ConfigurableProductBasic
        ...ConfigurableProductPrice
        ...ConfigurableProductImage
        ...ConfigurableProductOptions
        ...ConfigurableProductSpecialPrice
      }
      ... on SimpleProduct {
        ...SimpleProductBasic
        ...SimpleProductPrice
        ...SimpleProductImage
        ...SimpleProductSpecialPrice
      }
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductSpecialPriceFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductSpecialPriceFragmentDoc}`;

/**
 * __useCategoryHighlightProductsQuery__
 *
 * To run a query within a React component, call `useCategoryHighlightProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryHighlightProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryHighlightProductsQuery({
 *   variables: {
 *      categoryId: // value for 'categoryId'
 *   },
 * });
 */
export function useCategoryHighlightProductsQuery(baseOptions?: Apollo.QueryHookOptions<CategoryHighlightProductsQuery, CategoryHighlightProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CategoryHighlightProductsQuery, CategoryHighlightProductsQueryVariables>(CategoryHighlightProductsDocument, options);
      }
export function useCategoryHighlightProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CategoryHighlightProductsQuery, CategoryHighlightProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CategoryHighlightProductsQuery, CategoryHighlightProductsQueryVariables>(CategoryHighlightProductsDocument, options);
        }
export function useCategoryHighlightProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CategoryHighlightProductsQuery, CategoryHighlightProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CategoryHighlightProductsQuery, CategoryHighlightProductsQueryVariables>(CategoryHighlightProductsDocument, options);
        }
export type CategoryHighlightProductsQueryHookResult = ReturnType<typeof useCategoryHighlightProductsQuery>;
export type CategoryHighlightProductsLazyQueryHookResult = ReturnType<typeof useCategoryHighlightProductsLazyQuery>;
export type CategoryHighlightProductsSuspenseQueryHookResult = ReturnType<typeof useCategoryHighlightProductsSuspenseQuery>;
export type CategoryHighlightProductsQueryResult = Apollo.QueryResult<CategoryHighlightProductsQuery, CategoryHighlightProductsQueryVariables>;
export const UserGuideProductBySkuDocument = gql`
    query UserGuideProductBySku($sku: String!) {
  productBySku(sku: $sku) {
    user_guide
    id
    sku
  }
}
    `;

/**
 * __useUserGuideProductBySkuQuery__
 *
 * To run a query within a React component, call `useUserGuideProductBySkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserGuideProductBySkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserGuideProductBySkuQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useUserGuideProductBySkuQuery(baseOptions: Apollo.QueryHookOptions<UserGuideProductBySkuQuery, UserGuideProductBySkuQueryVariables> & ({ variables: UserGuideProductBySkuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserGuideProductBySkuQuery, UserGuideProductBySkuQueryVariables>(UserGuideProductBySkuDocument, options);
      }
export function useUserGuideProductBySkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserGuideProductBySkuQuery, UserGuideProductBySkuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserGuideProductBySkuQuery, UserGuideProductBySkuQueryVariables>(UserGuideProductBySkuDocument, options);
        }
export function useUserGuideProductBySkuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserGuideProductBySkuQuery, UserGuideProductBySkuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserGuideProductBySkuQuery, UserGuideProductBySkuQueryVariables>(UserGuideProductBySkuDocument, options);
        }
export type UserGuideProductBySkuQueryHookResult = ReturnType<typeof useUserGuideProductBySkuQuery>;
export type UserGuideProductBySkuLazyQueryHookResult = ReturnType<typeof useUserGuideProductBySkuLazyQuery>;
export type UserGuideProductBySkuSuspenseQueryHookResult = ReturnType<typeof useUserGuideProductBySkuSuspenseQuery>;
export type UserGuideProductBySkuQueryResult = Apollo.QueryResult<UserGuideProductBySkuQuery, UserGuideProductBySkuQueryVariables>;
export const ProductBadgesBySkuDocument = gql`
    query ProductBadgesBySku($sku: String!) {
  productBySku(sku: $sku) {
    id
    sku
    product_badges {
      description
      end_date
      id
      image
      is_active
      name
      position
      start_date
    }
  }
}
    `;

/**
 * __useProductBadgesBySkuQuery__
 *
 * To run a query within a React component, call `useProductBadgesBySkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductBadgesBySkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductBadgesBySkuQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useProductBadgesBySkuQuery(baseOptions: Apollo.QueryHookOptions<ProductBadgesBySkuQuery, ProductBadgesBySkuQueryVariables> & ({ variables: ProductBadgesBySkuQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductBadgesBySkuQuery, ProductBadgesBySkuQueryVariables>(ProductBadgesBySkuDocument, options);
      }
export function useProductBadgesBySkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductBadgesBySkuQuery, ProductBadgesBySkuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductBadgesBySkuQuery, ProductBadgesBySkuQueryVariables>(ProductBadgesBySkuDocument, options);
        }
export function useProductBadgesBySkuSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductBadgesBySkuQuery, ProductBadgesBySkuQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductBadgesBySkuQuery, ProductBadgesBySkuQueryVariables>(ProductBadgesBySkuDocument, options);
        }
export type ProductBadgesBySkuQueryHookResult = ReturnType<typeof useProductBadgesBySkuQuery>;
export type ProductBadgesBySkuLazyQueryHookResult = ReturnType<typeof useProductBadgesBySkuLazyQuery>;
export type ProductBadgesBySkuSuspenseQueryHookResult = ReturnType<typeof useProductBadgesBySkuSuspenseQuery>;
export type ProductBadgesBySkuQueryResult = Apollo.QueryResult<ProductBadgesBySkuQuery, ProductBadgesBySkuQueryVariables>;
export const BrandHighlightProductsDocument = gql`
    query BrandHighlightProducts($brandIds: [Int]!, $pageSize: Int, $currentPage: Int, $highlightProductsPageSize: Int, $highlightProductsCurrentPage: Int) {
  brands(brand_ids: $brandIds, page_size: $pageSize, current_page: $currentPage) {
    items {
      id
      highlight_products(
        page_size: $highlightProductsPageSize
        current_page: $highlightProductsCurrentPage
      ) {
        page_info {
          current_page
          page_size
          total_pages
        }
        total_count
        items {
          ... on ConfigurableProduct {
            ...ConfigurableProductBasic
            ...ConfigurableProductOptions
            ...ConfigurableProductPrice
            ...ConfigurableProductImage
            ...ConfigurableProductSpecialPrice
            __typename
          }
          ... on SimpleProduct {
            ...SimpleProductPrice
            ...SimpleProductBasic
            ...SimpleProductImage
            ...SimpleProductSpecialPrice
            __typename
          }
          __typename
        }
      }
    }
  }
}
    ${ConfigurableProductBasicFragmentDoc}
${ConfigurableProductOptionsFragmentDoc}
${ConfigurableProductPriceFragmentDoc}
${ConfigurableProductImageFragmentDoc}
${ConfigurableProductSpecialPriceFragmentDoc}
${SimpleProductPriceFragmentDoc}
${SimpleProductBasicFragmentDoc}
${SimpleProductImageFragmentDoc}
${SimpleProductSpecialPriceFragmentDoc}`;

/**
 * __useBrandHighlightProductsQuery__
 *
 * To run a query within a React component, call `useBrandHighlightProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandHighlightProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandHighlightProductsQuery({
 *   variables: {
 *      brandIds: // value for 'brandIds'
 *      pageSize: // value for 'pageSize'
 *      currentPage: // value for 'currentPage'
 *      highlightProductsPageSize: // value for 'highlightProductsPageSize'
 *      highlightProductsCurrentPage: // value for 'highlightProductsCurrentPage'
 *   },
 * });
 */
export function useBrandHighlightProductsQuery(baseOptions: Apollo.QueryHookOptions<BrandHighlightProductsQuery, BrandHighlightProductsQueryVariables> & ({ variables: BrandHighlightProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BrandHighlightProductsQuery, BrandHighlightProductsQueryVariables>(BrandHighlightProductsDocument, options);
      }
export function useBrandHighlightProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BrandHighlightProductsQuery, BrandHighlightProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BrandHighlightProductsQuery, BrandHighlightProductsQueryVariables>(BrandHighlightProductsDocument, options);
        }
export function useBrandHighlightProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BrandHighlightProductsQuery, BrandHighlightProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BrandHighlightProductsQuery, BrandHighlightProductsQueryVariables>(BrandHighlightProductsDocument, options);
        }
export type BrandHighlightProductsQueryHookResult = ReturnType<typeof useBrandHighlightProductsQuery>;
export type BrandHighlightProductsLazyQueryHookResult = ReturnType<typeof useBrandHighlightProductsLazyQuery>;
export type BrandHighlightProductsSuspenseQueryHookResult = ReturnType<typeof useBrandHighlightProductsSuspenseQuery>;
export type BrandHighlightProductsQueryResult = Apollo.QueryResult<BrandHighlightProductsQuery, BrandHighlightProductsQueryVariables>;
export const ProductFlashSaleDataDocument = gql`
    query ProductFlashSaleData($productId: Int, $sku: String) {
  flashSaleProduct(product_id: $productId, sku: $sku) {
    sales_data {
      deal_qty
      flashsale_id
      sale_qty
    }
  }
}
    `;

/**
 * __useProductFlashSaleDataQuery__
 *
 * To run a query within a React component, call `useProductFlashSaleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductFlashSaleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductFlashSaleDataQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useProductFlashSaleDataQuery(baseOptions?: Apollo.QueryHookOptions<ProductFlashSaleDataQuery, ProductFlashSaleDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductFlashSaleDataQuery, ProductFlashSaleDataQueryVariables>(ProductFlashSaleDataDocument, options);
      }
export function useProductFlashSaleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductFlashSaleDataQuery, ProductFlashSaleDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductFlashSaleDataQuery, ProductFlashSaleDataQueryVariables>(ProductFlashSaleDataDocument, options);
        }
export function useProductFlashSaleDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductFlashSaleDataQuery, ProductFlashSaleDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductFlashSaleDataQuery, ProductFlashSaleDataQueryVariables>(ProductFlashSaleDataDocument, options);
        }
export type ProductFlashSaleDataQueryHookResult = ReturnType<typeof useProductFlashSaleDataQuery>;
export type ProductFlashSaleDataLazyQueryHookResult = ReturnType<typeof useProductFlashSaleDataLazyQuery>;
export type ProductFlashSaleDataSuspenseQueryHookResult = ReturnType<typeof useProductFlashSaleDataSuspenseQuery>;
export type ProductFlashSaleDataQueryResult = Apollo.QueryResult<ProductFlashSaleDataQuery, ProductFlashSaleDataQueryVariables>;
export const ProductSoldQuantityDocument = gql`
    query ProductSoldQuantity($sku: String!) {
  productBySku(sku: $sku) {
    ... on ConfigurableProduct {
      id
      sku
      sold_quantity
      __typename
    }
    ... on SimpleProduct {
      id
      sku
      sold_quantity
      __typename
    }
    __typename
  }
}
    `;

/**
 * __useProductSoldQuantityQuery__
 *
 * To run a query within a React component, call `useProductSoldQuantityQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSoldQuantityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSoldQuantityQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useProductSoldQuantityQuery(baseOptions: Apollo.QueryHookOptions<ProductSoldQuantityQuery, ProductSoldQuantityQueryVariables> & ({ variables: ProductSoldQuantityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSoldQuantityQuery, ProductSoldQuantityQueryVariables>(ProductSoldQuantityDocument, options);
      }
export function useProductSoldQuantityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSoldQuantityQuery, ProductSoldQuantityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSoldQuantityQuery, ProductSoldQuantityQueryVariables>(ProductSoldQuantityDocument, options);
        }
export function useProductSoldQuantitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductSoldQuantityQuery, ProductSoldQuantityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductSoldQuantityQuery, ProductSoldQuantityQueryVariables>(ProductSoldQuantityDocument, options);
        }
export type ProductSoldQuantityQueryHookResult = ReturnType<typeof useProductSoldQuantityQuery>;
export type ProductSoldQuantityLazyQueryHookResult = ReturnType<typeof useProductSoldQuantityLazyQuery>;
export type ProductSoldQuantitySuspenseQueryHookResult = ReturnType<typeof useProductSoldQuantitySuspenseQuery>;
export type ProductSoldQuantityQueryResult = Apollo.QueryResult<ProductSoldQuantityQuery, ProductSoldQuantityQueryVariables>;
export const ProductSalableQuantityDocument = gql`
    query ProductSalableQuantity($sku: String!, $requestQty: Int!) {
  productSalableQuantity(sku: $sku, request_qty: $requestQty) {
    is_salable
  }
}
    `;

/**
 * __useProductSalableQuantityQuery__
 *
 * To run a query within a React component, call `useProductSalableQuantityQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSalableQuantityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSalableQuantityQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *      requestQty: // value for 'requestQty'
 *   },
 * });
 */
export function useProductSalableQuantityQuery(baseOptions: Apollo.QueryHookOptions<ProductSalableQuantityQuery, ProductSalableQuantityQueryVariables> & ({ variables: ProductSalableQuantityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductSalableQuantityQuery, ProductSalableQuantityQueryVariables>(ProductSalableQuantityDocument, options);
      }
export function useProductSalableQuantityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductSalableQuantityQuery, ProductSalableQuantityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductSalableQuantityQuery, ProductSalableQuantityQueryVariables>(ProductSalableQuantityDocument, options);
        }
export function useProductSalableQuantitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductSalableQuantityQuery, ProductSalableQuantityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductSalableQuantityQuery, ProductSalableQuantityQueryVariables>(ProductSalableQuantityDocument, options);
        }
export type ProductSalableQuantityQueryHookResult = ReturnType<typeof useProductSalableQuantityQuery>;
export type ProductSalableQuantityLazyQueryHookResult = ReturnType<typeof useProductSalableQuantityLazyQuery>;
export type ProductSalableQuantitySuspenseQueryHookResult = ReturnType<typeof useProductSalableQuantitySuspenseQuery>;
export type ProductSalableQuantityQueryResult = Apollo.QueryResult<ProductSalableQuantityQuery, ProductSalableQuantityQueryVariables>;
export const ProductsSalableQuantityDocument = gql`
    query ProductsSalableQuantity($items: [ProductSalableQuantityInput!]) {
  productsSalableQuantity(items: $items) {
    is_salable
    errors {
      code
      message
    }
    available_quantity
    sku
  }
}
    `;

/**
 * __useProductsSalableQuantityQuery__
 *
 * To run a query within a React component, call `useProductsSalableQuantityQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsSalableQuantityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsSalableQuantityQuery({
 *   variables: {
 *      items: // value for 'items'
 *   },
 * });
 */
export function useProductsSalableQuantityQuery(baseOptions?: Apollo.QueryHookOptions<ProductsSalableQuantityQuery, ProductsSalableQuantityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductsSalableQuantityQuery, ProductsSalableQuantityQueryVariables>(ProductsSalableQuantityDocument, options);
      }
export function useProductsSalableQuantityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductsSalableQuantityQuery, ProductsSalableQuantityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductsSalableQuantityQuery, ProductsSalableQuantityQueryVariables>(ProductsSalableQuantityDocument, options);
        }
export function useProductsSalableQuantitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductsSalableQuantityQuery, ProductsSalableQuantityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductsSalableQuantityQuery, ProductsSalableQuantityQueryVariables>(ProductsSalableQuantityDocument, options);
        }
export type ProductsSalableQuantityQueryHookResult = ReturnType<typeof useProductsSalableQuantityQuery>;
export type ProductsSalableQuantityLazyQueryHookResult = ReturnType<typeof useProductsSalableQuantityLazyQuery>;
export type ProductsSalableQuantitySuspenseQueryHookResult = ReturnType<typeof useProductsSalableQuantitySuspenseQuery>;
export type ProductsSalableQuantityQueryResult = Apollo.QueryResult<ProductsSalableQuantityQuery, ProductsSalableQuantityQueryVariables>;
export const ProductCategoriesDocument = gql`
    query ProductCategories($sku: String!) {
  productBySku(sku: $sku) {
    ... on ConfigurableProduct {
      categories {
        id
        name
        url_key
        url_suffix
      }
    }
    ... on SimpleProduct {
      categories {
        id
        name
        url_key
        url_suffix
      }
    }
  }
}
    `;

/**
 * __useProductCategoriesQuery__
 *
 * To run a query within a React component, call `useProductCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductCategoriesQuery({
 *   variables: {
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useProductCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables> & ({ variables: ProductCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, options);
      }
export function useProductCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, options);
        }
export function useProductCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductCategoriesQuery, ProductCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductCategoriesQuery, ProductCategoriesQueryVariables>(ProductCategoriesDocument, options);
        }
export type ProductCategoriesQueryHookResult = ReturnType<typeof useProductCategoriesQuery>;
export type ProductCategoriesLazyQueryHookResult = ReturnType<typeof useProductCategoriesLazyQuery>;
export type ProductCategoriesSuspenseQueryHookResult = ReturnType<typeof useProductCategoriesSuspenseQuery>;
export type ProductCategoriesQueryResult = Apollo.QueryResult<ProductCategoriesQuery, ProductCategoriesQueryVariables>;
export const SliderBannersDocument = gql`
    query SliderBanners($location: String) {
  sliderBanners(location: $location) {
    items {
      app_image_url
      background_color
      banner_id
      image_app
      name
      position
      url_banner
    }
    layout {
      label
      value
    }
  }
}
    `;

/**
 * __useSliderBannersQuery__
 *
 * To run a query within a React component, call `useSliderBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSliderBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSliderBannersQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useSliderBannersQuery(baseOptions?: Apollo.QueryHookOptions<SliderBannersQuery, SliderBannersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SliderBannersQuery, SliderBannersQueryVariables>(SliderBannersDocument, options);
      }
export function useSliderBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SliderBannersQuery, SliderBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SliderBannersQuery, SliderBannersQueryVariables>(SliderBannersDocument, options);
        }
export function useSliderBannersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SliderBannersQuery, SliderBannersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SliderBannersQuery, SliderBannersQueryVariables>(SliderBannersDocument, options);
        }
export type SliderBannersQueryHookResult = ReturnType<typeof useSliderBannersQuery>;
export type SliderBannersLazyQueryHookResult = ReturnType<typeof useSliderBannersLazyQuery>;
export type SliderBannersSuspenseQueryHookResult = ReturnType<typeof useSliderBannersSuspenseQuery>;
export type SliderBannersQueryResult = Apollo.QueryResult<SliderBannersQuery, SliderBannersQueryVariables>;